(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.O.aP === region.M.aP)
	{
		return 'on line ' + region.O.aP;
	}
	return 'on lines ' + region.O.aP + ' through ' + region.M.aP;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cT,
		impl.ds,
		impl.di,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_enqueueEffects(managers, result.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		aw: func(record.aw),
		bw: record.bw,
		bq: record.bq
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.aw;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.bw;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.bq) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cT,
		impl.ds,
		impl.di,
		function(sendToApp, initialModel) {
			var view = impl.dt;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cT,
		impl.ds,
		impl.di,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.bv && impl.bv(sendToApp)
			var view = impl.dt;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.ac);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.I) && (_VirtualDom_doc.title = title = doc.I);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.c1;
	var onUrlRequest = impl.c2;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		bv: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.b5 === next.b5
							&& curr.bP === next.bP
							&& curr.b2.a === next.b2.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		cT: function(flags)
		{
			return A3(impl.cT, flags, _Browser_getUrl(), key);
		},
		dt: impl.dt,
		ds: impl.ds,
		di: impl.di
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { cO: 'hidden', cz: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { cO: 'mozHidden', cz: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { cO: 'msHidden', cz: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { cO: 'webkitHidden', cz: 'webkitvisibilitychange' }
		: { cO: 'hidden', cz: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		ce: _Browser_getScene(),
		cq: {
			cs: _Browser_window.pageXOffset,
			ct: _Browser_window.pageYOffset,
			cr: _Browser_doc.documentElement.clientWidth,
			bN: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		cr: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bN: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			ce: {
				cr: node.scrollWidth,
				bN: node.scrollHeight
			},
			cq: {
				cs: node.scrollLeft,
				ct: node.scrollTop,
				cr: node.clientWidth,
				bN: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			ce: _Browser_getScene(),
			cq: {
				cs: x,
				ct: y,
				cr: _Browser_doc.documentElement.clientWidth,
				bN: _Browser_doc.documentElement.clientHeight
			},
			cG: {
				cs: x + rect.left,
				ct: y + rect.top,
				cr: rect.width,
				bN: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cI.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cI.b, xhr)); });
		$elm$core$Maybe$isJust(request.cm) && _Http_track(router, xhr, request.cm.a);

		try {
			xhr.open(request.cZ, request.J, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.J));
		}

		_Http_configureRequest(xhr, request);

		request.ac.a && xhr.setRequestHeader('Content-Type', request.ac.a);
		xhr.send(request.ac.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.bM; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.dq.a || 0;
	xhr.responseType = request.cI.d;
	xhr.withCredentials = request.cv;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		J: xhr.responseURL,
		de: xhr.status,
		df: xhr.statusText,
		bM: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			dc: event.loaded,
			cg: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			c9: event.loaded,
			cg: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.c$) { flags += 'm'; }
	if (options.cy) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $author$project$Main$LinkClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$UrlChanged = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.R) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.T),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.T);
		} else {
			var treeLen = builder.R * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.V) : builder.V;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.R);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.T) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.T);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{V: nodeList, R: (len / $elm$core$Array$branchFactor) | 0, T: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bK: fragment, bP: host, c7: path, b2: port_, b5: protocol, b6: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Main$PortfolioBeta = {$: 20};
var $author$project$Main$PortfolioBetaMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$ReferralsBeta = {$: 21};
var $author$project$Main$ReferralsBetaMsg = function (a) {
	return {$: 12, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Pages$PortfolioBeta$GotProjects = $elm$core$Basics$identity;
var $author$project$Pages$PortfolioBeta$endpoint = 'https://script.google.com/macros/s/AKfycbz674XW8MRBTLiIFSj3uLG3YO0yHmENhFZIFCayn0pip4xZT3-jupWOXUdiIPK2KAJP-g/exec';
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.de));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {b9: reqs, cj: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.cm;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.b9));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.cj)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					cv: r.cv,
					ac: r.ac,
					cI: A2(_Http_mapExpect, func, r.cI),
					bM: r.bM,
					cZ: r.cZ,
					dq: r.dq,
					cm: r.cm,
					J: r.J
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{cv: false, ac: r.ac, cI: r.cI, bM: r.bM, cZ: r.cZ, dq: r.dq, cm: r.cm, J: r.J}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{ac: $elm$http$Http$emptyBody, cI: r.cI, bM: _List_Nil, cZ: 'GET', dq: $elm$core$Maybe$Nothing, cm: $elm$core$Maybe$Nothing, J: r.J});
};
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Pages$PortfolioBeta$Project = function (id) {
	return function (name) {
		return function (client) {
			return function (category) {
				return function (year) {
					return function (stack) {
						return function (summary) {
							return function (metrics) {
								return function (imageUrl) {
									return function (permission) {
										return {y: category, bC: client, cQ: id, a9: imageUrl, bY: metrics, bo: name, b0: permission, ci: stack, ck: summary, am: year};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$PortfolioBeta$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Pages$PortfolioBeta$optionalString = function (key) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				key,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$null('')
						]))),
				$elm$json$Json$Decode$succeed('')
			]));
};
var $author$project$Pages$PortfolioBeta$projectDecoder = A2(
	$author$project$Pages$PortfolioBeta$andMap,
	$author$project$Pages$PortfolioBeta$optionalString('nda_permission'),
	A2(
		$author$project$Pages$PortfolioBeta$andMap,
		$author$project$Pages$PortfolioBeta$optionalString('featured_image_url'),
		A2(
			$author$project$Pages$PortfolioBeta$andMap,
			$author$project$Pages$PortfolioBeta$optionalString('key_metrics_achieved'),
			A2(
				$author$project$Pages$PortfolioBeta$andMap,
				$author$project$Pages$PortfolioBeta$optionalString('deliverables_summary'),
				A2(
					$author$project$Pages$PortfolioBeta$andMap,
					$author$project$Pages$PortfolioBeta$optionalString('primary_tech_stack'),
					A2(
						$author$project$Pages$PortfolioBeta$andMap,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$String$left(4),
							$author$project$Pages$PortfolioBeta$optionalString('start_date')),
						A2(
							$author$project$Pages$PortfolioBeta$andMap,
							$author$project$Pages$PortfolioBeta$optionalString('category'),
							A2(
								$author$project$Pages$PortfolioBeta$andMap,
								$author$project$Pages$PortfolioBeta$optionalString('client_name'),
								A2(
									$author$project$Pages$PortfolioBeta$andMap,
									$author$project$Pages$PortfolioBeta$optionalString('project_name'),
									A2(
										$author$project$Pages$PortfolioBeta$andMap,
										$author$project$Pages$PortfolioBeta$optionalString('project_id'),
										$elm$json$Json$Decode$succeed($author$project$Pages$PortfolioBeta$Project)))))))))));
var $author$project$Pages$PortfolioBeta$responseDecoder = A2(
	$elm$json$Json$Decode$field,
	'data',
	$elm$json$Json$Decode$list($author$project$Pages$PortfolioBeta$projectDecoder));
var $author$project$Pages$PortfolioBeta$fetch = $elm$http$Http$get(
	{
		cI: A2($elm$http$Http$expectJson, $elm$core$Basics$identity, $author$project$Pages$PortfolioBeta$responseDecoder),
		J: $author$project$Pages$PortfolioBeta$endpoint
	});
var $author$project$Pages$ReferralsBeta$GotReferrals = $elm$core$Basics$identity;
var $author$project$Pages$ReferralsBeta$endpoint = 'https://script.google.com/macros/s/AKfycbwvc3J4gdzD90GzYVbjCkrU72D1JYYKkIERHqY_DI6KpFEMz3PLSqAcjUEiikmEWpu8/exec';
var $author$project$Pages$ReferralsBeta$Referral = function (id) {
	return function (company) {
		return function (role) {
			return function (kind) {
				return function (department) {
					return function (location) {
						return function (status) {
							return function (referralMethod) {
								return function (instructions) {
									return function (notes) {
										return function (isPublic) {
											return {bE: company, bG: department, cQ: id, bl: instructions, bT: isPublic, bV: kind, bX: location, b_: notes, br: referralMethod, a0: role, aA: status};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$ReferralsBeta$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Pages$ReferralsBeta$optionalBool = function (key) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				key,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$bool,
							$elm$json$Json$Decode$succeed(false)
						]))),
				$elm$json$Json$Decode$succeed(false)
			]));
};
var $author$project$Pages$ReferralsBeta$optionalString = function (key) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				key,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$null('')
						]))),
				$elm$json$Json$Decode$succeed('')
			]));
};
var $author$project$Pages$ReferralsBeta$referralDecoder = A2(
	$author$project$Pages$ReferralsBeta$andMap,
	$author$project$Pages$ReferralsBeta$optionalBool('isPublic'),
	A2(
		$author$project$Pages$ReferralsBeta$andMap,
		$author$project$Pages$ReferralsBeta$optionalString('notes'),
		A2(
			$author$project$Pages$ReferralsBeta$andMap,
			$author$project$Pages$ReferralsBeta$optionalString('instructions'),
			A2(
				$author$project$Pages$ReferralsBeta$andMap,
				$author$project$Pages$ReferralsBeta$optionalString('referralMethod'),
				A2(
					$author$project$Pages$ReferralsBeta$andMap,
					$author$project$Pages$ReferralsBeta$optionalString('status'),
					A2(
						$author$project$Pages$ReferralsBeta$andMap,
						$author$project$Pages$ReferralsBeta$optionalString('location'),
						A2(
							$author$project$Pages$ReferralsBeta$andMap,
							$author$project$Pages$ReferralsBeta$optionalString('department'),
							A2(
								$author$project$Pages$ReferralsBeta$andMap,
								$author$project$Pages$ReferralsBeta$optionalString('type'),
								A2(
									$author$project$Pages$ReferralsBeta$andMap,
									$author$project$Pages$ReferralsBeta$optionalString('role'),
									A2(
										$author$project$Pages$ReferralsBeta$andMap,
										$author$project$Pages$ReferralsBeta$optionalString('company'),
										A2(
											$author$project$Pages$ReferralsBeta$andMap,
											$author$project$Pages$ReferralsBeta$optionalString('id'),
											$elm$json$Json$Decode$succeed($author$project$Pages$ReferralsBeta$Referral))))))))))));
var $author$project$Pages$ReferralsBeta$responseDecoder = A2(
	$elm$json$Json$Decode$field,
	'data',
	$elm$json$Json$Decode$list($author$project$Pages$ReferralsBeta$referralDecoder));
var $author$project$Pages$ReferralsBeta$fetch = $elm$http$Http$get(
	{
		cI: A2($elm$http$Http$expectJson, $elm$core$Basics$identity, $author$project$Pages$ReferralsBeta$responseDecoder),
		J: $author$project$Pages$ReferralsBeta$endpoint
	});
var $author$project$Main$getCanonicalUrl = function (route) {
	var baseUrl = 'https://mpj.io';
	switch (route.$) {
		case 0:
			return baseUrl + '/';
		case 1:
			return baseUrl + '/appearances/';
		case 2:
			return baseUrl + '/credentials/';
		case 3:
			return baseUrl + '/outcomes/';
		case 4:
			return baseUrl + '/hire-me/';
		case 5:
			return baseUrl + '/writings/';
		case 6:
			return baseUrl + '/codex/';
		case 7:
			return baseUrl + '/signals/';
		case 8:
			var slug = route.a;
			return baseUrl + ('/signals/' + (slug + '/'));
		case 9:
			return baseUrl + '/entrepreneurship/';
		case 10:
			return baseUrl + '/offers/';
		case 11:
			return baseUrl + '/mentorcruise/';
		case 12:
			return baseUrl + '/find-me-in/';
		case 13:
			return baseUrl + '/mentor-sh/';
		case 14:
			return baseUrl + '/meetapro/';
		case 15:
			return baseUrl + '/services/';
		case 16:
			return baseUrl + '/expert-witness/';
		case 17:
			return baseUrl + '/saksi-ahli/';
		case 18:
			var lang = route.a;
			var region = route.b;
			var topic = route.c;
			var forum = route.d;
			var root = (lang === 'en') ? '/expert-witness/' : '/saksi-ahli/';
			return baseUrl + (root + (region + ('/' + (topic + ('/' + (forum + '/'))))));
		case 19:
			var slug = route.a;
			return baseUrl + ('/mentoring/' + (slug + '/'));
		case 20:
			return baseUrl + '/portfolio-beta/';
		case 21:
			return baseUrl + '/referrals-beta/';
		default:
			return baseUrl + '/';
	}
};
var $author$project$Data$LegalPages$allPages = _List_fromArray(
	[
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in European Union',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in European Union',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in European Union',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in European Union',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in European Union',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in European Union',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in European Union',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in European Union',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in European Union', 'Technical testimony at ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration)', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in European Union',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in European Union', 'Technical testimony at ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration)', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in European Union',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in European Union',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in European Union',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in European Union',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in European Union',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in European Union',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in European Union',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in European Union',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in European Union',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in European Union',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in European Union',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in European Union',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in European Union',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in European Union',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within European Union. Experienced with ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (European Union)',
		c: 'en',
		e: 'eu',
		f: 'eu/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in European Union',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within European Union.', 'Expert Reporting: Drafting clear, robust evidence for ICC International Court of Arbitration, Netherlands Arbitration Institute (NAI), PCA (Permanent Court of Arbitration).']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in European Union',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in United Kingdom',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in United Kingdom',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in United Kingdom',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in United Kingdom',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in United Kingdom',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in United Kingdom',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in United Kingdom',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in United Kingdom',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in United Kingdom', 'Technical testimony at London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in United Kingdom',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in United Kingdom', 'Technical testimony at London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in United Kingdom',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in United Kingdom',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in United Kingdom',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in United Kingdom',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in United Kingdom',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in United Kingdom',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in United Kingdom',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in United Kingdom',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in United Kingdom',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in United Kingdom',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in United Kingdom',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in United Kingdom',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in United Kingdom',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in United Kingdom',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within United Kingdom. Experienced with London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (United Kingdom)',
		c: 'en',
		e: 'uk',
		f: 'uk/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in United Kingdom',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within United Kingdom.', 'Expert Reporting: Drafting clear, robust evidence for London Court of International Arbitration (LCIA), UK High Court (Technology and Construction Court), CIArb.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in United Kingdom',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in USA',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in USA',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in USA',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in USA',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in USA',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in USA',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in USA',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in USA',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in USA', 'Technical testimony at AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in USA',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in USA', 'Technical testimony at AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in USA',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in USA',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in USA',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in USA',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in USA',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in USA',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in USA',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in USA',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in USA',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in USA',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in USA',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in USA',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in USA',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in USA',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within USA. Experienced with AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (USA)',
		c: 'en',
		e: 'us',
		f: 'us/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in USA',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within USA.', 'Expert Reporting: Drafting clear, robust evidence for AAA-ICDR (International Centre for Dispute Resolution), JAMS International, US Federal District Courts.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in USA',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in Indonesia',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in Indonesia',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in Indonesia',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in Indonesia',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in Indonesia',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in Indonesia',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in Indonesia',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in Indonesia',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in Indonesia', 'Technical testimony at BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in Indonesia',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in Indonesia', 'Technical testimony at BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in Indonesia',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in Indonesia',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in Indonesia',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in Indonesia',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in Indonesia',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in Indonesia',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in Indonesia',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in Indonesia',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in Indonesia',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in Indonesia',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in Indonesia',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in Indonesia',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in Indonesia',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in Indonesia',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within Indonesia. Experienced with BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Indonesia)',
		c: 'en',
		e: 'id',
		f: 'id/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Indonesia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Indonesia.', 'Expert Reporting: Drafting clear, robust evidence for BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in Indonesia',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in Singapore',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in Singapore',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in Singapore',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in Singapore',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in Singapore',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in Singapore',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in Singapore',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in Singapore',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in Singapore', 'Technical testimony at Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC)', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in Singapore',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in Singapore', 'Technical testimony at Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC)', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in Singapore',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in Singapore',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in Singapore',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in Singapore',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in Singapore',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in Singapore',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in Singapore',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in Singapore',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in Singapore',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in Singapore',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in Singapore',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in Singapore',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in Singapore',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in Singapore',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within Singapore. Experienced with Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Singapore)',
		c: 'en',
		e: 'sg',
		f: 'sg/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Singapore',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Singapore.', 'Expert Reporting: Drafting clear, robust evidence for Singapore International Arbitration Centre (SIAC), Singapore International Commercial Court (SICC).']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in Singapore',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in Australia',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in Australia',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in Australia',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in Australia',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in Australia',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in Australia',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in Australia',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in Australia',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in Australia', 'Technical testimony at ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in Australia',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in Australia', 'Technical testimony at ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in Australia',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in Australia',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in Australia',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in Australia',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in Australia',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in Australia',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in Australia',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in Australia',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in Australia',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in Australia',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in Australia',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in Australia',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in Australia',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in Australia',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within Australia. Experienced with ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Australia)',
		c: 'en',
		e: 'au',
		f: 'au/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Australia',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Australia.', 'Expert Reporting: Drafting clear, robust evidence for ACICA (Australian Centre for International Commercial Arbitration), Federal Court of Australia.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in Australia',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Artificial Intelligence Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ai/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Arbitration in Hong Kong',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Deconstruction of \'Black Box\' neural networks for legal evidence', 'Audit of AI training data provenance and copyright compliance', 'Analysis of algorithmic bias and fairness metrics (EU AI Act standards)', 'Verification of AI transparency and explainability (XAI) requirements', 'Assessment of liability in autonomous system failures']),
		i: 'Professional technical expert witness specializing in Artificial Intelligence for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I use Explainable AI (XAI) techniques and feature attribution mapping to translate high-dimensional weights into logical factors that influenced a specific outcome.', b: 'How do you explain \'Black Box\' AI decisions to a judge?'},
				{a: 'Yes, I perform membership inference attacks and data lineage audits to determine the likelihood of specific datasets being part of the training corpus.', b: 'Can you identify if a model was trained on specific protected data?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Artificial Intelligence systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Artificial Intelligence?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Artificial Intelligence Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ai/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Artificial Intelligence for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Artificial Intelligence', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Artificial Intelligence dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Artificial Intelligence evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'In the era of the EU AI Act and global AI regulation, the \'black box\' of machine learning is no longer a valid legal defense. Whether it\'s algorithmic bias, transparency obligations under Article 13, or high-risk AI classification, you need an expert who can deconstruct neural networks into legally actionable evidence.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Artificial Intelligence Expert Witness | Court Litigation in Hong Kong',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Machine Learning Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ml/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Arbitration in Hong Kong',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Forensic audit of ML training pipelines and data leakage', 'Evaluation of model hallucination risks in RAG systems', 'Technical review of model architecture and hyperparameter tuning', 'Assessment of ML model robustness against adversarial attacks', 'Validation of model performance claims vs. real-world behavior']),
		i: 'Professional technical expert witness specializing in Machine Learning for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'It occurs when information from the test set or future data \'leaks\' into the training process, leading to inflated performance claims that fail in production. I audit the pipeline to detect this negligence.', b: 'What is \'Data Leakage\' in an ML dispute?'},
				{a: 'I compare the development lifecycle against ISO/IEC 42001 and industry benchmarks for data validation, model versioning, and monitoring.', b: 'How do you verify the \'Standard of Care\' for ML development?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Machine Learning systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Machine Learning?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Machine Learning Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ml/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Machine Learning for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Machine Learning', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Machine Learning dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Machine Learning evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Machine learning disputes often involve training data provenance, model hallucinations, and explainability (XAI). I provide deep technical analysis of model architecture, weights, and training pipelines to determine liability and adherence to industry standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Machine Learning Expert Witness | Court Litigation in Hong Kong',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Engineering Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/software/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Arbitration in Hong Kong',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Abstraction-Filtration-Comparison (AFC) test for code copyright', 'Deep source code forensics to identify misappropriated trade secrets', 'Clean room design audit and \'wall\' integrity verification', 'Software valuation and technical due diligence for IP disputes', 'Reverse engineering to detect patent infringement or hidden logic']),
		i: 'Professional technical expert witness specializing in Software Engineering for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'It is the judicial standard where I abstract the code, filter out non-protectable elements (open source, efficiency), and compare the remaining core for substantial similarity.', b: 'What is the AFC test in software litigation?'},
				{a: 'I use AST (Abstract Syntax Tree) comparison and symbolic analysis to match logic and structure even when variable names and formatting have been altered.', b: 'How do you handle obfuscated source code?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Engineering Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/software/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Engineering dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Software IP litigation goes beyond literal \'copy-paste\'. It involves architectural patterns, non-literal elements, and the AFC (Abstraction-Filtration-Comparison) test. I perform deep source code forensics and reverse engineering to identify trade secret misappropriation or patent infringement.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Engineering Expert Witness | Court Litigation in Hong Kong',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Software Testing Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/testing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Arbitration in Hong Kong',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit of testing protocols and coverage (ISO/IEC/IEEE 29119)', 'Root cause analysis of mission-critical system crashes', 'Regression testing failure analysis in rapid deployment cycles', 'Verification of load testing and scalability benchmarks', 'Assessment of \'Standard of Care\' in QA for safety-critical software']),
		i: 'Professional technical expert witness specializing in Software Testing for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the risk assessment documentation and the adequacy of the test suite coverage for edge cases that led to the failure.', b: 'Can you determine if a software failure was \'foreseeable\'?'},
				{a: 'I utilize ISO/IEC 25010 for product quality and the IEEE 829 standard for documentation to evaluate if the vendor met professional expectations.', b: 'What benchmarks do you use for software quality disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Software Testing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Software Testing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Software Testing Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/testing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Software Testing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Software Testing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Software Testing dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Software Testing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Software failure litigation often hinges on the \'Standard of Care\' in quality assurance. Whether it\'s mission-critical system crashes or data integrity failures, I analyze testing protocols, coverage metrics, and ISO/IEC/IEEE 29119 compliance to determine if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Software Testing Expert Witness | Court Litigation in Hong Kong',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Arbitration in Hong Kong', 'Technical testimony at Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'arbitration',
		k: 'System Engineering Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/systems/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Arbitration in Hong Kong',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Deep forensic analysis of System Engineering systems', 'Expert reports for Court Litigation in Hong Kong', 'Technical testimony at Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong', 'Verification of System Engineering implementation vs contract', 'Audit of algorithmic transparency and bias']),
		i: 'Professional technical expert witness specializing in System Engineering for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale System Engineering systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with System Engineering?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'},
				{a: 'I maintain a rigorous conflict check database. I require the names of all parties and related entities before accepting any instruction.', b: 'How do you manage potential conflicts of interest?'},
				{a: 'I am familiar with joint expert conclaves and concurrent evidence procedures, which are common in Australian and Singaporean jurisdictions.', b: 'Do you have experience with \'hot-tubbing\' (concurrent evidence)?'}
			]),
		d: 'court',
		k: 'System Engineering Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/systems/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate System Engineering for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: System Engineering', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes System Engineering dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of System Engineering evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Complex systems engineering failures are rarely caused by a single bug; they are emergent properties of tight coupling and complex interactions. I use STAMP/CAST models and system-of-systems analysis to identify root causes in distributed infrastructure and cloud architectures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'System Engineering Expert Witness | Court Litigation in Hong Kong',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'High Performance Computing Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/hpc/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Arbitration in Hong Kong',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analysis of race conditions in massive parallel processing', 'Audit of GPU cluster utilization and CUDA kernel efficiency', 'Root cause analysis of interconnect and MPI bottlenecks', 'Verification of supercomputing SLA performance benchmarks', 'Investigation of memory leakage in distributed architectures']),
		i: 'Professional technical expert witness specializing in High Performance Computing for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I use deterministic replay tools and thread-interleaving analysis to reconstruct the specific sequence of non-deterministic events that led to the crash.', b: 'How do you prove a race condition caused a system failure?'},
				{a: 'I have deconstructed complex CUDA and OpenCL implementations to identify performance bottlenecks or improper resource allocation in high-frequency trading and research clusters.', b: 'What is your experience with GPU-accelerated computing disputes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale High Performance Computing systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with High Performance Computing?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'High Performance Computing Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/hpc/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate High Performance Computing for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: High Performance Computing', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes High Performance Computing dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of High Performance Computing evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'High Performance Computing (HPC) and supercomputing disputes involve complex parallel processing, race conditions, and interconnect efficiency. I provide expert analysis for litigation involving large-scale clusters, GPU acceleration (CUDA), and distributed memory architectures (MPI).', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'High Performance Computing Expert Witness | Court Litigation in Hong Kong',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Algorithms & Logic Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/algorithms/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Arbitration in Hong Kong',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Deconstruction of proprietary scoring and ranking logic', 'Audit of algorithmic transparency for consumer protection', 'Verification of dynamic pricing models and fare-splitting logic', 'Analysis of emergent behavior vs. intentional design in systems', 'Technical review of automated decision-making (ADM) systems']),
		i: 'Professional technical expert witness specializing in Algorithms & Logic for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I work within secure, air-gapped environments or \'clean rooms\' to analyze the logic, providing the court with a conceptual mapping of the behavior without disclosing the literal source code to the public.', b: 'How do you audit a \'Trade Secret\' algorithm without leaking it?'},
				{a: 'While the algorithm itself isn\'t a legal person, I provide the technical evidence to show if the design was inherently biased or if the \'Standard of Care\' in data selection was breached.', b: 'Can algorithms be held liable for discriminatory outcomes?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Algorithms & Logic systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Algorithms & Logic?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Algorithms & Logic Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/algorithms/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Algorithms & Logic for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Algorithms & Logic', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Algorithms & Logic dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Algorithms & Logic evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Algorithms govern our lives, from credit scoring to content moderation. When these invisible rules lead to litigation, the dispute often hinges on the distinction between \'intentional design\' and \'emergent behavior\'. I bridge that gap.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Algorithms & Logic Expert Witness | Court Litigation in Hong Kong',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Cybersecurity & Data Breach Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/cybersecurity/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Arbitration in Hong Kong',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Forensic attribution of data breaches and entry vectors', 'Assessment of \'Reasonable Security\' against NIST/CIS frameworks', 'Audit of MFA and identity management configurations in breaches', 'Timeline reconstruction from firewall, EDR, and cloud logs', 'Expert reporting on SEC/GDPR technical disclosure accuracy']),
		i: 'Professional technical expert witness specializing in Cybersecurity & Data Breach for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I evaluate the defendant\'s security posture against recognized frameworks like NIST CSF or CIS Controls relative to the sensitivity of the data they handled.', b: 'How do you define \'Reasonable Security\' in court?'},
				{a: 'Yes, through deep log analysis and forensic artifacts, I can determine if data was merely viewed or actually removed from the network, which impacts notification laws.', b: 'Can you distinguish between data \'access\' and \'exfiltration\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Cybersecurity & Data Breach systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Cybersecurity & Data Breach?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Cybersecurity & Data Breach Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/cybersecurity/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Cybersecurity & Data Breach for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Cybersecurity & Data Breach', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Cybersecurity & Data Breach dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Cybersecurity & Data Breach evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Data breaches are rarely a matter of \'if\', but \'when\'. In court, the question is \'was the security state-of-the-art?\'. I provide the technical forensic audit to determine if reasonable care was taken or if gross negligence occurred.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Cybersecurity & Data Breach Expert Witness | Court Litigation in Hong Kong',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'E-Commerce Systems Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ecommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Arbitration in Hong Kong',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Root cause analysis of ERP and middleware integration failures', 'Audit of PIM synchronization and inventory data integrity', 'Performance stress testing and load-bearing capacity verification', 'Technical review of ADA (Accessibility) and PCI-DSS compliance', 'Gap analysis of \'Off-the-Shelf\' capabilities vs. custom SOW requirements']),
		i: 'Professional technical expert witness specializing in E-Commerce Systems for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'Usually due to systemic architectural decay where the middleware cannot handle the synchronization frequency required by the ERP, leading to data state corruption.', b: 'Why do large-scale e-commerce implementations fail technically?'},
				{a: 'I audit the UAT (User Acceptance Testing) sign-offs and the Stress Testing logs to see if known risks were ignored before the \'Go-Live\' date.', b: 'How do you evaluate \'Reasonable Care\' in a site launch failure?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale E-Commerce Systems systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with E-Commerce Systems?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'E-Commerce Systems Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ecommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate E-Commerce Systems for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: E-Commerce Systems', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes E-Commerce Systems dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of E-Commerce Systems evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Multi-million dollar E-commerce platforms fail not because of \'bugs\', but because of systemic architectural decay. When implementations collapse, I investigate the \'Standard of Care\' provided by vendors versus the contractual requirements.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'E-Commerce Systems Expert Witness | Court Litigation in Hong Kong',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Logistics & Supply Chain Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/logistics/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Arbitration in Hong Kong',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Forensic audit of routing algorithms and fleet dispatch logic', 'Analysis of warehouse automation and IoT sensor data integrity', 'Technical review of supply chain visibility and tracking systems', 'Root cause analysis of systemic delivery delay patterns', 'Verification of last-mile optimization efficiency claims']),
		i: 'Professional technical expert witness specializing in Logistics & Supply Chain for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I correlate GPS pings, sensor telemetry, and API logs to reconstruct the exact state of the supply chain at the time of the incident, identifying where the data integrity was compromised.', b: 'How can IoT data be used as evidence in logistics disputes?'},
				{a: 'I have audited high-frequency dispatching engines to determine if the logic was providing unfair advantages or if it was failing to comply with service level agreements (SLAs).', b: 'What is your experience with \'Last-Mile\' delivery algorithms?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Logistics & Supply Chain systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Logistics & Supply Chain?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Logistics & Supply Chain Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/logistics/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Logistics & Supply Chain for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Logistics & Supply Chain', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Logistics & Supply Chain dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Logistics & Supply Chain evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'Logistics systems are the nervous system of global trade. When routing algorithms fail or warehouse automation goes rogue, the resulting supply chain disruption is catastrophic. I provide the root-cause analysis for these complex failures.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Logistics & Supply Chain Expert Witness | Court Litigation in Hong Kong',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Q-Commerce & Food Delivery Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/qcommerce/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Arbitration in Hong Kong',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit of real-time inventory management and low-latency APIs', 'Verification of automated batching and dispatching logic', 'Analysis of dynamic pay and incentive calculation engines', 'Technical review of dark store automation and picking systems', 'Assessment of system uptime and performance during peak demand']),
		i: 'Professional technical expert witness specializing in Q-Commerce & Food Delivery for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'I perform timestamp correlation analysis across distributed microservices to identify where \'race conditions\' or API timeouts caused systemic delivery failures.', b: 'How do you audit milliseconds-sensitive Q-commerce systems?'},
				{a: 'It determines liability in gig-worker disputes; I provide the technical proof of how the algorithm \'managed\' the worker, which is critical for employment status litigation.', b: 'What is the legal relevance of \'Algorithmic Dispatching\'?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Q-Commerce & Food Delivery systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Q-Commerce & Food Delivery?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Q-Commerce & Food Delivery Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/qcommerce/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Q-Commerce & Food Delivery for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Q-Commerce & Food Delivery', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Q-Commerce & Food Delivery dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Q-Commerce & Food Delivery evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'In Q-commerce, milliseconds are money. Disputes often arise around algorithmic dispatching and dynamic pay models. I help legal teams understand how these high-frequency systems actually operate under the hood.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Q-Commerce & Food Delivery Expert Witness | Court Litigation in Hong Kong',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Arbitration matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'arbitration',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ridehailing/arbitration',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Arbitration, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Arbitration without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Arbitration, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Arbitration in Hong Kong',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analysis of surge pricing algorithms and demand-supply matching', 'Forensic audit of driver deactivation and fraud detection logic', 'Technical review of GPS tracking and fare-splitting accuracy', 'Audit of platform compliance with labor and transportation laws', 'Verification of safety protocols and automated emergency triggers']),
		i: 'Professional technical expert witness specializing in Ride-Hailing & Gig Economy for Court Litigation matters within Hong Kong. Experienced with Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.',
		j: _List_fromArray(
			[
				{a: 'Yes, by analyzing the logs of the fraud detection engine and the specific decision-tree parameters that triggered the deactivation, determining if it met the contractual \'Fairness\' standards.', b: 'Can you prove if a driver was \'Automatically Deactivated\' without cause?'},
				{a: 'I audit the real-time demand telemetry data versus the output of the pricing engine to ensure no \'unjust enrichment\' occurred through intentional system manipulation.', b: 'How do you verify \'Surge Pricing\' transparency?'},
				{a: 'I have a decade of professional engineering experience and have been writing code since 2009. I am currently a Full Stack Engineer with Booking.com\'s FareHarbor, and previously worked at bol.com, Picnic, Delivery Hero\'s Glovo, Mekari (as Engineering Manager), ErudiFi (Danacita) and Gojek\'s Midtrans division, building large-scale Ride-Hailing & Gig Economy systems. Academically I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), a professional postgraduate degree in Informatics from Institut Teknologi Bandung, and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada with peer-reviewed research in high-performance computing. I am currently a PhD candidate in Mathematics and Explainable AI at GCAS College Dublin and an MSc Cyber Security candidate at Royal Holloway.', b: 'What is your specific experience with Ride-Hailing & Gig Economy?'},
				{a: 'I am familiar with the procedures of SIAC, ICC and LCIA, and with the distinction between giving evidence to a tribunal and to a judge. My instruction and testimony history is disclosed in full in every expert report and I am happy to confirm it on enquiry.', b: 'Do you have experience testifying in international arbitration?'},
				{a: 'I use industry-standard tools and custom scripts to perform deep code comparison, identifying substantial similarity and open-source license compliance issues.', b: 'How do you handle source code forensics?'},
				{a: 'A preliminary merit review takes 5-7 days. A full expert report typically requires 4-6 weeks depending on the volume of discovery material.', b: 'What is your typical lead time for an expert report?'},
				{a: 'Absolutely. I understand that my primary duty is to the court or tribunal, providing independent and objective technical analysis regardless of who instructs me.', b: 'Are you familiar with the duty to the court (e.g., UK CPR 35)?'},
				{a: 'I use air-gapped systems for sensitive source code review and encrypted communication channels for all case-related discussions.', b: 'How do you maintain data security during a case?'},
				{a: 'This is my core strength. I combine my technical depth with my legal studies to translate \'code\' into \'concepts\' that a judge or arbitrator can use for a ruling.', b: 'Can you explain complex algorithms to non-technical judges?'},
				{a: 'Yes. I maintain strict independence. My goal is to find the technical truth, whether it supports the claimant or the respondent.', b: 'Do you work on both plaintiff and defense instructions?'}
			]),
		d: 'court',
		k: 'Ride-Hailing & Gig Economy Expert Witness (Hong Kong)',
		c: 'en',
		e: 'hk',
		f: 'hk/ridehailing/court',
		l: {
			n: 'Avoid the risk of an expert who cannot withstand cross-examination or fails to translate Ride-Hailing & Gig Economy for the judge.',
			o: 'Inquire for Expert Instruction',
			r: {m: 'Full Stack Engineer at Booking.com\'s FareHarbor; previously bol.com, Picnic and Delivery Hero\'s Glovo; two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, EU-accredited), 2026 | Program Profesi Insinyur (Ir.), Informatics, ITB, 2026 | BEng Nuclear Engineering & Engineering Physics, UGM, 2017 — peer-reviewed HPC research | MSc Cyber Security, Royal Holloway (in progress) | MS Data Center Engineering, HELHa Belgium (in progress) | PhD candidate, Mathematics & Explainable AI, GCAS College Dublin (Woolf, EU-accredited) | LLB candidate, Universitas Siber Muhammadiyah (2027) | Specialisation: Ride-Hailing & Gig Economy', p: 'I understand that in Court Litigation, a single technical misunderstanding can jeopardize your entire case.'},
			s: 'A legal team handling a high-stakes Ride-Hailing & Gig Economy dispute in Hong Kong',
			v: _List_fromArray(
				['Technical Merit Review: Assessing the strengths and weaknesses of Ride-Hailing & Gig Economy evidence.', 'Deep Forensics: Analyzing source code, logs, and system behavior within Hong Kong.', 'Expert Reporting: Drafting clear, robust evidence for Hong Kong International Arbitration Centre (HKIAC), High Court of Hong Kong.']),
			w: {q: 'The \'Gig Economy\' is built on algorithmic management. From automated deactivations to fare-splitting logic, I provide the technical expertise to analyze whether these systems comply with platform work directives and fair labor standards.', t: 'Struggling to find an expert who can explain the technical truth to the Court Litigation without getting lost in jargon.', u: 'In a world run by code, justice should be guided by those who truly understand how that code operates.'},
			x: 'Technical clarity in Court Litigation, leading to a ruling based on factual engineering truth.'
		},
		I: 'Ride-Hailing & Gig Economy Expert Witness | Court Litigation in Hong Kong',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Dekonstruksi jaringan saraf \'Black Box\' untuk bukti hukum', 'Audit asal-usul data pelatihan AI dan kepatuhan hak cipta', 'Analisis bias algoritma dan metrik keadilan (standar UU ITE/EU AI Act)', 'Verifikasi persyaratan transparansi dan keterjelasan AI (XAI)', 'Penilaian tanggung jawab dalam kegagalan sistem otonom']),
		i: 'Jasa saksi ahli profesional spesialisasi Kecerdasan Buatan (AI) untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya menggunakan teknik Explainable AI (XAI) dan pemetaan atribusi fitur untuk menerjemahkan bobot dimensi tinggi menjadi faktor logis yang mempengaruhi hasil tertentu.', b: 'Bagaimana Anda menjelaskan keputusan AI \'Black Box\' kepada hakim?'},
				{a: 'Ya, saya melakukan audit silsilah data dan analisis inferensi keanggotaan untuk menentukan probabilitas penggunaan dataset tertentu dalam proses pelatihan.', b: 'Dapatkah Anda mengidentifikasi jika suatu model dilatih menggunakan data terlindungi tertentu?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Kecerdasan Buatan (AI) berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Kecerdasan Buatan (AI)?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Kecerdasan Buatan (AI) (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ai/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Kecerdasan Buatan (AI) bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Kecerdasan Buatan (AI)', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Kecerdasan Buatan (AI) bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Kecerdasan Buatan (AI) Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Di era regulasi AI global dan UU ITE, \'kotak hitam\' machine learning bukan lagi pembelaan hukum yang sah. Baik itu bias algoritma, kewajiban transparansi, atau klasifikasi AI berisiko tinggi, Anda memerlukan ahli yang dapat menguraikan jaringan saraf menjadi bukti hukum yang nyata.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Kecerdasan Buatan (AI) | Arbitrase di Indonesia',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Dekonstruksi jaringan saraf \'Black Box\' untuk bukti hukum', 'Audit asal-usul data pelatihan AI dan kepatuhan hak cipta', 'Analisis bias algoritma dan metrik keadilan (standar UU ITE/EU AI Act)', 'Verifikasi persyaratan transparansi dan keterjelasan AI (XAI)', 'Penilaian tanggung jawab dalam kegagalan sistem otonom']),
		i: 'Jasa saksi ahli profesional spesialisasi Kecerdasan Buatan (AI) untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya menggunakan teknik Explainable AI (XAI) dan pemetaan atribusi fitur untuk menerjemahkan bobot dimensi tinggi menjadi faktor logis yang mempengaruhi hasil tertentu.', b: 'Bagaimana Anda menjelaskan keputusan AI \'Black Box\' kepada hakim?'},
				{a: 'Ya, saya melakukan audit silsilah data dan analisis inferensi keanggotaan untuk menentukan probabilitas penggunaan dataset tertentu dalam proses pelatihan.', b: 'Dapatkah Anda mengidentifikasi jika suatu model dilatih menggunakan data terlindungi tertentu?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Kecerdasan Buatan (AI) berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Kecerdasan Buatan (AI)?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Kecerdasan Buatan (AI) (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ai/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Kecerdasan Buatan (AI) bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Kecerdasan Buatan (AI)', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Kecerdasan Buatan (AI) bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Kecerdasan Buatan (AI) Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Di era regulasi AI global dan UU ITE, \'kotak hitam\' machine learning bukan lagi pembelaan hukum yang sah. Baik itu bias algoritma, kewajiban transparansi, atau klasifikasi AI berisiko tinggi, Anda memerlukan ahli yang dapat menguraikan jaringan saraf menjadi bukti hukum yang nyata.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Kecerdasan Buatan (AI) | Litigasi Pengadilan di Indonesia',
		g: 'ai'
	},
		{
		h: _List_fromArray(
			['Audit forensik alur pelatihan ML dan kebocoran data', 'Evaluasi risiko halusinasi model dalam sistem RAG', 'Tinjauan teknis arsitektur model dan penyetelan hyperparameter', 'Penilaian ketahanan model ML terhadap serangan adversarial', 'Validasi klaim kinerja model vs. perilaku dunia nyata']),
		i: 'Jasa saksi ahli profesional spesialisasi Pembelajaran Mesin (ML) untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Terjadi ketika informasi dari set pengujian \'bocor\' ke dalam proses pelatihan, menyebabkan klaim kinerja yang berlebihan namun gagal saat produksi. Saya mengaudit alur kerja untuk mendeteksi kelalaian ini.', b: 'Apa yang dimaksud dengan \'Data Leakage\' dalam sengketa ML?'},
				{a: 'Saya membandingkan siklus hidup pengembangan dengan ISO/IEC 42001 dan tolok ukur industri untuk validasi data, versi model, dan pemantauan.', b: 'Bagaimana Anda memverifikasi \'Standard of Care\' untuk pengembangan ML?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Pembelajaran Mesin (ML) berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Pembelajaran Mesin (ML)?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Pembelajaran Mesin (ML) (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ml/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Pembelajaran Mesin (ML) bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Pembelajaran Mesin (ML)', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Pembelajaran Mesin (ML) bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Pembelajaran Mesin (ML) Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Sengketa machine learning sering kali melibatkan asal-usul data pelatihan, halusinasi model, dan keterjelasan (XAI). Saya menyediakan analisis teknis mendalam tentang arsitektur model, bobot, dan alur pelatihan untuk menentukan tanggung jawab dan kepatuhan terhadap standar industri.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Pembelajaran Mesin (ML) | Arbitrase di Indonesia',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Audit forensik alur pelatihan ML dan kebocoran data', 'Evaluasi risiko halusinasi model dalam sistem RAG', 'Tinjauan teknis arsitektur model dan penyetelan hyperparameter', 'Penilaian ketahanan model ML terhadap serangan adversarial', 'Validasi klaim kinerja model vs. perilaku dunia nyata']),
		i: 'Jasa saksi ahli profesional spesialisasi Pembelajaran Mesin (ML) untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Terjadi ketika informasi dari set pengujian \'bocor\' ke dalam proses pelatihan, menyebabkan klaim kinerja yang berlebihan namun gagal saat produksi. Saya mengaudit alur kerja untuk mendeteksi kelalaian ini.', b: 'Apa yang dimaksud dengan \'Data Leakage\' dalam sengketa ML?'},
				{a: 'Saya membandingkan siklus hidup pengembangan dengan ISO/IEC 42001 dan tolok ukur industri untuk validasi data, versi model, dan pemantauan.', b: 'Bagaimana Anda memverifikasi \'Standard of Care\' untuk pengembangan ML?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Pembelajaran Mesin (ML) berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Pembelajaran Mesin (ML)?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Pembelajaran Mesin (ML) (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ml/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Pembelajaran Mesin (ML) bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Pembelajaran Mesin (ML)', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Pembelajaran Mesin (ML) bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Pembelajaran Mesin (ML) Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Sengketa machine learning sering kali melibatkan asal-usul data pelatihan, halusinasi model, dan keterjelasan (XAI). Saya menyediakan analisis teknis mendalam tentang arsitektur model, bobot, dan alur pelatihan untuk menentukan tanggung jawab dan kepatuhan terhadap standar industri.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Pembelajaran Mesin (ML) | Litigasi Pengadilan di Indonesia',
		g: 'ml'
	},
		{
		h: _List_fromArray(
			['Uji Abstraction-Filtration-Comparison (AFC) untuk hak cipta kode', 'Forensik kode sumber mendalam untuk identifikasi rahasia dagang', 'Audit desain \'Clean Room\' dan verifikasi integritas pemisahan', 'Valuasi perangkat lunak dan uji tuntas teknis untuk sengketa HAKI', 'Rekayasa balik untuk mendeteksi pelanggaran paten atau logika tersembunyi']),
		i: 'Jasa saksi ahli profesional spesialisasi Rekayasa Perangkat Lunak untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Ini adalah standar peradilan di mana saya mengabstraksi kode, menyaring elemen yang tidak dapat dilindungi, dan membandingkan inti yang tersisa untuk kemiripan substansial.', b: 'Apa itu uji AFC dalam litigasi perangkat lunak?'},
				{a: 'Saya menggunakan perbandingan AST (Abstract Syntax Tree) dan analisis simbolik untuk mencocokkan logika dan struktur meskipun nama variabel dan format telah diubah.', b: 'Bagaimana Anda menangani kode sumber yang dikaburkan (obfuscated)?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Rekayasa Perangkat Lunak berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Rekayasa Perangkat Lunak?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Rekayasa Perangkat Lunak (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/software/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Rekayasa Perangkat Lunak bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Rekayasa Perangkat Lunak', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Rekayasa Perangkat Lunak bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Rekayasa Perangkat Lunak Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Litigasi HAKI perangkat lunak lebih dari sekadar \'copy-paste\'. Ini melibatkan pola arsitektur, elemen non-literal, dan uji AFC (Abstraction-Filtration-Comparison). Saya melakukan forensik kode sumber mendalam dan rekayasa balik untuk mengidentifikasi penyalahgunaan rahasia dagang atau pelanggaran paten.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Rekayasa Perangkat Lunak | Arbitrase di Indonesia',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Uji Abstraction-Filtration-Comparison (AFC) untuk hak cipta kode', 'Forensik kode sumber mendalam untuk identifikasi rahasia dagang', 'Audit desain \'Clean Room\' dan verifikasi integritas pemisahan', 'Valuasi perangkat lunak dan uji tuntas teknis untuk sengketa HAKI', 'Rekayasa balik untuk mendeteksi pelanggaran paten atau logika tersembunyi']),
		i: 'Jasa saksi ahli profesional spesialisasi Rekayasa Perangkat Lunak untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Ini adalah standar peradilan di mana saya mengabstraksi kode, menyaring elemen yang tidak dapat dilindungi, dan membandingkan inti yang tersisa untuk kemiripan substansial.', b: 'Apa itu uji AFC dalam litigasi perangkat lunak?'},
				{a: 'Saya menggunakan perbandingan AST (Abstract Syntax Tree) dan analisis simbolik untuk mencocokkan logika dan struktur meskipun nama variabel dan format telah diubah.', b: 'Bagaimana Anda menangani kode sumber yang dikaburkan (obfuscated)?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Rekayasa Perangkat Lunak berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Rekayasa Perangkat Lunak?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Rekayasa Perangkat Lunak (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/software/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Rekayasa Perangkat Lunak bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Rekayasa Perangkat Lunak', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Rekayasa Perangkat Lunak bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Rekayasa Perangkat Lunak Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Litigasi HAKI perangkat lunak lebih dari sekadar \'copy-paste\'. Ini melibatkan pola arsitektur, elemen non-literal, dan uji AFC (Abstraction-Filtration-Comparison). Saya melakukan forensik kode sumber mendalam dan rekayasa balik untuk mengidentifikasi penyalahgunaan rahasia dagang atau pelanggaran paten.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Rekayasa Perangkat Lunak | Litigasi Pengadilan di Indonesia',
		g: 'software'
	},
		{
		h: _List_fromArray(
			['Audit protokol pengujian dan cakupan (ISO/IEC/IEEE 29119)', 'Analisis akar masalah kerusakan sistem misi kritis', 'Analisis kegagalan pengujian regresi dalam siklus rilis cepat', 'Verifikasi pengujian beban dan tolok ukur skalabilitas', 'Penilaian \'Standard of Care\' dalam QA untuk software safety-critical']),
		i: 'Jasa saksi ahli profesional spesialisasi Pengujian Perangkat Lunak untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Ya, dengan menganalisis dokumentasi penilaian risiko dan kecukupan cakupan pengujian untuk kasus-kasus ekstrem (edge cases) yang menyebabkan kegagalan.', b: 'Dapatkah Anda menentukan apakah kegagalan software dapat diprediksi?'},
				{a: 'Saya menggunakan ISO/IEC 25010 untuk kualitas produk dan standar IEEE 829 untuk dokumentasi guna mengevaluasi apakah vendor memenuhi ekspektasi profesional.', b: 'Tolok ukur apa yang Anda gunakan untuk sengketa kualitas software?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Pengujian Perangkat Lunak berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Pengujian Perangkat Lunak?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Pengujian Perangkat Lunak (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/testing/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Pengujian Perangkat Lunak bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Pengujian Perangkat Lunak', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Pengujian Perangkat Lunak bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Pengujian Perangkat Lunak Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Litigasi kegagalan perangkat lunak sering kali bergantung pada \'Standard of Care\' dalam penjaminan kualitas. Baik itu kerusakan sistem misi kritis atau kegagalan integritas data, saya menganalisis protokol pengujian, metrik cakupan, dan kepatuhan standar untuk menentukan apakah terjadi kelalaian berat.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Pengujian Perangkat Lunak | Arbitrase di Indonesia',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Audit protokol pengujian dan cakupan (ISO/IEC/IEEE 29119)', 'Analisis akar masalah kerusakan sistem misi kritis', 'Analisis kegagalan pengujian regresi dalam siklus rilis cepat', 'Verifikasi pengujian beban dan tolok ukur skalabilitas', 'Penilaian \'Standard of Care\' dalam QA untuk software safety-critical']),
		i: 'Jasa saksi ahli profesional spesialisasi Pengujian Perangkat Lunak untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Ya, dengan menganalisis dokumentasi penilaian risiko dan kecukupan cakupan pengujian untuk kasus-kasus ekstrem (edge cases) yang menyebabkan kegagalan.', b: 'Dapatkah Anda menentukan apakah kegagalan software dapat diprediksi?'},
				{a: 'Saya menggunakan ISO/IEC 25010 untuk kualitas produk dan standar IEEE 829 untuk dokumentasi guna mengevaluasi apakah vendor memenuhi ekspektasi profesional.', b: 'Tolok ukur apa yang Anda gunakan untuk sengketa kualitas software?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Pengujian Perangkat Lunak berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Pengujian Perangkat Lunak?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Pengujian Perangkat Lunak (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/testing/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Pengujian Perangkat Lunak bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Pengujian Perangkat Lunak', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Pengujian Perangkat Lunak bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Pengujian Perangkat Lunak Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Litigasi kegagalan perangkat lunak sering kali bergantung pada \'Standard of Care\' dalam penjaminan kualitas. Baik itu kerusakan sistem misi kritis atau kegagalan integritas data, saya menganalisis protokol pengujian, metrik cakupan, dan kepatuhan standar untuk menentukan apakah terjadi kelalaian berat.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Pengujian Perangkat Lunak | Litigasi Pengadilan di Indonesia',
		g: 'testing'
	},
		{
		h: _List_fromArray(
			['Analisis forensik mendalam untuk sistem Rekayasa Sistem', 'Penyusunan laporan ahli untuk Arbitrase di Indonesia', 'Pemberian kesaksian teknis di BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri', 'Verifikasi implementasi Rekayasa Sistem vs kontrak', 'Audit transparansi dan bias algoritma']),
		i: 'Jasa saksi ahli profesional spesialisasi Rekayasa Sistem untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Rekayasa Sistem berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Rekayasa Sistem?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'},
				{a: 'Seluruh data sengketa disimpan dalam sistem terenkripsi dan diakses secara terbatas hanya untuk kepentingan analisis forensik.', b: 'Bagaimana cara menjaga kerahasiaan data dalam sengketa?'},
				{a: 'Ya, saya melayani penugasan di seluruh wilayah Indonesia dan juga tribunal arbitrase internasional di luar negeri.', b: 'Apakah Anda memberikan jasa untuk sengketa di luar Jakarta?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Rekayasa Sistem (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/systems/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Rekayasa Sistem bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Rekayasa Sistem', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Rekayasa Sistem bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Rekayasa Sistem Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Kegagalan rekayasa sistem yang kompleks jarang disebabkan oleh satu bug saja; melainkan hasil dari interaksi kompleks dan keterkaitan yang erat. Saya menggunakan model STAMP/CAST dan analisis system-of-systems untuk mengidentifikasi akar penyebab dalam infrastruktur terdistribusi dan arsitektur cloud.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Rekayasa Sistem | Arbitrase di Indonesia',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analisis forensik mendalam untuk sistem Rekayasa Sistem', 'Penyusunan laporan ahli untuk Litigasi Pengadilan di Indonesia', 'Pemberian kesaksian teknis di BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri', 'Verifikasi implementasi Rekayasa Sistem vs kontrak', 'Audit transparansi dan bias algoritma']),
		i: 'Jasa saksi ahli profesional spesialisasi Rekayasa Sistem untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Rekayasa Sistem berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Rekayasa Sistem?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'},
				{a: 'Seluruh data sengketa disimpan dalam sistem terenkripsi dan diakses secara terbatas hanya untuk kepentingan analisis forensik.', b: 'Bagaimana cara menjaga kerahasiaan data dalam sengketa?'},
				{a: 'Ya, saya melayani penugasan di seluruh wilayah Indonesia dan juga tribunal arbitrase internasional di luar negeri.', b: 'Apakah Anda memberikan jasa untuk sengketa di luar Jakarta?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Rekayasa Sistem (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/systems/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Rekayasa Sistem bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Rekayasa Sistem', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Rekayasa Sistem bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Rekayasa Sistem Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Kegagalan rekayasa sistem yang kompleks jarang disebabkan oleh satu bug saja; melainkan hasil dari interaksi kompleks dan keterkaitan yang erat. Saya menggunakan model STAMP/CAST dan analisis system-of-systems untuk mengidentifikasi akar penyebab dalam infrastruktur terdistribusi dan arsitektur cloud.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Rekayasa Sistem | Litigasi Pengadilan di Indonesia',
		g: 'systems'
	},
		{
		h: _List_fromArray(
			['Analisis race conditions dalam pemrosesan paralel masif', 'Audit utilisasi klaster GPU dan efisiensi kernel CUDA', 'Analisis akar masalah hambatan interkoneksi dan MPI', 'Verifikasi tolok ukur kinerja SLA supercomputing', 'Investigasi kebocoran memori dalam arsitektur terdistribusi']),
		i: 'Jasa saksi ahli profesional spesialisasi Komputasi Kinerja Tinggi (HPC) untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya menggunakan alat replay deterministik dan analisis thread-interleaving untuk merekonstruksi urutan kejadian non-deterministik yang menyebabkan kerusakan.', b: 'Bagaimana Anda membuktikan bahwa race condition menyebabkan kegagalan sistem?'},
				{a: 'Saya telah membedah implementasi CUDA dan OpenCL yang kompleks untuk mengidentifikasi hambatan kinerja atau alokasi sumber daya yang tidak tepat.', b: 'Apa pengalaman Anda dengan sengketa komputasi terakselerasi GPU?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Komputasi Kinerja Tinggi (HPC) berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Komputasi Kinerja Tinggi (HPC)?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Komputasi Kinerja Tinggi (HPC) (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/hpc/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Komputasi Kinerja Tinggi (HPC) bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Komputasi Kinerja Tinggi (HPC)', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Komputasi Kinerja Tinggi (HPC) bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Komputasi Kinerja Tinggi (HPC) Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Sengketa High Performance Computing (HPC) melibatkan pemrosesan paralel yang kompleks, race conditions, dan efisiensi interkoneksi. Saya menyediakan analisis ahli untuk litigasi yang melibatkan klaster skala besar, akselerasi GPU (CUDA), dan arsitektur memori terdistribusi (MPI).', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Komputasi Kinerja Tinggi (HPC) | Arbitrase di Indonesia',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Analisis race conditions dalam pemrosesan paralel masif', 'Audit utilisasi klaster GPU dan efisiensi kernel CUDA', 'Analisis akar masalah hambatan interkoneksi dan MPI', 'Verifikasi tolok ukur kinerja SLA supercomputing', 'Investigasi kebocoran memori dalam arsitektur terdistribusi']),
		i: 'Jasa saksi ahli profesional spesialisasi Komputasi Kinerja Tinggi (HPC) untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya menggunakan alat replay deterministik dan analisis thread-interleaving untuk merekonstruksi urutan kejadian non-deterministik yang menyebabkan kerusakan.', b: 'Bagaimana Anda membuktikan bahwa race condition menyebabkan kegagalan sistem?'},
				{a: 'Saya telah membedah implementasi CUDA dan OpenCL yang kompleks untuk mengidentifikasi hambatan kinerja atau alokasi sumber daya yang tidak tepat.', b: 'Apa pengalaman Anda dengan sengketa komputasi terakselerasi GPU?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Komputasi Kinerja Tinggi (HPC) berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Komputasi Kinerja Tinggi (HPC)?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Komputasi Kinerja Tinggi (HPC) (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/hpc/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Komputasi Kinerja Tinggi (HPC) bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Komputasi Kinerja Tinggi (HPC)', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Komputasi Kinerja Tinggi (HPC) bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Komputasi Kinerja Tinggi (HPC) Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Sengketa High Performance Computing (HPC) melibatkan pemrosesan paralel yang kompleks, race conditions, dan efisiensi interkoneksi. Saya menyediakan analisis ahli untuk litigasi yang melibatkan klaster skala besar, akselerasi GPU (CUDA), dan arsitektur memori terdistribusi (MPI).', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Komputasi Kinerja Tinggi (HPC) | Litigasi Pengadilan di Indonesia',
		g: 'hpc'
	},
		{
		h: _List_fromArray(
			['Dekonstruksi logika penilaian dan pemeringkatan eksklusif', 'Audit transparansi algoritmik untuk perlindungan konsumen', 'Verifikasi model harga dinamis dan logika pembagian tarif', 'Analisis perilaku munculan (emergent) vs desain sengaja', 'Tinjauan teknis sistem pengambilan keputusan otomatis (ADM)']),
		i: 'Jasa saksi ahli profesional spesialisasi Algoritma & Logika untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya bekerja di lingkungan yang aman atau \'clean room\' untuk menganalisis logika, memberikan pemetaan konseptual kepada pengadilan tanpa mengungkap kode sumber literal ke publik.', b: 'Bagaimana Anda mengaudit algoritma \'Rahasia Dagang\' tanpa membocorkannya?'},
				{a: 'Meskipun algoritma bukan subjek hukum, saya menyediakan bukti teknis untuk menunjukkan apakah desainnya bias atau jika terjadi pelanggaran dalam pemilihan data.', b: 'Dapatkah algoritma dimintai pertanggungjawaban atas hasil diskriminatif?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Algoritma & Logika berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Algoritma & Logika?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Algoritma & Logika (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/algorithms/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Algoritma & Logika bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Algoritma & Logika', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Algoritma & Logika bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Algoritma & Logika Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Algoritma mengatur hidup kita, dari penilaian kredit hingga moderasi konten. Ketika aturan tak terlihat ini berujung pada litigasi, sengketa sering kali bergantung pada perbedaan antara \'desain yang disengaja\' dan \'perilaku yang muncul\'. Saya menjembatani celah tersebut.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Algoritma & Logika | Arbitrase di Indonesia',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Dekonstruksi logika penilaian dan pemeringkatan eksklusif', 'Audit transparansi algoritmik untuk perlindungan konsumen', 'Verifikasi model harga dinamis dan logika pembagian tarif', 'Analisis perilaku munculan (emergent) vs desain sengaja', 'Tinjauan teknis sistem pengambilan keputusan otomatis (ADM)']),
		i: 'Jasa saksi ahli profesional spesialisasi Algoritma & Logika untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya bekerja di lingkungan yang aman atau \'clean room\' untuk menganalisis logika, memberikan pemetaan konseptual kepada pengadilan tanpa mengungkap kode sumber literal ke publik.', b: 'Bagaimana Anda mengaudit algoritma \'Rahasia Dagang\' tanpa membocorkannya?'},
				{a: 'Meskipun algoritma bukan subjek hukum, saya menyediakan bukti teknis untuk menunjukkan apakah desainnya bias atau jika terjadi pelanggaran dalam pemilihan data.', b: 'Dapatkah algoritma dimintai pertanggungjawaban atas hasil diskriminatif?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Algoritma & Logika berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Algoritma & Logika?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Algoritma & Logika (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/algorithms/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Algoritma & Logika bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Algoritma & Logika', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Algoritma & Logika bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Algoritma & Logika Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Algoritma mengatur hidup kita, dari penilaian kredit hingga moderasi konten. Ketika aturan tak terlihat ini berujung pada litigasi, sengketa sering kali bergantung pada perbedaan antara \'desain yang disengaja\' dan \'perilaku yang muncul\'. Saya menjembatani celah tersebut.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Algoritma & Logika | Litigasi Pengadilan di Indonesia',
		g: 'algorithms'
	},
		{
		h: _List_fromArray(
			['Atribusi forensik kebocoran data dan vektor serangan', 'Penilaian \'Keamanan yang Wajar\' terhadap kerangka kerja NIST/CIS', 'Audit konfigurasi MFA dan manajemen identitas dalam insiden', 'Rekonstruksi lini masa dari log firewall, EDR, dan cloud', 'Laporan ahli tentang akurasi pengungkapan teknis SEC/UU PDP']),
		i: 'Jasa saksi ahli profesional spesialisasi Keamanan Siber & Kebocoran Data untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya mengevaluasi postur keamanan tergugat terhadap kerangka kerja yang diakui seperti NIST CSF atau CIS Controls relatif terhadap sensitivitas data yang dikelola.', b: 'Bagaimana Anda mendefinisikan \'Keamanan yang Wajar\' di pengadilan?'},
				{a: 'Ya, melalui analisis log mendalam dan artefak forensik, saya dapat menentukan apakah data hanya dilihat atau benar-benar dipindahkan dari jaringan.', b: 'Dapatkah Anda membedakan antara \'akses\' data dan \'ekstraksi\' data?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Keamanan Siber & Kebocoran Data berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Keamanan Siber & Kebocoran Data?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Keamanan Siber & Kebocoran Data (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/cybersecurity/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Keamanan Siber & Kebocoran Data bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Keamanan Siber & Kebocoran Data', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Keamanan Siber & Kebocoran Data bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Keamanan Siber & Kebocoran Data Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Kebocoran data jarang menjadi masalah \'jika\', melainkan \'kapan\'. Di pengadilan, pertanyaannya adalah \'apakah keamanan sudah sesuai standar industri?\'. Saya menyediakan audit forensik teknis untuk menentukan apakah langkah yang wajar telah diambil atau terjadi kelalaian berat.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Keamanan Siber & Kebocoran Data | Arbitrase di Indonesia',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Atribusi forensik kebocoran data dan vektor serangan', 'Penilaian \'Keamanan yang Wajar\' terhadap kerangka kerja NIST/CIS', 'Audit konfigurasi MFA dan manajemen identitas dalam insiden', 'Rekonstruksi lini masa dari log firewall, EDR, dan cloud', 'Laporan ahli tentang akurasi pengungkapan teknis SEC/UU PDP']),
		i: 'Jasa saksi ahli profesional spesialisasi Keamanan Siber & Kebocoran Data untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya mengevaluasi postur keamanan tergugat terhadap kerangka kerja yang diakui seperti NIST CSF atau CIS Controls relatif terhadap sensitivitas data yang dikelola.', b: 'Bagaimana Anda mendefinisikan \'Keamanan yang Wajar\' di pengadilan?'},
				{a: 'Ya, melalui analisis log mendalam dan artefak forensik, saya dapat menentukan apakah data hanya dilihat atau benar-benar dipindahkan dari jaringan.', b: 'Dapatkah Anda membedakan antara \'akses\' data dan \'ekstraksi\' data?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Keamanan Siber & Kebocoran Data berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Keamanan Siber & Kebocoran Data?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Keamanan Siber & Kebocoran Data (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/cybersecurity/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Keamanan Siber & Kebocoran Data bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Keamanan Siber & Kebocoran Data', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Keamanan Siber & Kebocoran Data bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Keamanan Siber & Kebocoran Data Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Kebocoran data jarang menjadi masalah \'jika\', melainkan \'kapan\'. Di pengadilan, pertanyaannya adalah \'apakah keamanan sudah sesuai standar industri?\'. Saya menyediakan audit forensik teknis untuk menentukan apakah langkah yang wajar telah diambil atau terjadi kelalaian berat.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Keamanan Siber & Kebocoran Data | Litigasi Pengadilan di Indonesia',
		g: 'cybersecurity'
	},
		{
		h: _List_fromArray(
			['Analisis akar masalah kegagalan integrasi ERP dan middleware', 'Audit sinkronisasi PIM dan integritas data inventaris', 'Pengujian beban kinerja dan verifikasi kapasitas daya tampung', 'Tinjauan teknis kepatuhan ADA (Aksesibilitas) dan PCI-DSS', 'Analisis kesenjangan antara fitur standar vs persyaratan khusus SOW']),
		i: 'Jasa saksi ahli profesional spesialisasi Sistem E-Commerce untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Biasanya karena peluruhan arsitektur sistemik di mana middleware tidak dapat menangani frekuensi sinkronisasi ERP, menyebabkan korupsi data.', b: 'Mengapa implementasi e-commerce skala besar sering gagal secara teknis?'},
				{a: 'Saya mengaudit persetujuan UAT dan log Stress Testing untuk melihat apakah risiko yang diketahui diabaikan sebelum tanggal peluncuran.', b: 'Bagaimana Anda mengevaluasi \'Reasonable Care\' dalam kegagalan peluncuran situs?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Sistem E-Commerce berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Sistem E-Commerce?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Sistem E-Commerce (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ecommerce/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Sistem E-Commerce bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Sistem E-Commerce', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Sistem E-Commerce bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Sistem E-Commerce Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Platform E-commerce bernilai jutaan dolar gagal bukan karena \'bug\', melainkan karena peluruhan arsitektur sistemik. Ketika implementasi runtuh, saya menyelidiki \'Standard of Care\' yang diberikan oleh vendor dibandingkan dengan persyaratan kontrak.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Sistem E-Commerce | Arbitrase di Indonesia',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Analisis akar masalah kegagalan integrasi ERP dan middleware', 'Audit sinkronisasi PIM dan integritas data inventaris', 'Pengujian beban kinerja dan verifikasi kapasitas daya tampung', 'Tinjauan teknis kepatuhan ADA (Aksesibilitas) dan PCI-DSS', 'Analisis kesenjangan antara fitur standar vs persyaratan khusus SOW']),
		i: 'Jasa saksi ahli profesional spesialisasi Sistem E-Commerce untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Biasanya karena peluruhan arsitektur sistemik di mana middleware tidak dapat menangani frekuensi sinkronisasi ERP, menyebabkan korupsi data.', b: 'Mengapa implementasi e-commerce skala besar sering gagal secara teknis?'},
				{a: 'Saya mengaudit persetujuan UAT dan log Stress Testing untuk melihat apakah risiko yang diketahui diabaikan sebelum tanggal peluncuran.', b: 'Bagaimana Anda mengevaluasi \'Reasonable Care\' dalam kegagalan peluncuran situs?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Sistem E-Commerce berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Sistem E-Commerce?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Sistem E-Commerce (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ecommerce/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Sistem E-Commerce bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Sistem E-Commerce', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Sistem E-Commerce bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Sistem E-Commerce Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Platform E-commerce bernilai jutaan dolar gagal bukan karena \'bug\', melainkan karena peluruhan arsitektur sistemik. Ketika implementasi runtuh, saya menyelidiki \'Standard of Care\' yang diberikan oleh vendor dibandingkan dengan persyaratan kontrak.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Sistem E-Commerce | Litigasi Pengadilan di Indonesia',
		g: 'ecommerce'
	},
		{
		h: _List_fromArray(
			['Audit forensik algoritma perutean dan logika pengiriman armada', 'Analisis otomasi gudang dan integritas data sensor IoT', 'Tinjauan teknis visibilitas rantai pasok dan sistem pelacakan', 'Analisis akar masalah pola keterlambatan pengiriman sistemik', 'Verifikasi klaim efisiensi optimasi pengiriman jarak terakhir']),
		i: 'Jasa saksi ahli profesional spesialisasi Logistik & Rantai Pasok untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya mengorelasikan data GPS, telemetri sensor, dan log API untuk merekonstruksi keadaan rantai pasok saat kejadian, mengidentifikasi di mana integritas data terganggu.', b: 'Bagaimana data IoT dapat digunakan sebagai bukti dalam sengketa logistik?'},
				{a: 'Saya telah mengaudit mesin pengiriman frekuensi tinggi untuk menentukan apakah logikanya memberikan keuntungan yang tidak adil atau gagal mematuhi SLA.', b: 'Apa pengalaman Anda dengan algoritma pengiriman \'Last-Mile\'?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Logistik & Rantai Pasok berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Logistik & Rantai Pasok?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Logistik & Rantai Pasok (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/logistics/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Logistik & Rantai Pasok bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Logistik & Rantai Pasok', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Logistik & Rantai Pasok bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Logistik & Rantai Pasok Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Sistem logistik adalah saraf perdagangan global. Ketika algoritma perutean gagal atau otomasi gudang bermasalah, gangguan rantai pasok yang dihasilkan sangat fatal. Saya menyediakan analisis akar masalah untuk kegagalan kompleks ini.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Logistik & Rantai Pasok | Arbitrase di Indonesia',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit forensik algoritma perutean dan logika pengiriman armada', 'Analisis otomasi gudang dan integritas data sensor IoT', 'Tinjauan teknis visibilitas rantai pasok dan sistem pelacakan', 'Analisis akar masalah pola keterlambatan pengiriman sistemik', 'Verifikasi klaim efisiensi optimasi pengiriman jarak terakhir']),
		i: 'Jasa saksi ahli profesional spesialisasi Logistik & Rantai Pasok untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya mengorelasikan data GPS, telemetri sensor, dan log API untuk merekonstruksi keadaan rantai pasok saat kejadian, mengidentifikasi di mana integritas data terganggu.', b: 'Bagaimana data IoT dapat digunakan sebagai bukti dalam sengketa logistik?'},
				{a: 'Saya telah mengaudit mesin pengiriman frekuensi tinggi untuk menentukan apakah logikanya memberikan keuntungan yang tidak adil atau gagal mematuhi SLA.', b: 'Apa pengalaman Anda dengan algoritma pengiriman \'Last-Mile\'?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Logistik & Rantai Pasok berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Logistik & Rantai Pasok?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Logistik & Rantai Pasok (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/logistics/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Logistik & Rantai Pasok bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Logistik & Rantai Pasok', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Logistik & Rantai Pasok bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Logistik & Rantai Pasok Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Sistem logistik adalah saraf perdagangan global. Ketika algoritma perutean gagal atau otomasi gudang bermasalah, gangguan rantai pasok yang dihasilkan sangat fatal. Saya menyediakan analisis akar masalah untuk kegagalan kompleks ini.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Logistik & Rantai Pasok | Litigasi Pengadilan di Indonesia',
		g: 'logistics'
	},
		{
		h: _List_fromArray(
			['Audit manajemen inventaris real-time dan API latensi rendah', 'Verifikasi logika pengumpulan (batching) dan pengiriman otomatis', 'Analisis mesin perhitungan insentif dan pembayaran dinamis', 'Tinjauan teknis otomasi \'dark store\' dan sistem pengambilan barang', 'Penilaian uptime sistem dan kinerja selama puncak permintaan']),
		i: 'Jasa saksi ahli profesional spesialisasi Q-Commerce & Pengantaran Makanan untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya melakukan analisis korelasi timestamp di seluruh microservices terdistribusi untuk mengidentifikasi di mana \'race conditions\' atau timeout API menyebabkan kegagalan pengiriman.', b: 'Bagaimana Anda mengaudit sistem Q-commerce yang sensitif milidetik?'},
				{a: 'Ini menentukan tanggung jawab dalam sengketa pekerja gig; saya menyediakan bukti teknis tentang bagaimana algoritma \'mengelola\' pekerja, yang krusial bagi litigasi status kerja.', b: 'Apa relevansi hukum dari \'Pengiriman Algoritmik\'?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Q-Commerce & Pengantaran Makanan berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Q-Commerce & Pengantaran Makanan?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Q-Commerce & Pengantaran Makanan (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/qcommerce/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Q-Commerce & Pengantaran Makanan bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Q-Commerce & Pengantaran Makanan', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Q-Commerce & Pengantaran Makanan bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Q-Commerce & Pengantaran Makanan Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Dalam Q-commerce, milidetik adalah uang. Sengketa sering muncul seputar pengiriman algoritmik dan model pembayaran dinamis. Saya membantu tim hukum memahami bagaimana sistem frekuensi tinggi ini sebenarnya beroperasi.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Q-Commerce & Pengantaran Makanan | Arbitrase di Indonesia',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Audit manajemen inventaris real-time dan API latensi rendah', 'Verifikasi logika pengumpulan (batching) dan pengiriman otomatis', 'Analisis mesin perhitungan insentif dan pembayaran dinamis', 'Tinjauan teknis otomasi \'dark store\' dan sistem pengambilan barang', 'Penilaian uptime sistem dan kinerja selama puncak permintaan']),
		i: 'Jasa saksi ahli profesional spesialisasi Q-Commerce & Pengantaran Makanan untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Saya melakukan analisis korelasi timestamp di seluruh microservices terdistribusi untuk mengidentifikasi di mana \'race conditions\' atau timeout API menyebabkan kegagalan pengiriman.', b: 'Bagaimana Anda mengaudit sistem Q-commerce yang sensitif milidetik?'},
				{a: 'Ini menentukan tanggung jawab dalam sengketa pekerja gig; saya menyediakan bukti teknis tentang bagaimana algoritma \'mengelola\' pekerja, yang krusial bagi litigasi status kerja.', b: 'Apa relevansi hukum dari \'Pengiriman Algoritmik\'?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Q-Commerce & Pengantaran Makanan berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Q-Commerce & Pengantaran Makanan?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Q-Commerce & Pengantaran Makanan (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/qcommerce/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Q-Commerce & Pengantaran Makanan bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Q-Commerce & Pengantaran Makanan', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Q-Commerce & Pengantaran Makanan bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Q-Commerce & Pengantaran Makanan Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Dalam Q-commerce, milidetik adalah uang. Sengketa sering muncul seputar pengiriman algoritmik dan model pembayaran dinamis. Saya membantu tim hukum memahami bagaimana sistem frekuensi tinggi ini sebenarnya beroperasi.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Q-Commerce & Pengantaran Makanan | Litigasi Pengadilan di Indonesia',
		g: 'qcommerce'
	},
		{
		h: _List_fromArray(
			['Analisis algoritma surge pricing dan pencocokan permintaan-pasokan', 'Audit forensik deaktivasi pengemudi dan logika deteksi penipuan', 'Tinjauan teknis pelacakan GPS dan akurasi pembagian tarif', 'Audit kepatuhan platform terhadap hukum tenaga kerja dan transportasi', 'Verifikasi protokol keselamatan dan pemicu darurat otomatis']),
		i: 'Jasa saksi ahli profesional spesialisasi Ride-Hailing & Ekonomi Gig untuk perkara Arbitrase di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Ya, dengan menganalisis log mesin deteksi penipuan dan parameter pohon keputusan spesifik yang memicu deaktivasi tersebut.', b: 'Dapatkah Anda membuktikan jika pengemudi dinonaktifkan secara otomatis tanpa sebab?'},
				{a: 'Saya mengaudit data telemetri permintaan real-time versus output mesin harga untuk memastikan tidak ada manipulasi sistem yang disengaja.', b: 'Bagaimana Anda memverifikasi transparansi \'Surge Pricing\'?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Ride-Hailing & Ekonomi Gig berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Ride-Hailing & Ekonomi Gig?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'arbitration',
		k: 'Saksi Ahli Ride-Hailing & Ekonomi Gig (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ridehailing/arbitration',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Ride-Hailing & Ekonomi Gig bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Ride-Hailing & Ekonomi Gig', p: 'Saya memahami bahwa dalam Arbitrase, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Ride-Hailing & Ekonomi Gig bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Ride-Hailing & Ekonomi Gig Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Ekonomi Gig dibangun di atas manajemen algoritmik. Dari penonaktifan otomatis hingga logika pembagian tarif, saya menyediakan keahlian teknis untuk menganalisis apakah sistem ini mematuhi standar kerja platform.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Arbitrase tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Arbitrase, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Ride-Hailing & Ekonomi Gig | Arbitrase di Indonesia',
		g: 'ridehailing'
	},
		{
		h: _List_fromArray(
			['Analisis algoritma surge pricing dan pencocokan permintaan-pasokan', 'Audit forensik deaktivasi pengemudi dan logika deteksi penipuan', 'Tinjauan teknis pelacakan GPS dan akurasi pembagian tarif', 'Audit kepatuhan platform terhadap hukum tenaga kerja dan transportasi', 'Verifikasi protokol keselamatan dan pemicu darurat otomatis']),
		i: 'Jasa saksi ahli profesional spesialisasi Ride-Hailing & Ekonomi Gig untuk perkara Litigasi Pengadilan di Indonesia. Berpengalaman dengan BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.',
		j: _List_fromArray(
			[
				{a: 'Ya, dengan menganalisis log mesin deteksi penipuan dan parameter pohon keputusan spesifik yang memicu deaktivasi tersebut.', b: 'Dapatkah Anda membuktikan jika pengemudi dinonaktifkan secara otomatis tanpa sebab?'},
				{a: 'Saya mengaudit data telemetri permintaan real-time versus output mesin harga untuk memastikan tidak ada manipulasi sistem yang disengaja.', b: 'Bagaimana Anda memverifikasi transparansi \'Surge Pricing\'?'},
				{a: 'Saya memiliki lebih dari 15 tahun pengalaman teknik. Saat ini saya bekerja di FareHarbor (Booking.com) dan sebelumnya pernah bekerja di Bol.com, Picnic, Glovo, Mekari, ErudiFi/Danacita, Gojek, Midtrans, Open Learning Exchange, Microsoft, dan Delivery Hero, membangun sistem Ride-Hailing & Ekonomi Gig berskala besar.', b: 'Apa pengalaman spesifik Anda dalam bidang Ride-Hailing & Ekonomi Gig?'},
				{a: 'Saya memberikan keterangan sebagai Saksi Ahli profesional independen. Kredibilitas saya didasarkan pada latar belakang akademis (UGM/ITB) dan pengalaman praktis global (Microsoft/CTO).', b: 'Apakah Anda terdaftar sebagai ahli di pengadilan Indonesia?'},
				{a: 'Saya menggunakan metode analisis statis dan dinamis untuk mengidentifikasi kemiripan substansial, pelanggaran algoritma, atau keberadaan kode pihak ketiga dalam sengketa HAKI.', b: 'Bagaimana Anda melakukan audit forensik kode sumber?'},
				{a: 'Tinjauan awal memakan waktu 5-7 hari. Penyusunan laporan ahli formal biasanya membutuhkan waktu 3-5 minggu tergantung kompleksitas bukti.', b: 'Berapa lama waktu yang dibutuhkan untuk menyusun BAP Ahli?'},
				{a: 'Sangat memahami. Saya memastikan integritas bukti elektronik terjaga sesuai dengan standar hukum acara dan persyaratan UU ITE di Indonesia.', b: 'Apakah Anda memahami standar alat bukti UU ITE?'},
				{a: 'Ya, ini adalah spesialisasi saya. Saya mampu menerjemahkan bahasa teknis yang kompleks menjadi penjelasan yang logis dan mudah dipahami oleh penegak hukum.', b: 'Dapatkah Anda menjelaskan algoritma rumit kepada Majelis Hakim?'},
				{a: 'Saya mewajibkan penyebutan seluruh pihak yang bersengketa sebelum menerima penugasan untuk memastikan independensi saya sebagai ahli.', b: 'Bagaimana prosedur pengecekan konflik kepentingan?'},
				{a: 'Ya, saya dapat memberikan pendapat ahli sejak tahap pemeriksaan di kepolisian hingga persidangan di pengadilan.', b: 'Apakah Anda bisa membantu dalam tahap penyidikan?'}
			]),
		d: 'court',
		k: 'Saksi Ahli Ride-Hailing & Ekonomi Gig (Indonesia)',
		c: 'id',
		e: 'id',
		f: 'id/ridehailing/court',
		l: {
			n: 'Hindari risiko ahli yang tidak dapat bertahan dalam pemeriksaan silang atau gagal menerjemahkan Ride-Hailing & Ekonomi Gig bagi hakim.',
			o: 'Hubungi untuk Penugasan Ahli',
			r: {m: 'Full Stack Engineer di Booking.com\'s FareHarbor; sebelumnya bol.com, Picnic dan Delivery Hero\'s Glovo; dua tahun merekrut dan memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari. | MS Artificial Intelligence, Udacity Institute of AI & Technology (Woolf, terakreditasi UE), 2026 | Program Profesi Insinyur (Ir.), Informatika, ITB, 2026 | Sarjana Teknik Nuklir & Fisika Teknik, UGM, 2017 — riset HPC terpublikasi | MSc Cyber Security, Royal Holloway (sedang berjalan) | MS Data Center Engineering, HELHa Belgia (sedang berjalan) | Kandidat PhD Matematika & Explainable AI, GCAS College Dublin (Woolf, terakreditasi UE) | Kandidat LLB, Universitas Siber Muhammadiyah (2027) | Spesialisasi: Ride-Hailing & Ekonomi Gig', p: 'Saya memahami bahwa dalam Litigasi Pengadilan, satu kesalahpahaman teknis dapat membahayakan seluruh kasus Anda.'},
			s: 'Tim hukum yang menangani sengketa Ride-Hailing & Ekonomi Gig bernilai tinggi di Indonesia',
			v: _List_fromArray(
				['Tinjauan Teknis: Menilai kekuatan dan kelemahan bukti Ride-Hailing & Ekonomi Gig Anda.', 'Forensik Mendalam: Menganalisis kode sumber, log, dan perilaku sistem di Indonesia.', 'Laporan Ahli: Menyusun dokumen bukti yang kuat untuk BANI (Badan Arbitrase Nasional Indonesia), Pengadilan Niaga (Commercial Court), Pengadilan Negeri.']),
			w: {q: 'Ekonomi Gig dibangun di atas manajemen algoritmik. Dari penonaktifan otomatis hingga logika pembagian tarif, saya menyediakan keahlian teknis untuk menganalisis apakah sistem ini mematuhi standar kerja platform.', t: 'Kesulitan menemukan ahli yang dapat menjelaskan kebenaran teknis kepada Litigasi Pengadilan tanpa terjebak dalam jargon.', u: 'Di dunia yang dijalankan oleh kode, keadilan harus dipandu oleh mereka yang benar-benar memahami cara kerja kode tersebut.'},
			x: 'Kejelasan teknis di Litigasi Pengadilan, menuju putusan yang didasarkan pada kebenaran fakta engineering.'
		},
		I: 'Saksi Ahli Ride-Hailing & Ekonomi Gig | Litigasi Pengadilan di Indonesia',
		g: 'ridehailing'
	}
	]);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$LegalPages$getByHierarchy = F4(
	function (lang, region, topic, forum) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(p.c, lang) && (_Utils_eq(p.e, region) && (_Utils_eq(p.g, topic) && _Utils_eq(p.d, forum)));
				},
				$author$project$Data$LegalPages$allPages));
	});
var $author$project$Data$LegalPages$getBySlug = function (slug) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(p.f, slug);
			},
			$author$project$Data$LegalPages$allPages));
};
var $author$project$Data$SeoPages$allPages = _List_fromArray(
	[
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Python skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Python.', b: 'What level of Python proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Python memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Python code naturally testable.', b: 'How do you teach Python testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Python performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Python ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Python?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Python.', b: 'Do you help with Python-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Python Engineer level?'}
			]),
		k: 'Master Python with a Booking.com Engineer & Former Engineering Manager',
		f: 'python',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Python while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Python at a professional level.',
			v: _List_fromArray(
				['Identify your Python knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Python features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Python.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Python code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Python Mentor | 1-on-1 Python Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Java skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Java.', b: 'What level of Java proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Java memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Java code naturally testable.', b: 'How do you teach Java testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Java performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Java ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Java?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Java.', b: 'Do you help with Java-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Java Engineer level?'}
			]),
		k: 'Master Java with a Booking.com Engineer & Former Engineering Manager',
		f: 'java',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Java while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Java at a professional level.',
			v: _List_fromArray(
				['Identify your Java knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Java features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Java.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Java code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Java Mentor | 1-on-1 Java Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Kotlin skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Kotlin.', b: 'What level of Kotlin proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Kotlin memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Kotlin code naturally testable.', b: 'How do you teach Kotlin testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Kotlin performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Kotlin ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Kotlin?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Kotlin.', b: 'Do you help with Kotlin-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Kotlin Engineer level?'}
			]),
		k: 'Master Kotlin with a Booking.com Engineer & Former Engineering Manager',
		f: 'kotlin',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Kotlin while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Kotlin at a professional level.',
			v: _List_fromArray(
				['Identify your Kotlin knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Kotlin features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Kotlin.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Kotlin code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Kotlin Mentor | 1-on-1 Kotlin Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Go skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Go.', b: 'What level of Go proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Go memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Go code naturally testable.', b: 'How do you teach Go testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Go performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Go ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Go?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Go.', b: 'Do you help with Go-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Go Engineer level?'}
			]),
		k: 'Master Go with a Booking.com Engineer & Former Engineering Manager',
		f: 'go',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Go while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Go at a professional level.',
			v: _List_fromArray(
				['Identify your Go knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Go features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Go.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Go code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Go Mentor | 1-on-1 Go Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your TypeScript skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using TypeScript.', b: 'What level of TypeScript proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover TypeScript memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make TypeScript code naturally testable.', b: 'How do you teach TypeScript testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at TypeScript performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the TypeScript ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in TypeScript?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in TypeScript.', b: 'Do you help with TypeScript-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff TypeScript Engineer level?'}
			]),
		k: 'Master TypeScript with a Booking.com Engineer & Former Engineering Manager',
		f: 'typescript',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with TypeScript while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master TypeScript at a professional level.',
			v: _List_fromArray(
				['Identify your TypeScript knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex TypeScript features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" TypeScript.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade TypeScript code with total confidence and lead your team\'s technical direction.'
		},
		I: 'TypeScript Mentor | 1-on-1 TypeScript Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your JavaScript skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using JavaScript.', b: 'What level of JavaScript proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover JavaScript memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make JavaScript code naturally testable.', b: 'How do you teach JavaScript testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at JavaScript performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the JavaScript ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in JavaScript?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in JavaScript.', b: 'Do you help with JavaScript-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff JavaScript Engineer level?'}
			]),
		k: 'Master JavaScript with a Booking.com Engineer & Former Engineering Manager',
		f: 'javascript',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with JavaScript while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master JavaScript at a professional level.',
			v: _List_fromArray(
				['Identify your JavaScript knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex JavaScript features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" JavaScript.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade JavaScript code with total confidence and lead your team\'s technical direction.'
		},
		I: 'JavaScript Mentor | 1-on-1 JavaScript Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Rust skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Rust.', b: 'What level of Rust proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Rust memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Rust code naturally testable.', b: 'How do you teach Rust testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Rust performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Rust ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Rust?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Rust.', b: 'Do you help with Rust-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Rust Engineer level?'}
			]),
		k: 'Master Rust with a Booking.com Engineer & Former Engineering Manager',
		f: 'rust',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Rust while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Rust at a professional level.',
			v: _List_fromArray(
				['Identify your Rust knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Rust features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Rust.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Rust code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Rust Mentor | 1-on-1 Rust Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your C# skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using C#.', b: 'What level of C# proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover C# memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make C# code naturally testable.', b: 'How do you teach C# testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at C# performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the C# ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in C#?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in C#.', b: 'Do you help with C#-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff C# Engineer level?'}
			]),
		k: 'Master C# with a Booking.com Engineer & Former Engineering Manager',
		f: 'c',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with C# while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master C# at a professional level.',
			v: _List_fromArray(
				['Identify your C# knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex C# features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" C#.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade C# code with total confidence and lead your team\'s technical direction.'
		},
		I: 'C# Mentor | 1-on-1 C# Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Ruby skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Ruby.', b: 'What level of Ruby proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Ruby memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Ruby code naturally testable.', b: 'How do you teach Ruby testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Ruby performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Ruby ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Ruby?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Ruby.', b: 'Do you help with Ruby-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Ruby Engineer level?'}
			]),
		k: 'Master Ruby with a Booking.com Engineer & Former Engineering Manager',
		f: 'ruby',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Ruby while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Ruby at a professional level.',
			v: _List_fromArray(
				['Identify your Ruby knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Ruby features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Ruby.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Ruby code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Ruby Mentor | 1-on-1 Ruby Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Swift skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Swift.', b: 'What level of Swift proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Swift memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Swift code naturally testable.', b: 'How do you teach Swift testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Swift performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Swift ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Swift?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Swift.', b: 'Do you help with Swift-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Swift Engineer level?'}
			]),
		k: 'Master Swift with a Booking.com Engineer & Former Engineering Manager',
		f: 'swift',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Swift while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Swift at a professional level.',
			v: _List_fromArray(
				['Identify your Swift knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Swift features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Swift.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Swift code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Swift Mentor | 1-on-1 Swift Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Scala skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Scala.', b: 'What level of Scala proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Scala memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Scala code naturally testable.', b: 'How do you teach Scala testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Scala performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Scala ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Scala?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Scala.', b: 'Do you help with Scala-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Scala Engineer level?'}
			]),
		k: 'Master Scala with a Booking.com Engineer & Former Engineering Manager',
		f: 'scala',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Scala while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Scala at a professional level.',
			v: _List_fromArray(
				['Identify your Scala knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Scala features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Scala.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Scala code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Scala Mentor | 1-on-1 Scala Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your Elixir skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using Elixir.', b: 'What level of Elixir proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover Elixir memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make Elixir code naturally testable.', b: 'How do you teach Elixir testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at Elixir performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the Elixir ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in Elixir?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in Elixir.', b: 'Do you help with Elixir-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff Elixir Engineer level?'}
			]),
		k: 'Master Elixir with a Booking.com Engineer & Former Engineering Manager',
		f: 'elixir',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Elixir while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master Elixir at a professional level.',
			v: _List_fromArray(
				['Identify your Elixir knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex Elixir features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" Elixir.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade Elixir code with total confidence and lead your team\'s technical direction.'
		},
		I: 'Elixir Mentor | 1-on-1 Elixir Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Pair Programming', 'Deep-dive Code Reviews', 'Performance Profiling', 'Idiomatic Pattern Analysis', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your PHP skills with personalized mentorship from an engineer at Booking.com\'s FareHarbor and former Engineering Manager. Focus on clean code, idiomatic patterns, and scalable systems.',
		j: _List_fromArray(
			[
				{a: 'My mentorship is tailored for intermediate to senior developers who want to deepen their architectural and system design skills using PHP.', b: 'What level of PHP proficiency is required?'},
				{a: 'Yes, we dive into the internal garbage collection, memory allocation, and how to write memory-efficient code for high-performance applications.', b: 'Do we cover PHP memory management?'},
				{a: 'We focus on standard testing frameworks, property-based testing, and architectural patterns that make PHP code naturally testable.', b: 'How do you teach PHP testing?'},
				{a: 'Absolutely. Mastering concurrency, threading models, and avoiding race conditions is a core senior skill we cover extensively.', b: 'Is async/concurrent programming part of the curriculum?'},
				{a: 'We use industry-standard profiling tools to identify memory leaks, CPU bottlenecks, and optimize execution speed.', b: 'Do we look at PHP performance profiling?'},
				{a: 'We explore the best linters, formatters, and build tools to ensure your development environment is fast and reproducible.', b: 'What about the PHP ecosystem and tooling?'},
				{a: 'We move beyond basic package managers to ensure reproducible builds and secure dependency supply chains.', b: 'How do you handle dependency management in PHP?'},
				{a: 'Yes, deep, line-by-line code reviews are the heart of the mentorship, focusing on readability and maintainability.', b: 'Is code review included?'},
				{a: 'Yes, we discuss how to architect large-scale monoliths and microservices using Domain-Driven Design (DDD) in PHP.', b: 'Do you help with PHP-based system design?'},
				{a: 'Yes, my program is specifically designed to bridge the gap between mid-level coding and senior architectural leadership.', b: 'Can you help me reach Senior/Staff PHP Engineer level?'}
			]),
		k: 'Master PHP with a Booking.com Engineer & Former Engineering Manager',
		f: 'php',
		l: {
			n: 'Don\'t stay stuck as a mid-level dev while others land Staff Engineer roles and $200k+ packages.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with PHP while delivering high-quality code.'},
			s: 'An ambitious Software Engineer aiming to master PHP at a professional level.',
			v: _List_fromArray(
				['Identify your PHP knowledge gaps through a deep-dive code review.', 'Execute a personalized learning roadmap focused on senior-level patterns.', 'Apply your skills to real-world architectural challenges with direct feedback.']),
			w: {q: 'Struggling with complex PHP features, concurrency, and high-performance requirements.', t: 'Feeling that you\'re not good enough or worrying you\'re not writing \"idiomatic\" PHP.', u: 'You shouldn\'t have to spend years of trial and error to learn what a mentor can teach you in weeks.'},
			x: 'Write production-grade PHP code with total confidence and lead your team\'s technical direction.'
		},
		I: 'PHP Mentor | 1-on-1 PHP Coaching & Mentorship | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Spring Boot, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Spring Boot ecosystem and best practices.', b: 'What is the core focus of Spring Boot mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Spring Boot.', b: 'How do you handle Spring Boot security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Spring Boot?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Spring Boot?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Spring Boot performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Spring Boot?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Spring Boot?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Spring Boot roles?'}
			]),
		k: 'Master Spring Boot and Advanced Architecture',
		f: 'spring-boot',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Spring Boot while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Spring Boot.',
			v: _List_fromArray(
				['Audit your current Spring Boot projects for architectural bottlenecks.', 'Master advanced Spring Boot patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Spring Boot applications.', t: 'Feeling overwhelmed by the \"magic\" of Spring Boot and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Spring Boot expert your organization relies on for critical system decisions.'
		},
		I: 'Spring Boot Mentor | Expert Spring Boot Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Node.js, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Node.js ecosystem and best practices.', b: 'What is the core focus of Node.js mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Node.js.', b: 'How do you handle Node.js security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Node.js?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Node.js?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Node.js performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Node.js?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Node.js?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Node.js roles?'}
			]),
		k: 'Master Node.js and Advanced Architecture',
		f: 'node-js',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Node.js while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Node.js.',
			v: _List_fromArray(
				['Audit your current Node.js projects for architectural bottlenecks.', 'Master advanced Node.js patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Node.js applications.', t: 'Feeling overwhelmed by the \"magic\" of Node.js and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Node.js expert your organization relies on for critical system decisions.'
		},
		I: 'Node.js Mentor | Expert Node.js Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master React, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full React ecosystem and best practices.', b: 'What is the core focus of React mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to React.', b: 'How do you handle React security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in React?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in React?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle React performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for React?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with React?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for React roles?'}
			]),
		k: 'Master React and Advanced Architecture',
		f: 'react',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with React while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with React.',
			v: _List_fromArray(
				['Audit your current React projects for architectural bottlenecks.', 'Master advanced React patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling React applications.', t: 'Feeling overwhelmed by the \"magic\" of React and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the React expert your organization relies on for critical system decisions.'
		},
		I: 'React Mentor | Expert React Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Vue.js, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Vue.js ecosystem and best practices.', b: 'What is the core focus of Vue.js mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Vue.js.', b: 'How do you handle Vue.js security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Vue.js?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Vue.js?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Vue.js performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Vue.js?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Vue.js?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Vue.js roles?'}
			]),
		k: 'Master Vue.js and Advanced Architecture',
		f: 'vue-js',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Vue.js while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Vue.js.',
			v: _List_fromArray(
				['Audit your current Vue.js projects for architectural bottlenecks.', 'Master advanced Vue.js patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Vue.js applications.', t: 'Feeling overwhelmed by the \"magic\" of Vue.js and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Vue.js expert your organization relies on for critical system decisions.'
		},
		I: 'Vue.js Mentor | Expert Vue.js Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Angular, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Angular ecosystem and best practices.', b: 'What is the core focus of Angular mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Angular.', b: 'How do you handle Angular security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Angular?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Angular?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Angular performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Angular?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Angular?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Angular roles?'}
			]),
		k: 'Master Angular and Advanced Architecture',
		f: 'angular',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Angular while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Angular.',
			v: _List_fromArray(
				['Audit your current Angular projects for architectural bottlenecks.', 'Master advanced Angular patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Angular applications.', t: 'Feeling overwhelmed by the \"magic\" of Angular and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Angular expert your organization relies on for critical system decisions.'
		},
		I: 'Angular Mentor | Expert Angular Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Django, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Django ecosystem and best practices.', b: 'What is the core focus of Django mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Django.', b: 'How do you handle Django security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Django?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Django?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Django performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Django?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Django?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Django roles?'}
			]),
		k: 'Master Django and Advanced Architecture',
		f: 'django',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Django while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Django.',
			v: _List_fromArray(
				['Audit your current Django projects for architectural bottlenecks.', 'Master advanced Django patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Django applications.', t: 'Feeling overwhelmed by the \"magic\" of Django and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Django expert your organization relies on for critical system decisions.'
		},
		I: 'Django Mentor | Expert Django Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master FastAPI, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full FastAPI ecosystem and best practices.', b: 'What is the core focus of FastAPI mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to FastAPI.', b: 'How do you handle FastAPI security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in FastAPI?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in FastAPI?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle FastAPI performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for FastAPI?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with FastAPI?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for FastAPI roles?'}
			]),
		k: 'Master FastAPI and Advanced Architecture',
		f: 'fastapi',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with FastAPI while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with FastAPI.',
			v: _List_fromArray(
				['Audit your current FastAPI projects for architectural bottlenecks.', 'Master advanced FastAPI patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling FastAPI applications.', t: 'Feeling overwhelmed by the \"magic\" of FastAPI and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the FastAPI expert your organization relies on for critical system decisions.'
		},
		I: 'FastAPI Mentor | Expert FastAPI Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Flask, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Flask ecosystem and best practices.', b: 'What is the core focus of Flask mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Flask.', b: 'How do you handle Flask security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Flask?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Flask?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Flask performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Flask?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Flask?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Flask roles?'}
			]),
		k: 'Master Flask and Advanced Architecture',
		f: 'flask',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Flask while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Flask.',
			v: _List_fromArray(
				['Audit your current Flask projects for architectural bottlenecks.', 'Master advanced Flask patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Flask applications.', t: 'Feeling overwhelmed by the \"magic\" of Flask and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Flask expert your organization relies on for critical system decisions.'
		},
		I: 'Flask Mentor | Expert Flask Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Express.js, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Express.js ecosystem and best practices.', b: 'What is the core focus of Express.js mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Express.js.', b: 'How do you handle Express.js security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Express.js?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Express.js?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Express.js performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Express.js?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Express.js?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Express.js roles?'}
			]),
		k: 'Master Express.js and Advanced Architecture',
		f: 'express-js',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Express.js while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Express.js.',
			v: _List_fromArray(
				['Audit your current Express.js projects for architectural bottlenecks.', 'Master advanced Express.js patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Express.js applications.', t: 'Feeling overwhelmed by the \"magic\" of Express.js and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Express.js expert your organization relies on for critical system decisions.'
		},
		I: 'Express.js Mentor | Expert Express.js Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master NestJS, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full NestJS ecosystem and best practices.', b: 'What is the core focus of NestJS mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to NestJS.', b: 'How do you handle NestJS security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in NestJS?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in NestJS?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle NestJS performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for NestJS?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with NestJS?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for NestJS roles?'}
			]),
		k: 'Master NestJS and Advanced Architecture',
		f: 'nestjs',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with NestJS while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with NestJS.',
			v: _List_fromArray(
				['Audit your current NestJS projects for architectural bottlenecks.', 'Master advanced NestJS patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling NestJS applications.', t: 'Feeling overwhelmed by the \"magic\" of NestJS and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the NestJS expert your organization relies on for critical system decisions.'
		},
		I: 'NestJS Mentor | Expert NestJS Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Next.js, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Next.js ecosystem and best practices.', b: 'What is the core focus of Next.js mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Next.js.', b: 'How do you handle Next.js security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Next.js?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Next.js?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Next.js performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Next.js?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Next.js?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Next.js roles?'}
			]),
		k: 'Master Next.js and Advanced Architecture',
		f: 'next-js',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Next.js while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Next.js.',
			v: _List_fromArray(
				['Audit your current Next.js projects for architectural bottlenecks.', 'Master advanced Next.js patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Next.js applications.', t: 'Feeling overwhelmed by the \"magic\" of Next.js and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Next.js expert your organization relies on for critical system decisions.'
		},
		I: 'Next.js Mentor | Expert Next.js Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master GraphQL, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full GraphQL ecosystem and best practices.', b: 'What is the core focus of GraphQL mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to GraphQL.', b: 'How do you handle GraphQL security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in GraphQL?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in GraphQL?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle GraphQL performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for GraphQL?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with GraphQL?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for GraphQL roles?'}
			]),
		k: 'Master GraphQL and Advanced Architecture',
		f: 'graphql',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with GraphQL while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with GraphQL.',
			v: _List_fromArray(
				['Audit your current GraphQL projects for architectural bottlenecks.', 'Master advanced GraphQL patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling GraphQL applications.', t: 'Feeling overwhelmed by the \"magic\" of GraphQL and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the GraphQL expert your organization relies on for critical system decisions.'
		},
		I: 'GraphQL Mentor | Expert GraphQL Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Ruby on Rails, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Ruby on Rails ecosystem and best practices.', b: 'What is the core focus of Ruby on Rails mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Ruby on Rails.', b: 'How do you handle Ruby on Rails security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Ruby on Rails?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Ruby on Rails?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Ruby on Rails performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Ruby on Rails?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Ruby on Rails?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Ruby on Rails roles?'}
			]),
		k: 'Master Ruby on Rails and Advanced Architecture',
		f: 'ruby-on-rails',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Ruby on Rails while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Ruby on Rails.',
			v: _List_fromArray(
				['Audit your current Ruby on Rails projects for architectural bottlenecks.', 'Master advanced Ruby on Rails patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Ruby on Rails applications.', t: 'Feeling overwhelmed by the \"magic\" of Ruby on Rails and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Ruby on Rails expert your organization relies on for critical system decisions.'
		},
		I: 'Ruby on Rails Mentor | Expert Ruby on Rails Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master ASP.NET, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full ASP.NET ecosystem and best practices.', b: 'What is the core focus of ASP.NET mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to ASP.NET.', b: 'How do you handle ASP.NET security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in ASP.NET?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in ASP.NET?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle ASP.NET performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for ASP.NET?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with ASP.NET?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for ASP.NET roles?'}
			]),
		k: 'Master ASP.NET and Advanced Architecture',
		f: 'asp-net',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with ASP.NET while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with ASP.NET.',
			v: _List_fromArray(
				['Audit your current ASP.NET projects for architectural bottlenecks.', 'Master advanced ASP.NET patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling ASP.NET applications.', t: 'Feeling overwhelmed by the \"magic\" of ASP.NET and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the ASP.NET expert your organization relies on for critical system decisions.'
		},
		I: 'ASP.NET Mentor | Expert ASP.NET Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Laravel, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Laravel ecosystem and best practices.', b: 'What is the core focus of Laravel mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Laravel.', b: 'How do you handle Laravel security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Laravel?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Laravel?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Laravel performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Laravel?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Laravel?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Laravel roles?'}
			]),
		k: 'Master Laravel and Advanced Architecture',
		f: 'laravel',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Laravel while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Laravel.',
			v: _List_fromArray(
				['Audit your current Laravel projects for architectural bottlenecks.', 'Master advanced Laravel patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Laravel applications.', t: 'Feeling overwhelmed by the \"magic\" of Laravel and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Laravel expert your organization relies on for critical system decisions.'
		},
		I: 'Laravel Mentor | Expert Laravel Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Ktor, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Ktor ecosystem and best practices.', b: 'What is the core focus of Ktor mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Ktor.', b: 'How do you handle Ktor security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Ktor?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Ktor?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Ktor performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Ktor?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Ktor?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Ktor roles?'}
			]),
		k: 'Master Ktor and Advanced Architecture',
		f: 'ktor',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Ktor while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Ktor.',
			v: _List_fromArray(
				['Audit your current Ktor projects for architectural bottlenecks.', 'Master advanced Ktor patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Ktor applications.', t: 'Feeling overwhelmed by the \"magic\" of Ktor and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Ktor expert your organization relies on for critical system decisions.'
		},
		I: 'Ktor Mentor | Expert Ktor Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Quarkus, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Quarkus ecosystem and best practices.', b: 'What is the core focus of Quarkus mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Quarkus.', b: 'How do you handle Quarkus security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Quarkus?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Quarkus?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Quarkus performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Quarkus?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Quarkus?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Quarkus roles?'}
			]),
		k: 'Master Quarkus and Advanced Architecture',
		f: 'quarkus',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Quarkus while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Quarkus.',
			v: _List_fromArray(
				['Audit your current Quarkus projects for architectural bottlenecks.', 'Master advanced Quarkus patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Quarkus applications.', t: 'Feeling overwhelmed by the \"magic\" of Quarkus and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Quarkus expert your organization relies on for critical system decisions.'
		},
		I: 'Quarkus Mentor | Expert Quarkus Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Architecture Review', 'Module Design sessions', 'Security Best Practices Audit', 'Testing Strategy workshops', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Level up your engineering career. Master Elm, advanced design patterns, and building resilient systems with a Senior Mentor.',
		j: _List_fromArray(
			[
				{a: 'We focus on building production-ready applications using the full Elm ecosystem and best practices.', b: 'What is the core focus of Elm mentoring?'},
				{a: 'We implement robust authentication, authorization, and cover the OWASP Top 10 vulnerabilities specific to Elm.', b: 'How do you handle Elm security?'},
				{a: 'Yes, including performance tuning, complex querying, and reactive data access patterns.', b: 'Do we cover data access and ORMs?'},
				{a: 'We implement service discovery, circuit breakers, and distributed tracing to build resilient distributed systems.', b: 'What about microservices patterns in Elm?'},
				{a: 'Absolutely. We focus on unit, integration, and end-to-end testing using modern frameworks.', b: 'Do you teach testing in Elm?'},
				{a: 'We profile startup times, optimize caching layers, and ensure the application scales horizontally.', b: 'How do you handle Elm performance and scaling?'},
				{a: 'Yes, we look at containerization (Docker), orchestration (Kubernetes), and CI/CD pipelines.', b: 'Do we cover deployment for Elm?'},
				{a: 'We master environment variables, secret management, and externalized configuration for cloud environments.', b: 'How do you manage configuration and environments?'},
				{a: 'Yes, I help you decouple your domain logic from the framework to ensure long-term maintainability.', b: 'Do you advise on architectural patterns with Elm?'},
				{a: 'Yes, we do mock interviews specifically targeting deep framework knowledge and system design.', b: 'Can you help me pass technical interviews for Elm roles?'}
			]),
		k: 'Master Elm and Advanced Architecture',
		f: 'elm',
		l: {
			n: 'Avoid building \"technical debt\" that slows your team down and leads to burnout.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Elm while delivering high-quality code.'},
			s: 'A developer looking to build enterprise-scale applications with Elm.',
			v: _List_fromArray(
				['Audit your current Elm projects for architectural bottlenecks.', 'Master advanced Elm patterns through 1-on-1 pair programming.', 'Deploy a resilient, production-ready system following industry best practices.']),
			w: {q: 'Difficulty managing state, handling security, and scaling Elm applications.', t: 'Feeling overwhelmed by the \"magic\" of Elm and feeling like you\'re just copying tutorials.', u: 'Modern frameworks are complex, and you deserve a guide who knows how they work under the hood.'},
			x: 'Become the Elm expert your organization relies on for critical system decisions.'
		},
		I: 'Elm Mentor | Expert Elm Coaching | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master AWS, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of AWS coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for AWS.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on AWS and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with AWS',
		f: 'aws',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with AWS while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable AWS.',
			v: _List_fromArray(
				['Evaluate your AWS infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with AWS.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'AWS Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master GCP, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of GCP coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for GCP.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on GCP and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with GCP',
		f: 'gcp',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with GCP while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable GCP.',
			v: _List_fromArray(
				['Evaluate your GCP infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with GCP.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'GCP Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Azure, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Azure coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Azure.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Azure and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Azure',
		f: 'azure',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Azure while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Azure.',
			v: _List_fromArray(
				['Evaluate your Azure infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Azure.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Azure Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Kubernetes, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Kubernetes coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Kubernetes.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Kubernetes and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Kubernetes',
		f: 'kubernetes',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Kubernetes while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Kubernetes.',
			v: _List_fromArray(
				['Evaluate your Kubernetes infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Kubernetes.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Kubernetes Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Docker, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Docker coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Docker.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Docker and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Docker',
		f: 'docker',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Docker while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Docker.',
			v: _List_fromArray(
				['Evaluate your Docker infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Docker.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Docker Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Terraform, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Terraform coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Terraform.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Terraform and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Terraform',
		f: 'terraform',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Terraform while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Terraform.',
			v: _List_fromArray(
				['Evaluate your Terraform infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Terraform.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Terraform Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master CI/CD, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of CI/CD coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for CI/CD.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on CI/CD and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with CI/CD',
		f: 'ci-cd',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with CI/CD while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable CI/CD.',
			v: _List_fromArray(
				['Evaluate your CI/CD infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with CI/CD.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'CI/CD Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master DevOps, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of DevOps coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for DevOps.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on DevOps and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with DevOps',
		f: 'devops',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with DevOps while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable DevOps.',
			v: _List_fromArray(
				['Evaluate your DevOps infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with DevOps.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'DevOps Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master SRE, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of SRE coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for SRE.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on SRE and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with SRE',
		f: 'sre',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with SRE while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable SRE.',
			v: _List_fromArray(
				['Evaluate your SRE infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with SRE.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'SRE Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master GitHub Actions, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of GitHub Actions coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for GitHub Actions.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on GitHub Actions and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with GitHub Actions',
		f: 'github-actions',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with GitHub Actions while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable GitHub Actions.',
			v: _List_fromArray(
				['Evaluate your GitHub Actions infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with GitHub Actions.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'GitHub Actions Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master GitLab CI, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of GitLab CI coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for GitLab CI.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on GitLab CI and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with GitLab CI',
		f: 'gitlab-ci',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with GitLab CI while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable GitLab CI.',
			v: _List_fromArray(
				['Evaluate your GitLab CI infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with GitLab CI.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'GitLab CI Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Linux Administration, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Linux Administration coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Linux Administration.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Linux Administration and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Linux Administration',
		f: 'linux-administration',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Linux Administration while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Linux Administration.',
			v: _List_fromArray(
				['Evaluate your Linux Administration infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Linux Administration.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Linux Administration Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Prometheus, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Prometheus coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Prometheus.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Prometheus and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Prometheus',
		f: 'prometheus',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Prometheus while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Prometheus.',
			v: _List_fromArray(
				['Evaluate your Prometheus infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Prometheus.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Prometheus Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Grafana, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Grafana coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Grafana.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Grafana and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Grafana',
		f: 'grafana',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Grafana while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Grafana.',
			v: _List_fromArray(
				['Evaluate your Grafana infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Grafana.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Grafana Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Infrastructure-as-Code Audit', 'Cloud Cost Optimization', 'Kubernetes Configuration Review', 'CI/CD Pipeline Design', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Bridge the gap between code and production. Master Datadog, automation, and Cloud Infrastructure with a senior SRE.',
		j: _List_fromArray(
			[
				{a: 'The goal is to turn you into an engineer who can own the entire lifecycle of a product, from local dev to global production.', b: 'What is the goal of Datadog coaching?'},
				{a: 'Absolutely. Infrastructure cost optimization is a core part of architecture reviews, often resulting in significant savings.', b: 'Can you help reduce our cloud bill?'},
				{a: 'Yes, we master tools like Terraform to build versioned, reproducible infrastructure for Datadog.', b: 'Do you cover Infrastructure as Code (IaC)?'},
				{a: 'We design for multi-region active-active or active-passive setups based on strict RTO/RPO requirements.', b: 'How do you handle high availability?'},
				{a: 'We build advanced automated pipelines including canary deployments and security scanning gates.', b: 'What about CI/CD pipelines?'},
				{a: 'We implement the \'Three Pillars\': Metrics, Logging, and Distributed Tracing to ensure deep system visibility.', b: 'How do you handle observability?'},
				{a: 'Absolutely. We implement vulnerability scanning, secret management, and strict network policies from the start.', b: 'Do we look at security (DevSecOps)?'},
				{a: 'We look at automated backups, point-in-time recovery, and zero-downtime migration strategies.', b: 'How do you handle disaster recovery?'},
				{a: 'Yes, focusing on SLIs, SLOs, and Error Budgets to balance feature velocity with system stability.', b: 'Do you coach on the SRE mindset?'},
				{a: 'Yes, I offer hands-on workshops on Datadog and modern SRE practices for enterprise teams.', b: 'Do you provide training for our Ops team?'}
			]),
		k: 'Modernize Your Infrastructure with Datadog',
		f: 'datadog',
		l: {
			n: 'Stop firefighting and start building a future-proof platform.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Datadog while delivering high-quality code.'},
			s: 'A DevOps Engineer or Architect responsible for stable and scalable Datadog.',
			v: _List_fromArray(
				['Evaluate your Datadog infrastructure for reliability and cost-efficiency.', 'Implement Infrastructure-as-Code and automated CI/CD pipelines.', 'Establish SRE practices to ensure 99.9% uptime and developer autonomy.']),
			w: {q: 'Manual deployments, fragile infrastructure, and rising cloud costs with Datadog.', t: 'Stress from on-call rotations and the fear of \"the system going down.\"', u: 'Infrastructure should be an asset that enables speed, not a bottleneck that hinders it.'},
			x: 'A self-healing, automated infrastructure that scales effortlessly with your business.'
		},
		I: 'Datadog Consulting & Mentoring | DevOps Expert | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into PostgreSQL architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common PostgreSQL bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where PostgreSQL is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how PostgreSQL interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with PostgreSQL',
		f: 'postgresql',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with PostgreSQL while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with PostgreSQL performance.',
			v: _List_fromArray(
				['Run a comprehensive PostgreSQL performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'PostgreSQL Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into MongoDB architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common MongoDB bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where MongoDB is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how MongoDB interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with MongoDB',
		f: 'mongodb',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with MongoDB while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with MongoDB performance.',
			v: _List_fromArray(
				['Run a comprehensive MongoDB performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'MongoDB Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Redis architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Redis bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Redis is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Redis interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Redis',
		f: 'redis',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Redis while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Redis performance.',
			v: _List_fromArray(
				['Run a comprehensive Redis performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Redis Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Kafka architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Kafka bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Kafka is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Kafka interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Kafka',
		f: 'kafka',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Kafka while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Kafka performance.',
			v: _List_fromArray(
				['Run a comprehensive Kafka performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Kafka Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into RabbitMQ architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common RabbitMQ bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where RabbitMQ is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how RabbitMQ interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with RabbitMQ',
		f: 'rabbitmq',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with RabbitMQ while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with RabbitMQ performance.',
			v: _List_fromArray(
				['Run a comprehensive RabbitMQ performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'RabbitMQ Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Elasticsearch architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Elasticsearch bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Elasticsearch is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Elasticsearch interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Elasticsearch',
		f: 'elasticsearch',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Elasticsearch while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Elasticsearch performance.',
			v: _List_fromArray(
				['Run a comprehensive Elasticsearch performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Elasticsearch Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Cassandra architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Cassandra bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Cassandra is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Cassandra interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Cassandra',
		f: 'cassandra',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Cassandra while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Cassandra performance.',
			v: _List_fromArray(
				['Run a comprehensive Cassandra performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Cassandra Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into MySQL architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common MySQL bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where MySQL is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how MySQL interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with MySQL',
		f: 'mysql',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with MySQL while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with MySQL performance.',
			v: _List_fromArray(
				['Run a comprehensive MySQL performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'MySQL Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into DynamoDB architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common DynamoDB bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where DynamoDB is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how DynamoDB interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with DynamoDB',
		f: 'dynamodb',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with DynamoDB while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with DynamoDB performance.',
			v: _List_fromArray(
				['Run a comprehensive DynamoDB performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'DynamoDB Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Apache Spark architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Apache Spark bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Apache Spark is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Apache Spark interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Apache Spark',
		f: 'apache-spark',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Apache Spark while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Apache Spark performance.',
			v: _List_fromArray(
				['Run a comprehensive Apache Spark performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Apache Spark Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Snowflake architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Snowflake bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Snowflake is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Snowflake interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Snowflake',
		f: 'snowflake',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Snowflake while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Snowflake performance.',
			v: _List_fromArray(
				['Run a comprehensive Snowflake performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Snowflake Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Query Performance Tuning', 'Schema Design Review', 'High-Availability Strategy', 'Data Migration Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Deep-dive into Event Sourcing architecture, query optimization, indexing strategies, and high-availability setups.',
		j: _List_fromArray(
			[
				{a: 'Usually it\'s lack of proper indexing, N+1 query problems from the application, or inefficient schema design.', b: 'What are common Event Sourcing bottlenecks you find?'},
				{a: 'Yes, every database audit comes with a prioritized list of fixes, from quick query optimizations to long-term architectural changes.', b: 'Do you provide a remediation plan?'},
				{a: 'We use query execution plans, slow query logs, and performance schemas to find exactly where Event Sourcing is lagging.', b: 'How do you perform database profiling?'},
				{a: 'Yes, proper data modeling is step one. We ensure your schema matches your application\'s read/write access patterns.', b: 'Do you advise on data modeling?'},
				{a: 'We profile your database to find memory leaks and optimize connection pooling (e.g., using PgBouncer).', b: 'What about memory and connection management?'},
				{a: 'We implement zero-downtime migration strategies so you can alter schemas without locking tables in production.', b: 'How do you handle database migrations?'},
				{a: 'We look at how Event Sourcing interacts with distributed caches like Redis to minimize database load.', b: 'Do you audit the caching layer?'},
				{a: 'We look at continuous archiving and point-in-time recovery to ensure no data is ever permanently lost.', b: 'How do you optimize backup strategies?'},
				{a: 'I help you determine the most cost-effective path, exploring read replicas, sharding, and partitioning.', b: 'What is your approach to vertical vs horizontal scaling?'},
				{a: 'I help you set up specific alerts to ensure the bottlenecks don\'t return as your data volume grows.', b: 'Do you monitor the fixes post-audit?'}
			]),
		k: 'Scale Your Data Layer with Event Sourcing',
		f: 'event-sourcing',
		l: {
			n: 'Avoid downtime and data loss that could devastate your reputation.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Event Sourcing while delivering high-quality code.'},
			s: 'A Data Engineer or Backend Developer struggling with Event Sourcing performance.',
			v: _List_fromArray(
				['Run a comprehensive Event Sourcing performance audit to find slow queries.', 'Optimize schemas, indexes, and queries for maximum throughput.', 'Implement a robust monitoring and high-availability strategy.']),
			w: {q: 'Slow queries, data locks, and scaling issues as your user base grows.', t: 'Frustration with \"black box\" database behavior and reactive performance tuning.', u: 'Data is your most valuable asset; it shouldn\'t be your biggest bottleneck.'},
			x: 'A lightning-fast, resilient data layer that powers your application\'s growth.'
		},
		I: 'Event Sourcing Performance Tuning & Mentoring | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into System Design with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in System Design mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good System Design. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern System Design.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern System Design without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting System Design right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale System Design',
		f: 'system-design',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with System Design while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing System Design.',
			v: _List_fromArray(
				['Analyze your system requirements and current System Design constraints.', 'Map out a scalable System Design following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'System Design Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Microservices with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Microservices mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Microservices. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Microservices.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Microservices without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Microservices right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Microservices',
		f: 'microservices',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Microservices while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Microservices.',
			v: _List_fromArray(
				['Analyze your system requirements and current Microservices constraints.', 'Map out a scalable Microservices following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Microservices Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into API Design with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in API Design mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good API Design. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern API Design.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern API Design without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting API Design right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale API Design',
		f: 'api-design',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with API Design while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing API Design.',
			v: _List_fromArray(
				['Analyze your system requirements and current API Design constraints.', 'Map out a scalable API Design following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'API Design Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Backend Scalability with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Backend Scalability mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Backend Scalability. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Backend Scalability.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Backend Scalability without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Backend Scalability right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Backend Scalability',
		f: 'backend-scalability',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Backend Scalability while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Backend Scalability.',
			v: _List_fromArray(
				['Analyze your system requirements and current Backend Scalability constraints.', 'Map out a scalable Backend Scalability following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Backend Scalability Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Event-Driven Architecture with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Event-Driven Architecture mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Event-Driven Architecture. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Event-Driven Architecture.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Event-Driven Architecture without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Event-Driven Architecture right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Event-Driven Architecture',
		f: 'event-driven-architecture',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Event-Driven Architecture while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Event-Driven Architecture.',
			v: _List_fromArray(
				['Analyze your system requirements and current Event-Driven Architecture constraints.', 'Map out a scalable Event-Driven Architecture following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Event-Driven Architecture Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into REST API with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in REST API mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good REST API. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern REST API.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern REST API without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting REST API right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale REST API',
		f: 'rest-api',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with REST API while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing REST API.',
			v: _List_fromArray(
				['Analyze your system requirements and current REST API constraints.', 'Map out a scalable REST API following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'REST API Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Serverless Architecture with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Serverless Architecture mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Serverless Architecture. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Serverless Architecture.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Serverless Architecture without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Serverless Architecture right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Serverless Architecture',
		f: 'serverless-architecture',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Serverless Architecture while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Serverless Architecture.',
			v: _List_fromArray(
				['Analyze your system requirements and current Serverless Architecture constraints.', 'Map out a scalable Serverless Architecture following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Serverless Architecture Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Domain-Driven Design with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Domain-Driven Design mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Domain-Driven Design. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Domain-Driven Design.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Domain-Driven Design without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Domain-Driven Design right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Domain-Driven Design',
		f: 'domain-driven-design',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Domain-Driven Design while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Domain-Driven Design.',
			v: _List_fromArray(
				['Analyze your system requirements and current Domain-Driven Design constraints.', 'Map out a scalable Domain-Driven Design following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Domain-Driven Design Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Hexagonal Architecture with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Hexagonal Architecture mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Hexagonal Architecture. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Hexagonal Architecture.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Hexagonal Architecture without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Hexagonal Architecture right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Hexagonal Architecture',
		f: 'hexagonal-architecture',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Hexagonal Architecture while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Hexagonal Architecture.',
			v: _List_fromArray(
				['Analyze your system requirements and current Hexagonal Architecture constraints.', 'Map out a scalable Hexagonal Architecture following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Hexagonal Architecture Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into Cloud-Native with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in Cloud-Native mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good Cloud-Native. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern Cloud-Native.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern Cloud-Native without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting Cloud-Native right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale Cloud-Native',
		f: 'cloud-native',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Cloud-Native while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing Cloud-Native.',
			v: _List_fromArray(
				['Analyze your system requirements and current Cloud-Native constraints.', 'Map out a scalable Cloud-Native following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'Cloud-Native Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['System Design Whiteboarding', 'Trade-off Analysis Sessions', 'Microservices Decoupling', 'ADR (Architecture Decision Record) Writing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Design robust, scalable, and maintainable systems. Deep-dive into High Availability with a senior engineer who has built for millions of users.',
		j: _List_fromArray(
			[
				{a: 'Both. We use real-world architectural challenges to teach concepts that apply to both senior interviews and production systems.', b: 'Is this for interview prep or real-world application?'},
				{a: 'We cover decoupling logic, scaling state, managing distributed data, and designing for high availability.', b: 'What topics are covered in High Availability mentoring?'},
				{a: 'I use the \'Everything is a Trade-off\' framework to help you justify every component in your architecture.', b: 'How do we evaluate trade-offs?'},
				{a: 'Yes, clear contracts are the foundation of good High Availability. We cover versioning, backward compatibility, and documentation.', b: 'Do we discuss API contracts and boundaries?'},
				{a: 'We look at edge computing, CDNs, multi-region replication, and stateless service design.', b: 'How do we handle global scalability?'},
				{a: 'Absolutely. Designing for \'Operability\' (Tracing, Metrics, Logging) is a key part of modern High Availability.', b: 'Is observability part of the design?'},
				{a: 'We implement Zero Trust architecture, secure identity federation, and data-at-rest encryption from the start.', b: 'What about security in design?'},
				{a: 'We employ the Strangler Fig pattern to slowly extract functionality from monoliths into modern High Availability without downtime.', b: 'How do you handle legacy system migration?'},
				{a: 'Yes, identifying Bounded Contexts is critical for getting High Availability right and preventing distributed monoliths.', b: 'Do you help with DDD (Domain-Driven Design)?'},
				{a: 'We walk through the design of a real-world complex system from scratch, documenting decisions via ADRs.', b: 'Do we build a real project?'}
			]),
		k: 'Master High-Scale High Availability',
		f: 'high-availability',
		l: {
			n: 'Don\'t build a \"distributed monolith\" that\'s impossible to maintain.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with High Availability while delivering high-quality code.'},
			s: 'An aspiring Tech Lead or Software Architect designing High Availability.',
			v: _List_fromArray(
				['Analyze your system requirements and current High Availability constraints.', 'Map out a scalable High Availability following Domain-Driven Design principles.', 'Establish clear boundaries and communication patterns for your services.']),
			w: {q: 'Systems that are hard to change, difficult to scale, and prone to failure.', t: 'Indecision when faced with complex architectural trade-offs.', u: 'Great architecture isn\'t about the \"perfect\" solution; it\'s about the right trade-offs.'},
			x: 'A clear, documented architecture that empowers your team to move fast.'
		},
		I: 'High Availability Consultant & Mentor | Software Architecture | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Engineering Management coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Engineering Management and Technical Direction',
		f: 'engineering-management',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Engineering Management while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Engineering Management.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Engineering Management challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Engineering Management Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Tech Lead coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Tech Lead and Technical Direction',
		f: 'tech-lead',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Tech Lead while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Tech Lead.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Tech Lead challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Tech Lead Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Fractional CTO coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Fractional CTO and Technical Direction',
		f: 'fractional-cto',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Fractional CTO while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Fractional CTO.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Fractional CTO challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Fractional CTO Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is VP of Engineering coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic VP of Engineering and Technical Direction',
		f: 'vp-of-engineering',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with VP of Engineering while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into VP of Engineering.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current VP of Engineering challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'VP of Engineering Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Agile Leadership coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Agile Leadership and Technical Direction',
		f: 'agile-leadership',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Agile Leadership while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Agile Leadership.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Agile Leadership challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Agile Leadership Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Scrum Mastery coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Scrum Mastery and Technical Direction',
		f: 'scrum-mastery',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Scrum Mastery while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Scrum Mastery.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Scrum Mastery challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Scrum Mastery Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Remote Team Building coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Remote Team Building and Technical Direction',
		f: 'remote-team-building',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Remote Team Building while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Remote Team Building.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Remote Team Building challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Remote Team Building Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Tech Due Diligence coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Tech Due Diligence and Technical Direction',
		f: 'tech-due-diligence',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Tech Due Diligence while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Tech Due Diligence.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Tech Due Diligence challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Tech Due Diligence Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Developer Productivity coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Developer Productivity and Technical Direction',
		f: 'developer-productivity',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Developer Productivity while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Developer Productivity.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Developer Productivity challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Developer Productivity Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Startup MVP Development coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Startup MVP Development and Technical Direction',
		f: 'startup-mvp-development',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Startup MVP Development while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Startup MVP Development.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Startup MVP Development challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Startup MVP Development Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Fintech CTO coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Fintech CTO and Technical Direction',
		f: 'fintech-cto',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Fintech CTO while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Fintech CTO.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Fintech CTO challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Fintech CTO Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Management Strategy Coaching', 'Team Culture workshops', 'Stakeholder Communication training', 'Technical Strategy Planning', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Accelerate your leadership career. Learn how to manage high-performing teams, handle difficult conversations, and align tech with business strategy.',
		j: _List_fromArray(
			[
				{a: 'Technical mentoring focuses on code and architecture; leadership coaching focuses on people, processes, and strategic impact.', b: 'How is Legal-Tech coaching different from technical mentoring?'},
				{a: 'Yes, a core part of our coaching is learning how to communicate technical debt and roadmaps to non-technical executives.', b: 'Do you help with stakeholder management?'},
				{a: 'We practice Radical Candor and structured performance improvement plans (PIPs) that actually work.', b: 'How do you handle team performance issues?'},
				{a: 'Yes, we look at how to build a hiring machine: from sourcing to technical assessment and culture fit.', b: 'Do you coach on technical recruiting?'},
				{a: 'We cover the basics of engineering P&L, managing vendor costs (SaaS/Cloud), and headcount planning.', b: 'What about budget management?'},
				{a: 'I teach coordination frameworks like RFCs, ADRs, and shared roadmaps to keep organizations aligned.', b: 'How do you manage cross-team dependencies?'},
				{a: 'Leadership is 80% EQ. We work on active listening, empathy, and maintaining composure under pressure.', b: 'Can you help me develop my emotional intelligence?'},
				{a: 'Yes, specifically how to deliver compelling technical visions to the entire company or at conferences.', b: 'Do you coach on public speaking for leaders?'},
				{a: 'We use the \'Crucial Conversations\' framework to resolve disputes between engineers or across departments.', b: 'How do you handle conflict resolution?'},
				{a: 'Yes, I have a specific track for senior leaders focusing on org design, culture-at-scale, and technical strategy.', b: 'Is this coaching for existing Directors/VPs?'}
			]),
		k: 'Strategic Legal-Tech and Technical Direction',
		f: 'legal-tech',
		l: {
			n: 'Avoid team burnout and the loss of your top engineering talent.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Legal-Tech while delivering high-quality code.'},
			s: 'An Engineering Manager or Tech Lead stepping into Legal-Tech.',
			v: _List_fromArray(
				['Identify your leadership style and team\'s current Legal-Tech challenges.', 'Implement structured frameworks for communication, planning, and feedback.', 'Develop a strategic technical vision that aligns with business goals.']),
			w: {q: 'Team misalignment, missed deadlines, and difficulty bridging tech and business.', t: 'Feeling like you\'re losing your technical edge while struggling with people management.', u: 'Engineering leadership is a skill that should be taught, not just \"figured out.\"'},
			x: 'A high-performing, autonomous engineering team that delivers consistent value.'
		},
		I: 'Legal-Tech Coaching & Consulting | Tech Leadership | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Big Tech Careers Mentorship',
		f: 'big-tech-careers',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Big Tech Careers while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Big Tech Careers.',
			v: _List_fromArray(
				['Build a personalized Big Tech Careers study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Big Tech Careers Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with FAANG Interviews Mentorship',
		f: 'faang-interviews',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with FAANG Interviews while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in FAANG Interviews.',
			v: _List_fromArray(
				['Build a personalized FAANG Interviews study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'FAANG Interviews Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Algorithms Mentorship',
		f: 'algorithms',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Algorithms while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Algorithms.',
			v: _List_fromArray(
				['Build a personalized Algorithms study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Algorithms Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Data Structures Mentorship',
		f: 'data-structures',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Data Structures while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Data Structures.',
			v: _List_fromArray(
				['Build a personalized Data Structures study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Data Structures Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Resume Review Mentorship',
		f: 'resume-review',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Resume Review while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Resume Review.',
			v: _List_fromArray(
				['Build a personalized Resume Review study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Resume Review Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Salary Negotiation Mentorship',
		f: 'salary-negotiation',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Salary Negotiation while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Salary Negotiation.',
			v: _List_fromArray(
				['Build a personalized Salary Negotiation study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Salary Negotiation Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Career Pivot Mentorship',
		f: 'career-pivot',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Career Pivot while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Career Pivot.',
			v: _List_fromArray(
				['Build a personalized Career Pivot study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Career Pivot Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Junior to Senior Mentorship',
		f: 'junior-to-senior',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Junior to Senior while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Junior to Senior.',
			v: _List_fromArray(
				['Build a personalized Junior to Senior study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Junior to Senior Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Mock Interviews Mentorship',
		f: 'mock-interviews',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Mock Interviews while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Mock Interviews.',
			v: _List_fromArray(
				['Build a personalized Mock Interviews study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Mock Interviews Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Mock Interviews', 'Resume & LinkedIn Review', 'Salary Negotiation Coaching', 'Big Tech Application Strategy', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'Personalized career coaching and interview preparation for software engineers. Master system design, algorithms, and behavioral interviews.',
		j: _List_fromArray(
			[
				{a: 'I provide mock interviews focusing on high-level system design, behavioral questions (STAR method), and algorithmic deep-dives.', b: 'How do you help with the interview process?'},
				{a: 'Yes, I advise on navigating the compensation package (base salary, equity, and bonuses) to ensure you are valued correctly.', b: 'Can you help with salary negotiation?'},
				{a: 'We focus on identifying your gaps, building a structured study plan, and practicing until you have \'muscle memory\' for interviews.', b: 'What is the focus of the coaching?'},
				{a: 'We focus on the underlying patterns (Sliding Window, Two Pointers, DP) rather than memorizing specific problems.', b: 'Do you cover LeetCode-style problems?'},
				{a: 'I help you quantify your impact using the X-Y-Z formula to ensure your resume passes both ATS and human screens.', b: 'How do you improve my resume?'},
				{a: 'Absolutely. We refine your career stories to align with the specific values of top-tier companies.', b: 'Do you mentor on behavioral principles?'},
				{a: 'Yes, I have specific tracks for L6/L7 levels focusing on organizational impact, mentoring, and cross-team influence.', b: 'Is this coaching suitable for Staff Engineer roles?'},
				{a: 'Depending on your starting point, most successful candidates spend 3-6 months in my coaching program.', b: 'How long does it take to prepare?'},
				{a: 'Yes, we ensure your profile attracts the right recruiters through strategic keyword and narrative placement.', b: 'Do you help with LinkedIn optimization?'},
				{a: 'We discuss how to transition smoothly, set up for a strong first 90 days, and plan for your first promotion.', b: 'What happens after I get the offer?'}
			]),
		k: 'Accelerate Your Career with Full-Stack Transition Mentorship',
		f: 'full-stack-transition',
		l: {
			n: 'Don\'t spend another year stuck at a dead-end job with a capped salary.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Full-Stack Transition while delivering high-quality code.'},
			s: 'A Software Engineer aiming for a top-tier role in Full-Stack Transition.',
			v: _List_fromArray(
				['Build a personalized Full-Stack Transition study plan covering patterns and system design.', 'Practice with mock interviews and receive brutal, honest feedback.', 'Optimize your resume and LinkedIn to land more interviews and higher offers.']),
			w: {q: 'Complex technical interviews, competitive job markets, and stagnant career growth.', t: 'Feeling that you\'re \"not smart enough\" for Big Tech and struggling with imposter syndrome.', u: 'You shouldn\'t be judged by a whiteboard puzzle, but you can master the game.'},
			x: 'Sign an offer letter at a top-tier company with compensation that reflects your true level.'
		},
		I: 'Full-Stack Transition Coaching | Land Your Dream Role | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy Generative AI features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate Generative AI into Your Product Stack',
		f: 'generative-ai',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Generative AI while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating Generative AI into their business.',
			v: _List_fromArray(
				['Identify high-impact Generative AI use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'Generative AI Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy LLM Integration features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate LLM Integration into Your Product Stack',
		f: 'llm-integration',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with LLM Integration while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating LLM Integration into their business.',
			v: _List_fromArray(
				['Identify high-impact LLM Integration use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'LLM Integration Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy RAG Architecture features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate RAG Architecture into Your Product Stack',
		f: 'rag-architecture',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with RAG Architecture while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating RAG Architecture into their business.',
			v: _List_fromArray(
				['Identify high-impact RAG Architecture use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'RAG Architecture Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy Prompt Engineering features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate Prompt Engineering into Your Product Stack',
		f: 'prompt-engineering',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Prompt Engineering while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating Prompt Engineering into their business.',
			v: _List_fromArray(
				['Identify high-impact Prompt Engineering use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'Prompt Engineering Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy LangChain features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate LangChain into Your Product Stack',
		f: 'langchain',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with LangChain while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating LangChain into their business.',
			v: _List_fromArray(
				['Identify high-impact LangChain use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'LangChain Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy Vector Databases features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate Vector Databases into Your Product Stack',
		f: 'vector-databases',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Vector Databases while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating Vector Databases into their business.',
			v: _List_fromArray(
				['Identify high-impact Vector Databases use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'Vector Databases Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy Machine Learning Engineering features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate Machine Learning Engineering into Your Product Stack',
		f: 'machine-learning-engineering',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with Machine Learning Engineering while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating Machine Learning Engineering into their business.',
			v: _List_fromArray(
				['Identify high-impact Machine Learning Engineering use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'Machine Learning Engineering Consultant | AI Strategy & Integration | Abdu Mappuji'
	},
		{
		h: _List_fromArray(
			['Prompt Engineering workshops', 'RAG Pipeline Review', 'Model Selection Advisory', 'AI Security Auditing', 'Career Roadmap Planning', '1-on-1 Q&A Sessions', 'Personalized Study Plans']),
		i: 'From prompt engineering to RAG architectures. I help companies deploy AI Product Strategy features that actually solve customer problems securely.',
		j: _List_fromArray(
			[
				{a: 'RAG allows LLMs to use your private data to provide accurate, context-aware answers. It\'s essential for most business AI applications.', b: 'What is RAG and do we need it?'},
				{a: 'I specialize in fine-tuning and integrating existing models rather than training from scratch, which is more cost-effective for 99% of businesses.', b: 'Can you help us build a custom AI model?'},
				{a: 'We use multi-stage verification, grounding in private data, and confidence scoring to minimize inaccurate AI responses.', b: 'How do you handle AI hallucinations?'},
				{a: 'We implement streaming responses, prompt optimization, and model tiering to ensure a fast user experience.', b: 'What about AI latency?'},
				{a: 'I help you build an internal evaluation framework to benchmark models on your specific use cases for cost and accuracy.', b: 'How do you evaluate different LLMs?'},
				{a: 'Yes, we move beyond simple instructions to advanced techniques like Chain-of-Thought and Few-Shot prompting.', b: 'Do you help with Prompt Engineering?'},
				{a: 'Yes, we implement automated testing for AI outputs to ensure model updates don\'t break existing functionality.', b: 'Can you integrate AI into our CI/CD?'},
				{a: 'We implement efficient vector storage systems to index and retrieve your embeddings for AI features at scale.', b: 'What about vector databases?'},
				{a: 'We implement robust input sanitization and output filtering to prevent prompt injection and data leakage.', b: 'How do you handle AI security?'},
				{a: 'Yes, I help design systems where AI can take secure, deterministic actions across your internal toolchain.', b: 'Do you advise on AI \'Agentic\' workflows?'}
			]),
		k: 'Integrate AI Product Strategy into Your Product Stack',
		f: 'ai-product-strategy',
		l: {
			n: 'Avoid wasting resources on AI features that users find useless or untrustworthy.',
			o: 'Book a Free Discovery Call',
			r: {m: 'Since 2019 I\'ve mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews, and I\'ve been writing code since 2009 with a decade of that in industry.', p: 'I\'ve been in your shoes, navigating the complexities of modern engineering. I know how overwhelming it can be to keep up with AI Product Strategy while delivering high-quality code.'},
			s: 'A Product Leader or Engineer integrating AI Product Strategy into their business.',
			v: _List_fromArray(
				['Identify high-impact AI Product Strategy use cases for your specific business.', 'Implement a Retrieval-Augmented Generation (RAG) pipeline for your data.', 'Establish an evaluation and security framework for your AI features.']),
			w: {q: 'AI hallucinations, high latency, and the struggle to move beyond simple chat interfaces.', t: 'Pressure to \"do AI\" without a clear path to real customer value.', u: 'AI should be a tool that solves real problems, not just a hype-driven feature.'},
			x: 'A cutting-edge AI integration that delivers measurable value and delights customers.'
		},
		I: 'AI Product Strategy Consultant | AI Strategy & Integration | Abdu Mappuji'
	}
	]);
var $author$project$Data$SeoPages$getBySlug = function (slug) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(p.f, slug);
			},
			$author$project$Data$SeoPages$allPages));
};
var $author$project$Data$WeeklySignals$allWeeklySignals = _List_fromArray(
	[
		{
		ac: '# Five Signal Fridays · W32\n\nSignals · W32 · 2026-08-09\n\nWeekly signals from the noise. Structured by focus area.\n\n## System Design & Craft\n\n1. Freddie deBoer argues [the project of software is complete](https://open.substack.com/pub/freddiedeboer/p/the-project-of-software-is-complete?r=3paa3&utm_medium=ios).\n2. Kaggle Whitepaper on the new [SDLC with vibe coding](https://www.kaggle.com/whitepaper-the-new-SDLC-with-vibe-coding).\n\n## AI Curation & Tools\n\n3. Marcos Hernanz shares his full [AGENTS.md after 60B tokens](https://x.com/MarcosHernanz/status/2083954734487212511?s=20).\n4. Cloudflare introduces a runtime for AI agents called [Cloudflare Computer](https://x.com/Cloudflare/status/2084264282405974034?s=20).\n\n## Offers, Deals & Accelerator Deadlines\n\n5. The biggest opportunity right now: build for agents that need to spend money.',
		F: '2026-08-09',
		i: 'Weekly signals: Freddie deBoer on software completion, Kaggle\'s SDLC vibe coding, 60B tokens AGENTS.md, Cloudflare computer, and agent spending.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('the project of software is complete'),
				C: 'Freddie deBoer argues the project of software is complete.',
				J: $elm$core$Maybe$Just('https://open.substack.com/pub/freddiedeboer/p/the-project-of-software-is-complete?r=3paa3&utm_medium=ios')
			},
				{
				B: $elm$core$Maybe$Just('SDLC with vibe coding'),
				C: 'Kaggle Whitepaper on the new SDLC with vibe coding.',
				J: $elm$core$Maybe$Just('https://www.kaggle.com/whitepaper-the-new-SDLC-with-vibe-coding')
			},
				{
				B: $elm$core$Maybe$Just('AGENTS.md after 60B tokens'),
				C: 'Marcos Hernanz shares his full AGENTS.md after 60B tokens.',
				J: $elm$core$Maybe$Just('https://x.com/MarcosHernanz/status/2083954734487212511?s=20')
			},
				{
				B: $elm$core$Maybe$Just('Cloudflare Computer'),
				C: 'Cloudflare introduces a runtime for AI agents called Cloudflare Computer.',
				J: $elm$core$Maybe$Just('https://x.com/Cloudflare/status/2084264282405974034?s=20')
			},
				{B: $elm$core$Maybe$Nothing, C: 'The biggest opportunity right now: build for agents that need to spend money.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w32-2026',
		aj: 'Gen2 / W32 August',
		ak: _List_fromArray(
			['system-design', 'ai-curation']),
		I: 'Five Signal Fridays: Software Complete, Vibe Coding, AGENTS.md, Cloudflare Computer, Agent Spending',
		al: 32,
		am: 2026
	},
		{
		ac: '# Five 👋🏻 Signal Fridays · W31\n\nSignals · W31 · 2026-07-31\n\nWeekly signals from the noise. Structured by focus area.\n\n## System Design & Craft\n\n1. [Overcoming Underselling](https://www.linkedin.com/posts/underselling-yourself-is-rarely-modesty-ugcPost-7487608853900201984-MXgL/?utm_source=share&utm_medium=member_desktop&rcm=ACoAABdjr8sBey0GCL6ecskem0xI7-9qvVE1OOo): engineers don\'t lack impact; they lack business vocabulary to articulate it.\n\n## Offers, Deals & Accelerator Deadlines\n\n2. [Solo Founders Program](https://x.com/julianweisser/status/2081779351289532652?s=12): South Park Commons launching 3 months in SF with $100k for solo builders.\n\n## AI Curation & Tools\n\n3. Bobo Wong: [posting exploratory spec landing pages](https://x.com/poistudioltd/status/2081303518460482003?s=20) publicly converted real inbound clients.\n\n4. [Fujifilm iPhone recipe](https://x.com/noorielova/status/2081423520115179606?s=12): tweak contrast, exposure (-5), and warmth to get film tones natively.\n\n## Steal Line\n\n5. Steal line: Publish your practice work—spec projects attract real clients faster than polished resumes.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-07-31',
		i: 'Five signals from W31 — engineering vocabulary, SPC Solo Founders Program, converting spec work to clients, and native Fujifilm iPhone presets.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('Overcoming Underselling'),
				C: 'Overcoming Underselling: engineers don\'t lack impact; they lack business vocabulary to articulate it.',
				J: $elm$core$Maybe$Just('https://www.linkedin.com/posts/underselling-yourself-is-rarely-modesty-ugcPost-7487608853900201984-MXgL/?utm_source=share&utm_medium=member_desktop&rcm=ACoAABdjr8sBey0GCL6ecskem0xI7-9qvVE1OOo')
			},
				{
				B: $elm$core$Maybe$Just('Solo Founders Program'),
				C: 'Solo Founders Program: South Park Commons launching 3 months in SF with $100k for solo builders.',
				J: $elm$core$Maybe$Just('https://x.com/julianweisser/status/2081779351289532652?s=12')
			},
				{
				B: $elm$core$Maybe$Just('posting exploratory spec landing pages'),
				C: 'Bobo Wong: posting exploratory spec landing pages publicly converted real inbound clients.',
				J: $elm$core$Maybe$Just('https://x.com/poistudioltd/status/2081303518460482003?s=20')
			},
				{
				B: $elm$core$Maybe$Just('Fujifilm iPhone recipe'),
				C: 'Fujifilm iPhone recipe: tweak contrast, exposure (-5), and warmth to get film tones natively.',
				J: $elm$core$Maybe$Just('https://x.com/noorielova/status/2081423520115179606?s=12')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal line: Publish your practice work—spec projects attract real clients faster than polished resumes.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w31-2026',
		aj: 'Gen2 / W31 July',
		ak: _List_fromArray(
			['engineering', 'startup', 'design', 'career']),
		I: 'Five 👋🏻 Signal Fridays: Underselling Engineers, Solo Founders Program, Spec Inbound, Fujifilm iPhone, Public Practice',
		al: 31,
		am: 2026
	},
		{
		ac: '# Five 👋🏻 Signal Fridays · W30\n\nSignals · W30 · 2026-07-24\n\nWeekly signals from the noise. Structured by focus area.\n\n## System Design & Craft\n\n1. [Seniority in system design](https://formation.dev/blog/signal-seniority-system-design-interview?utm_source=linkedin&utm_medium=organic&utm_campaign=System_design_seniority&utm_term=blog&utm_content=formation_brand) isn\'t about naming tools—it\'s explaining trade-offs & handling pushback.\n\n## AI Curation & Tools\n\n2. Sau Sheong: [AI agents look like workers](https://sausheong.com/are-ai-agents-the-new-serfs-60485133dc66) but behave like software—neither employee nor tool.\n\n3. [Qwen3.8](https://x.com/Alibaba_Qwen/status/2078759124914098291?s=20): Alibaba launching open-weight 2.4T model to rival top proprietary frontier AI.\n\n4. Sami: [10 directory submissions](https://x.com/samigrows/status/2078504320375701861?s=20) (Crunchbase, Product Hunt) beat 6 months chasing guest posts.\n\n## Steal Line\n\n5. Steal line: Build on your own site first—mistakes on your domain are cheap; client mistakes aren\'t.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-07-24',
		i: 'Weekly signals from W30 — system design seniority, AI agent philosophy, Qwen 2.4T open-weights, fast directory backlinks, and domain ownership.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('Seniority in system design'),
				C: 'Seniority in system design isn\'t about naming tools—it\'s explaining trade-offs & handling pushback.',
				J: $elm$core$Maybe$Just('https://formation.dev/blog/signal-seniority-system-design-interview?utm_source=linkedin&utm_medium=organic&utm_campaign=System_design_seniority&utm_term=blog&utm_content=formation_brand')
			},
				{
				B: $elm$core$Maybe$Just('AI agents look like workers'),
				C: 'Sau Sheong: AI agents look like workers but behave like software—neither employee nor tool.',
				J: $elm$core$Maybe$Just('https://sausheong.com/are-ai-agents-the-new-serfs-60485133dc66')
			},
				{
				B: $elm$core$Maybe$Just('Qwen3.8'),
				C: 'Qwen3.8: Alibaba launching open-weight 2.4T model to rival top proprietary frontier AI.',
				J: $elm$core$Maybe$Just('https://x.com/Alibaba_Qwen/status/2078759124914098291?s=20')
			},
				{
				B: $elm$core$Maybe$Just('10 directory submissions'),
				C: 'Sami: 10 directory submissions (Crunchbase, Product Hunt) beat 6 months chasing guest posts.',
				J: $elm$core$Maybe$Just('https://x.com/samigrows/status/2078504320375701861?s=20')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal line: Build on your own site first—mistakes on your domain are cheap; client mistakes aren\'t.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w30-2026',
		aj: 'Gen2 / W30 July',
		ak: _List_fromArray(
			['system-design', 'ai', 'agents', 'seo', 'engineering']),
		I: 'Five 👋🏻 Signal Fridays: System Design Seniority, AI Agent Serfs, Qwen 2.4T, Directory Backlinks, Domain Ownership',
		al: 30,
		am: 2026
	},
		{
		ac: '# Five 👋🏻 Signal Fridays · W29\n\nSignals · W29 · 2026-07-18\n\nWeekly signals from the noise. Structured by focus area.\n\n## System Design & Craft\n\n1. [Steve Yegge’s Flat Curve Society](https://steve-yegge.medium.com/the-flat-curve-society-36c8b01eb33b): frontier locks up; craft becomes about literacy, token hygiene, and supervising agents.\n\n2. [Thomas Guthrie](https://x.com/realthomasgu/status/2075743754967973976) (15yo builder): software is just the output of a thousand decisions. The hard part is deciding what should happen.\n\n3. [Tom Blomfield](https://substack.com/@linas/note/c-293870032) (Monzo founder): how to build recursive, self-improving AI loops inside AI-native companies.\n\n4. [NVIDIA Engineer](https://x.com/0xCarnagee/status/2076757506014286235): "my job is two things: build agents, and babysit agents." Watched a model high-five itself in Jan 2026.\n\n## AI Curation & Tools\n\n5. Anthropic shipped free [Loop Engineering](https://x.com/RoundtableSpace/status/2076254742401921228) — bookmark if your job is already agents.\n\n6. Jacob Bank: [~40 marketing agents](https://x.com/Zephyr_hg/status/2076405725157298441), one human — ~$500 AI vs ~$50k headcount leverage.\n\n7. On-die path: [Gemma 270M → LoRA → int4](https://x.com/h100envy/status/2077784077604692440) on a Pixel in ~21 minutes.\n\n8. [Devin for Startups](https://x.com/cognition/status/2077821585252028849): Cognition is offering $65k in credits to use Devin across Cloud, Desktop, and CLI.\n\n9. [Torlink](https://substack.com/@divyanshisharma2/note/c-289021895): a clean, open-source terminal torrent client that searches curated trackers and downloads straight to disk.\n\n## Offers, Deals & Accelerator Deadlines\n\n10. [South Park Commons Fellowship](https://x.com/suraj_sharma14/status/2077747581409452225): SPC fellowship is offering up to $1M in funding ($400k upfront).\n\n11. Accelerator Shortlist: Ben Lang\'s [curated shortlist of accelerators](https://x.com/benln/status/2077810594032333299) (HF0, SPC, YC, Neo, Sequoia Arc).\n\n12. [Google AI Pro Deal](https://g.co/g1referral/FEG47N9D): get a 4-month trial of Google AI Pro when subscribing with this referral link.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-07-18',
		i: 'Weekly curation from W29 — flat curve, loop engineering, Devin credits, accelerator deadlines, and Tom Blomfield\'s recursive AI loops.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('Steve Yegge\'s Flat Curve Society'),
				C: 'Steve Yegge\'s Flat Curve Society: frontier locks up; craft becomes about literacy, token hygiene, and supervising agents.',
				J: $elm$core$Maybe$Just('https://steve-yegge.medium.com/the-flat-curve-society-36c8b01eb33b')
			},
				{
				B: $elm$core$Maybe$Just('Thomas Guthrie'),
				C: 'Thomas Guthrie: software is just the output of a thousand decisions. The hard part is deciding what should happen.',
				J: $elm$core$Maybe$Just('https://x.com/realthomasgu/status/2075743754967973976')
			},
				{
				B: $elm$core$Maybe$Just('Tom Blomfield'),
				C: 'Tom Blomfield: Monzo/GoCardless founder on how to build recursive, self-improving AI loops inside AI-native companies.',
				J: $elm$core$Maybe$Just('https://substack.com/@linas/note/c-293870032')
			},
				{
				B: $elm$core$Maybe$Just('NVIDIA Engineer'),
				C: 'NVIDIA Engineer: \'my job is two things: build agents, and babysit agents.\' Watched a model high-five itself in Jan 2026.',
				J: $elm$core$Maybe$Just('https://x.com/0xCarnagee/status/2076757506014286235')
			},
				{
				B: $elm$core$Maybe$Just('Anthropic Loop Engineering'),
				C: 'Anthropic Loop Engineering: Anthropic published a free course on loop engineering for AI agents.',
				J: $elm$core$Maybe$Just('https://x.com/RoundtableSpace/status/2076254742401921228')
			},
				{
				B: $elm$core$Maybe$Just('Jacob Bank'),
				C: 'Jacob Bank: ~40 marketing agents, one human — ~$500 AI vs ~$50k headcount leverage.',
				J: $elm$core$Maybe$Just('https://x.com/Zephyr_hg/status/2076405725157298441')
			},
				{
				B: $elm$core$Maybe$Just('Gemma 270M Local LoRA'),
				C: 'Gemma 270M Local LoRA: fine-tuning Gemma 270M with LoRA to int4 on a Pixel in ~21 minutes.',
				J: $elm$core$Maybe$Just('https://x.com/h100envy/status/2077784077604692440')
			},
				{
				B: $elm$core$Maybe$Just('Devin for Startups'),
				C: 'Devin for Startups: Cognition is offering $65k in credits to use Devin across Cloud, Desktop, and CLI.',
				J: $elm$core$Maybe$Just('https://x.com/cognition/status/2077821585252028849')
			},
				{
				B: $elm$core$Maybe$Just('Torlink'),
				C: 'Torlink (Terminal Client): a clean terminal torrent client that searches curated trackers and downloads straight to disk.',
				J: $elm$core$Maybe$Just('https://substack.com/@divyanshisharma2/note/c-289021895')
			},
				{
				B: $elm$core$Maybe$Just('South Park Commons Fellowship'),
				C: 'South Park Commons Fellowship: SPC fellowship is offering up to $1M in funding ($400k upfront).',
				J: $elm$core$Maybe$Just('https://x.com/suraj_sharma14/status/2077747581409452225')
			},
				{
				B: $elm$core$Maybe$Just('Accelerator Shortlist'),
				C: 'Accelerator Shortlist: Ben Lang\'s curated shortlist of accelerators (HF0, SPC, YC, Neo, Sequoia Arc).',
				J: $elm$core$Maybe$Just('https://x.com/benln/status/2077810594032333299')
			},
				{
				B: $elm$core$Maybe$Just('Google AI Pro Deal'),
				C: 'Google AI Pro Deal: get a 4-month trial of Google AI Pro when subscribing with this referral link.',
				J: $elm$core$Maybe$Just('https://g.co/g1referral/FEG47N9D')
			}
			]),
		f: 'w29-2026',
		aj: 'Gen2 / W29 July',
		ak: _List_fromArray(
			['ai', 'agents', 'startup', 'design']),
		I: 'Five 👋🏻 Signal Fridays: flat curve, Loop Engineering, Devin credits, SPC fellowship, Tom Blomfield',
		al: 29,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W28\n\nSignals · W28 · 2026-07-10\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Claude Projects hack: pin an [Claude operating manual prompt trick](https://x.com/cyrilxbt/status/2074728435424047566?s=12) to get dramatically sharper reasoning out of Opus.\n\n2. Teen builder: [Verse founder fellowship announcement](https://x.com/realthomasgu/status/2073876068893913510?s=12) on how a 15-year-old scaled a side project to 50k users and got into YC.\n\n3. Audio efficiency: Andrew Warner details [FluidVoice local transcription](https://x.com/andrewwarner/status/2074130001381777505?s=12)—a fast, private alternative to Wispr.\n\n4. Validation strategy: a [Reddit validation playbook](https://x.com/jasperli0122/status/2074322267224539518?s=12) on how to use existing communities to test startup ideas cheaply.\n\n5. Steal this: Apple I, Wikipedia, and Linux were **hobby projects**—the next breakthroughs will come from hobbyists building for fun.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-07-10',
		i: 'Five signals from W28 — Claude Projects reasoning manuals, Verse scaling to 50k, FluidVoice local dictation, and Reddit validation.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('Claude operating manual prompt trick'),
				C: 'Claude Projects hack: write a reasoning \'operating manual\' for Claude Opus 4.8 and pin it to projects for sharper logic.',
				J: $elm$core$Maybe$Just('https://x.com/cyrilxbt/status/2074728435424047566?s=12')
			},
				{
				B: $elm$core$Maybe$Just('Verse founder fellowship announcement'),
				C: 'Thomas Guthrie: 15-year-old builds Verse as a side project in a local forest, scales to 50k users, and raises $500k.',
				J: $elm$core$Maybe$Just('https://x.com/realthomasgu/status/2073876068893913510?s=12')
			},
				{
				B: $elm$core$Maybe$Just('FluidVoice local transcription'),
				C: 'Local Dictation: FluidVoice launches as a fast, private, and local-first alternative to cloud-heavy audio dictation tools.',
				J: $elm$core$Maybe$Just('https://x.com/andrewwarner/status/2074130001381777505?s=12')
			},
				{
				B: $elm$core$Maybe$Just('Reddit validation playbook'),
				C: 'Startup validation: using highly targeted Reddit communities as a cheap, immediate feedback loop for early ideas.',
				J: $elm$core$Maybe$Just('https://x.com/jasperli0122/status/2074322267224539518?s=12')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: breakthrough tech (Linux, Apple I, Minecraft) started as hobby projects—fund the weird experiments, not just the pitch decks.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w28-2026',
		aj: 'Gen2 / W28 July',
		ak: _List_fromArray(
			['ai', 'startup', 'tools', 'design']),
		I: 'Five Signal Fridays: Claude projects hack, 15yo YC founder, local dictation tool, Reddit validation, hobbyist breakthroughs',
		al: 28,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W27\n\nSignals · W27 · 2026-07-03\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Stanford researchers build an [agent-native version of Git](https://x.com/_avichawla/status/2073746091795960237?s=12) that snapshots dev state (DB, KV cache) for rollback safety.\n\n2. Claude Code creator Boris Cherny: the [Claude Code creator interview](https://x.com/mogulinfluence/status/2071591933416296520?s=12) explains why tiny teams can now out-build big startups.\n\n3. Perplexity CEO Aravind Srinivas details the [history of office workers](https://x.com/JoeRoganRecaps/status/2073481735174815822?s=20)—a concept manufactured to sell office software.\n\n4. Peak hardware optimization: a Meta PyTorch engineer turns [CUDA kernel speedrunning](https://x.com/h100envy/status/2072026253842841692?s=12) and profiling into a 13-minute sport.\n\n5. Steal this: read Aaron Levie\'s **essential business books**—7 Powers, Positioning, Innovator\'s Dilemma, Blue Ocean, and Crossing the Chasm.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-07-03',
		i: 'Five signals from W27 — Stanford\'s agent-native Git, the Claude Code startup edge, Perplexity on the office worker myth, and CUDA speedruns.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('agent-native version of Git'),
				C: 'Stanford\'s Agent-Git: research builds agent-native Git to snapshot environment state (KV cache, DB, files) for fast agent rollbacks.',
				J: $elm$core$Maybe$Just('https://x.com/_avichawla/status/2073746091795960237?s=12')
			},
				{
				B: $elm$core$Maybe$Just('Claude Code creator interview'),
				C: 'Boris Cherny (Claude Code): tiny teams are outmuscling incumbents because the marginal cost of building has collapsed.',
				J: $elm$core$Maybe$Just('https://x.com/mogulinfluence/status/2071591933416296520?s=12')
			},
				{
				B: $elm$core$Maybe$Just('history of office workers'),
				C: 'Perplexity\'s Aravind Srinivas: how Microsoft manufactured the concept of the \'office worker\' to create demand for productivity suites.',
				J: $elm$core$Maybe$Just('https://x.com/JoeRoganRecaps/status/2073481735174815822?s=20')
			},
				{
				B: $elm$core$Maybe$Just('CUDA kernel speedrunning'),
				C: 'CUDA speedruns: Meta PyTorch engineer turns kernel writing into a sport by optimizing and benchmarking in 13 minutes.',
				J: $elm$core$Maybe$Just('https://x.com/h100envy/status/2072026253842841692?s=12')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: read Aaron Levie’s foundational 5 books—Positioning, 7 Powers, Innovator\'s Dilemma, Blue Ocean, and Crossing the Chasm.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w27-2026',
		aj: 'Gen2 / W27 June',
		ak: _List_fromArray(
			['ai', 'development', 'history', 'performance']),
		I: 'Five Signal Fridays: agent-native git, Claude Code advantage, office worker myth, CUDA speedruns, Levie\'s business stack',
		al: 27,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W26\n\nSignals · W26 · 2026-06-26\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Aswath Damodaran: Dot-com was an equity bubble, but AI is an [AI infrastructure debt bubble](https://substack.com/@linas/note/c-281947883?r=3paa3&utm_medium=ios&utm_source=notes-share-action) backed by $5.3T hyperscaler capex.\n\n2. Netflix engineer Tejas Chopra open-sources [Headroom token compression proxy](https://substack.com/@linas/note/c-280532857?r=3paa3&utm_medium=ios&utm_source=notes-share-action), slashing input tokens by 60–95%.\n\n3. Anthropic PM reveals their own engineers deploy [swarms of self-improving agents](https://substack.com/@linas/note/c-281725347?r=3paa3&utm_medium=ios&utm_source=notes-share-action) in loops to verify output.\n\n4. AI Search Optimization: Jonathan Liem launches Inflect to manage and track [AI engine search visibility](https://www.linkedin.com/posts/jonathan-liem_today-im-super-excited-to-launch-inflect-ugcPost-7475457949050679296-bB0J/?utm_source=share&utm_medium=member_ios&rcm=ACoAABdjr8sBey0GCL6ecskem0xI7-9qvVE1OOo) and recommendations.\n\n5. Steal this: the cheapest token is the one you **never send**—use local AST-based compression to clean your prompt.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-06-26',
		i: 'Five signals from W26 — Damodaran\'s AI debt bubble, Netflix\'s token compression proxy Headroom, swarms of 300+ agents, and GEO.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('AI infrastructure debt bubble'),
				C: 'Aswath Damodaran: Dot-com was an equity bubble; AI is an infrastructure debt bubble backed by $5.3T data center leases.',
				J: $elm$core$Maybe$Just('https://substack.com/@linas/note/c-281947883?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('Headroom token compression proxy'),
				C: 'Headroom by Tejas Chopra: Netflix engineer open-sources a proxy compressing input tokens by 60–95% via AST/JSON parsing.',
				J: $elm$core$Maybe$Just('https://substack.com/@linas/note/c-280532857?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('swarms of self-improving agents'),
				C: 'Anthropic PM: their engineers build and debug by running swarms of 300+ self-improving agents in continuous verification loops.',
				J: $elm$core$Maybe$Just('https://substack.com/@linas/note/c-281725347?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('AI engine search visibility'),
				C: 'GEO / AI Search Optimization: Jonathan Liem launches Inflect to help companies track and audit how AI engines recommend them.',
				J: $elm$core$Maybe$Just('https://www.linkedin.com/posts/jonathan-liem_today-im-super-excited-to-launch-inflect-ugcPost-7475457949050679296-bB0J/?utm_source=share&utm_medium=member_ios&rcm=ACoAABdjr8sBey0GCL6ecskem0xI7-9qvVE1OOo')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: the cheapest token is the one you never send—use local AST-based filtering to slice junk code from context.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w26-2026',
		aj: 'Gen2 / W26 June',
		ak: _List_fromArray(
			['finance', 'ai', 'agents', 'seo']),
		I: 'Five Signal Fridays: AI debt bubble, token compression proxy, agent swarms, AI engine visibility, context filtering',
		al: 26,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W25\n\nSignals · W25 · 2026-06-19\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Zhipu AI\'s GLM-5.2: open-weight [GLM-5.2 coding agent optimization](https://substack.com/@aisupremacy/note/c-278415278?r=3paa3&utm_medium=ios&utm_source=notes-share-action) for long-running, multi-file agent sessions.\n\n2. Milan Milanović: [the junior engineer training crisis](https://www.linkedin.com/feed/update/urn:li:share:7474068558071721986/) shows cutting junior roles breaks the \'learning by doing\' talent pipeline.\n\n3. AI Engineering stack: the shift from simple prompting to a comprehensive [harness engineering curriculum](https://substack.com/@thatdevopsguy/note/c-270078254) and fallback loops.\n\n4. AI Dependency risk: how to write an [AI workflows survival guide](https://substack.com/@samillingworth/note/c-277120127) for when a flagship model is suddenly pulled.\n\n5. Steal this: don\'t write one-off prompts; construct **reusable skills** that execute and refine themselves in the background.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-06-19',
		i: 'Five signals from W25 — Zhipu GLM-5.2 long-context coding agents, Milan Milanović on the junior engineer crisis, and harness engineering.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('GLM-5.2 coding agent optimization'),
				C: 'Zhipu AI\'s GLM-5.2: open-weight model optimized for long-running, multi-file agent sessions to avoid context fragmentation.',
				J: $elm$core$Maybe$Just('https://substack.com/@aisupremacy/note/c-278415278?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('the junior engineer training crisis'),
				C: 'Milan Milanović: cutting junior roles to save money halts the Kenneth Arrow \'learning by doing\' loop, leaving no seniors by 2032.',
				J: $elm$core$Maybe$Just('https://www.linkedin.com/feed/update/urn:li:share:7474068558071721986/')
			},
				{
				B: $elm$core$Maybe$Just('harness engineering curriculum'),
				C: 'AI Engineering stack: the transition from simple prompting to harness engineering, KV cache tuning, and fallback loops.',
				J: $elm$core$Maybe$Just('https://substack.com/@thatdevopsguy/note/c-270078254')
			},
				{
				B: $elm$core$Maybe$Just('AI workflows survival guide'),
				C: 'AI Dependency risk: what happens when your flagship model is pulled due to regulatory compliance (like Fable 5).',
				J: $elm$core$Maybe$Just('https://substack.com/@samillingworth/note/c-277120127')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: don\'t write prompts or custom scripts for every task; construct reusable skills that execute and improve in the background.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w25-2026',
		aj: 'Gen2 / W25 June',
		ak: _List_fromArray(
			['ai', 'agents', 'business', 'development']),
		I: 'Five Signal Fridays: GLM-5.2 agents, junior talent crisis, harness engineering, model dependency, automated skills',
		al: 25,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W24\n\nSignals · W24 · 2026-06-12\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Anthropic’s Daisy Hollman: you’re not supposed to prompt Claude, you\'re supposed to [build a system that prompts itself](https://substack.com/@linas/note/c-270902409?r=3paa3&utm_medium=ios&utm_source=notes-share-action).\n\n2. Self-improving agents: [self-improving agents research](https://substack.com/@elvissaravia/note/c-268736067?r=3paa3&utm_medium=ios&utm_source=notes-share-action) shows cheap models write harness edits as well as Opus, but solver benefits most.\n\n3. Michael Novati: [Reflecting on a year of Claude Code](https://www.linkedin.com/feed/update/urn:li:activity:7469892256108335104/) shows a shift from complex prompt engineering to minimal prompts and tools.\n\n4. David Oks: [Why China got rich and India didn\'t](https://open.substack.com/pub/davidoks/p/why-china-got-rich-and-india-didnt?r=3paa3&utm_medium=ios) breaks down the deep human and structural roots of their divergence.\n\n5. Steal this: there are only **three growth levers** for digital business: expand attention, lift conversion, or increase lifetime value.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-06-12',
		i: 'Five signals from W24 — self-prompting systems, self-improving agent harnesses, Claude Code\'s first year, and the Sino-Indian divergence.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('build a system that prompts itself'),
				C: 'Anthropic’s Daisy Hollman: you’re not supposed to prompt Claude, you\'re supposed to build a system that prompts itself.',
				J: $elm$core$Maybe$Just('https://substack.com/@linas/note/c-270902409?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('self-improving agents research'),
				C: 'Self-improving agents: paper shows weaker/cheaper models write harness edits as well as Opus, but solver benefits most.',
				J: $elm$core$Maybe$Just('https://substack.com/@elvissaravia/note/c-268736067?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('Reflecting on a year of Claude Code'),
				C: 'Michael Novati (Claude Code): shift from prompt/context engineering to minimal prompts and tools, letting models solve it.',
				J: $elm$core$Maybe$Just('https://www.linkedin.com/feed/update/urn:li:activity:7469892256108335104/')
			},
				{
				B: $elm$core$Maybe$Just('Why China got rich and India didn\'t'),
				C: 'David Oks on divergence: the deep human and structural roots of why China got rich while India lag behind.',
				J: $elm$core$Maybe$Just('https://open.substack.com/pub/davidoks/p/why-china-got-rich-and-india-didnt?r=3paa3&utm_medium=ios')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: there are only three levers for digital business growth: expand attention, lift conversion, increase lifetime value.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w24-2026',
		aj: 'Gen2 / W24 June',
		ak: _List_fromArray(
			['ai', 'agents', 'geopolitics', 'growth']),
		I: 'Five Signal Fridays: self-prompting systems, agent harnesses, Claude Code evolution, Sino-Indian divergence, growth levers',
		al: 24,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W21\n\nSignals · W21 · 2026-05-22\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Dwarkesh Patel on the [mystery of the miracle year](https://open.substack.com/pub/dwarkesh/p/annus-mirabilis?r=3paa3&utm_medium=ios) where scientists make multiple independent breakthroughs.\n\n2. AI Agent architecture: good agents look [less like chatbots and more like workshops](https://open.substack.com/pub/xaiguy/p/why-good-ai-agents-look-less-like?r=3paa3&utm_medium=ios).\n\n3. Leah Litman’s The Passive Vices: how the Supreme Court uses procedural avoidance mechanisms for [avoiding judicial decisions](https://www.linkedin.com/posts/the-georgetown-law-journal-capped-off-the-share-7465069757038481410-xESa/?utm_source=social_share_send&utm_medium=ios_app&rcm=ACoAABdjr8sBey0GCL6ecskem0xI7-9qvVE1OOo&utm_campaign=share_via).\n\n4. Turbopuffer vector search: serverless, usage-based [turbopuffer serverless vector search](https://turbopuffer.com/pricing) claiming 10x cheaper cost.\n\n5. Steal this: open-source sustainability isn\'t just about code maintenance; it\'s about building **institutional trust**.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-05-22',
		i: 'Five signals from W21 — Dwarkesh\'s miracle years, agents as workshops, the Supreme Court\'s passive vices, and serverless vector search.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('mystery of the miracle year'),
				C: 'Dwarkesh Patel on the mystery of the miracle year where scientists make multiple independent breakthroughs.',
				J: $elm$core$Maybe$Just('https://open.substack.com/pub/dwarkesh/p/annus-mirabilis?r=3paa3&utm_medium=ios')
			},
				{
				B: $elm$core$Maybe$Just('less like chatbots and more like workshops'),
				C: 'AI Agent architecture: good agents look less like chatbots and more like interactive digital workshops.',
				J: $elm$core$Maybe$Just('https://open.substack.com/pub/xaiguy/p/why-good-ai-agents-look-less-like?r=3paa3&utm_medium=ios')
			},
				{
				B: $elm$core$Maybe$Just('avoiding judicial decisions'),
				C: 'Leah Litman’s The Passive Vices: how the Supreme Court uses procedural avoidance mechanisms to dodge hard decisions.',
				J: $elm$core$Maybe$Just('https://www.linkedin.com/posts/the-georgetown-law-journal-capped-off-the-share-7465069757038481410-xESa/?utm_source=social_share_send&utm_medium=ios_app&rcm=ACoAABdjr8sBey0GCL6ecskem0xI7-9qvVE1OOo&utm_campaign=share_via')
			},
				{
				B: $elm$core$Maybe$Just('turbopuffer serverless vector search'),
				C: 'Turbopuffer vector search: serverless, usage-based vector index on object storage claiming 10x cheaper cost.',
				J: $elm$core$Maybe$Just('https://turbopuffer.com/pricing')
			},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: open-source sustainability isn\'t just about code maintenance; it\'s about building institutional trust.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w21-2026',
		aj: 'Gen2 / W21 May',
		ak: _List_fromArray(
			['science', 'agents', 'law', 'databases']),
		I: 'Five Signal Fridays: miracle years, agent workshops, passive vices, serverless vector search, open source trust',
		al: 21,
		am: 2026
	},
		{
		ac: '# Five Signal Fridays · W20\n\nSignals · W20 · 2026-05-15\n\nFive lines from the week’s noise. What still had a rising edge.\n\n## Signals\n\n1. Benjamin Antoine: the [creator economy sold freedom](https://substack.com/@2hourcreatorstack/note/c-258308428?r=3paa3&utm_medium=ios&utm_source=notes-share-action) but built a metrics-based job with worse boundaries.\n\n2. Dr. Sam Illingworth: treat [ethics as something you practice](https://substack.com/@samillingworth/note/c-257632287?r=3paa3&utm_medium=ios&utm_source=notes-share-action) daily, rather than something you simply have.\n\n3. LLM latency: optimizing for prefill vs decode is where you save latency; raw tokens matter less than TTFT.\n\n4. Vector search overhead: small setups are better off with flat indexes before paying Pinecone or Qdrant taxes.\n\n5. Steal this: build a **body of work** and a way of operating that your nervous system and relationships can sustain.\n\n---\n\n*See you next Friday. — Abdu*',
		F: '2026-05-15',
		i: 'Five signals from W20 — the creator economy freedom trap, Sam Illingworth on practicing ethics, vector db trade-offs, and sustainable growth.',
		af: 'five-signal-fridays',
		ai: _List_fromArray(
			[
				{
				B: $elm$core$Maybe$Just('creator economy sold freedom'),
				C: 'Benjamin Antoine: the creator economy sold freedom but built a metrics-based job with worse boundaries.',
				J: $elm$core$Maybe$Just('https://substack.com/@2hourcreatorstack/note/c-258308428?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{
				B: $elm$core$Maybe$Just('ethics as something you practice'),
				C: 'Dr. Sam Illingworth: treat ethics as something you practice daily, rather than something you simply have.',
				J: $elm$core$Maybe$Just('https://substack.com/@samillingworth/note/c-257632287?r=3paa3&utm_medium=ios&utm_source=notes-share-action')
			},
				{B: $elm$core$Maybe$Nothing, C: 'LLM latency: optimizing for prefill vs decode is where you save latency; raw tokens matter less than TTFT.', J: $elm$core$Maybe$Nothing},
				{B: $elm$core$Maybe$Nothing, C: 'Vector search overhead: small setups are better off with flat indexes before paying Pinecone or Qdrant taxes.', J: $elm$core$Maybe$Nothing},
				{B: $elm$core$Maybe$Nothing, C: 'Steal this: build a body of work and a way of operating that your nervous system and relationships can sustain.', J: $elm$core$Maybe$Nothing}
			]),
		f: 'w20-2026',
		aj: 'Gen2 / W20 May',
		ak: _List_fromArray(
			['growth', 'ethics', 'databases', 'productivity']),
		I: 'Five Signal Fridays: creator economy trap, practicing ethics, sustainable growth, agent loops',
		al: 20,
		am: 2026
	}
	]);
var $author$project$Data$WeeklySignals$getBySlug = function (slug) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (s) {
				return _Utils_eq(s.f, slug);
			},
			$author$project$Data$WeeklySignals$allWeeklySignals));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Main$getMetaDescription = function (route) {
	switch (route.$) {
		case 0:
			return 'Interview coach and Full Stack Engineer at Booking.com\'s FareHarbor. 200+ engineers mentored one-on-one since 2019 across multiple platforms, with 100+ five-star reviews. Mentees at Amazon, Meta, Netflix, NVIDIA and Two Sigma.';
		case 3:
			return 'What mentees achieved after coaching with Abdu Mappuji: named testimonials, mentee work, and the companies they went on to. 200+ engineers mentored one-on-one since 2019.';
		case 2:
			return 'Verifiable record for Abdurrachman Mappuji: seven degrees including a PhD candidacy in Mathematics & Explainable AI, eight employment tenures, six peer-reviewed publications, and certifications from Microsoft and Google.';
		case 1:
			return 'Tech talks & speaking by Abdu Mappuji. Featured in IEEE, Web Directions. Topics: DevOps, Python, Elm, AI. 21 talks since 2017.';
		case 4:
			return 'Hire Abdu Mappuji as fractional CTO or exclusive mentor. 200+ engineers mentored, 100+ five-star reviews. Mentored engineers from Amazon, Netflix, NVIDIA. Packages from $90.';
		case 5:
			return 'Works by Abdu Mappuji — blogs, books, and publications. Tech articles on Medium, Substack, Codementor. Academic papers on IEEE.';
		case 6:
			return 'Codex — a living archive of essays, signals, and technical reflections by Abdu Mappuji. System design, engineering culture, and craft.';
		case 7:
			return 'Signals — Five 👋🏻 Signal Fridays from Abdu Mappuji. Short weekly briefs on AI agents, engineering craft, and what survived the scroll.';
		case 8:
			var slug = route.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Weekly signal by Abdu Mappuji — Five 👋🏻 Signal Fridays.',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i;
					},
					$author$project$Data$WeeklySignals$getBySlug(slug)));
		case 9:
			return 'Founded Kulkul Tech (100% CEO approval). Angel investor in YC companies: AptDeco, Airthium, InnaMed. Tech entrepreneurship & venture investments.';
		case 10:
			return 'Exclusive referral offers curated by Abdu Mappuji. Get special benefits for Perplexity AI, Wise, and premium tech services with bonus discounts.';
		case 11:
			return 'Mentoring services with MentorCruise by Abdu Mappuji. Find out the pros and cons of MentorCruise and how to get started.';
		case 12:
			return 'Find Abdu Mappuji on various platforms. Connect with him on MentorCruise, social media, and other professional networks.';
		case 13:
			return 'Experience the power of group mentoring with Abdu Mappuji on mentor.sh. Join collaborative sessions focused on active, peer-based learning for tech growth.';
		case 14:
			return 'Book Abdu Mappuji on MeetAPro for technical mock interviews, resume review, system design consulting, and fractional CTO leadership sessions.';
		case 15:
			return 'Explore specialized technical services by Abdu Mappuji, including CTO consulting, AI integration, and high-end engineering mentorship.';
		case 16:
			return A2(
				$elm$core$Maybe$withDefault,
				'Technical Expert Witness for Software IP, AI, and Algorithm Economy.',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i;
					},
					$author$project$Data$LegalPages$getBySlug('expert-witness')));
		case 17:
			return A2(
				$elm$core$Maybe$withDefault,
				'Saksi Ahli Teknologi Informasi (Indonesia) untuk sengketa HAKI, Siber, dan UU ITE.',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i;
					},
					$author$project$Data$LegalPages$getBySlug('saksi-ahli')));
		case 18:
			var lang = route.a;
			var region = route.b;
			var topic = route.c;
			var forum = route.d;
			return A2(
				$elm$core$Maybe$withDefault,
				'Technical Expert Witness services for complex software and AI disputes.',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i;
					},
					A4($author$project$Data$LegalPages$getByHierarchy, lang, region, topic, forum)));
		case 19:
			var slug = route.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Specialized tech services and mentoring by Abdu Mappuji.',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i;
					},
					$author$project$Data$SeoPages$getBySlug(slug)));
		case 20:
			return 'Beta: an experimental mosaic gallery of selected projects by Abdu Mappuji, loaded live.';
		case 21:
			return 'Beta: opportunities and referral programs passed along by Abdu Mappuji, loaded live.';
		default:
			return 'Page not found. Explore Abdu Mappuji\'s mentoring services, tech talks, blog posts, and entrepreneurial ventures. Return to home page.';
	}
};
var $author$project$Data$Tags$allTags = _List_fromArray(
	[
		{y: 'Language', k: 'Master Python with a Booking.com Engineer & Former Engineering Manager', f: 'python'},
		{y: 'Language', k: 'Master Java with a Booking.com Engineer & Former Engineering Manager', f: 'java'},
		{y: 'Language', k: 'Master Kotlin with a Booking.com Engineer & Former Engineering Manager', f: 'kotlin'},
		{y: 'Language', k: 'Master Go with a Booking.com Engineer & Former Engineering Manager', f: 'go'},
		{y: 'Language', k: 'Master TypeScript with a Booking.com Engineer & Former Engineering Manager', f: 'typescript'},
		{y: 'Language', k: 'Master JavaScript with a Booking.com Engineer & Former Engineering Manager', f: 'javascript'},
		{y: 'Language', k: 'Master Rust with a Booking.com Engineer & Former Engineering Manager', f: 'rust'},
		{y: 'Language', k: 'Master C# with a Booking.com Engineer & Former Engineering Manager', f: 'c'},
		{y: 'Language', k: 'Master Ruby with a Booking.com Engineer & Former Engineering Manager', f: 'ruby'},
		{y: 'Language', k: 'Master Swift with a Booking.com Engineer & Former Engineering Manager', f: 'swift'},
		{y: 'Language', k: 'Master Scala with a Booking.com Engineer & Former Engineering Manager', f: 'scala'},
		{y: 'Language', k: 'Master Elixir with a Booking.com Engineer & Former Engineering Manager', f: 'elixir'},
		{y: 'Language', k: 'Master PHP with a Booking.com Engineer & Former Engineering Manager', f: 'php'},
		{y: 'Framework', k: 'Master Spring Boot and Advanced Architecture', f: 'spring-boot'},
		{y: 'Framework', k: 'Master Node.js and Advanced Architecture', f: 'node-js'},
		{y: 'Framework', k: 'Master React and Advanced Architecture', f: 'react'},
		{y: 'Framework', k: 'Master Vue.js and Advanced Architecture', f: 'vue-js'},
		{y: 'Framework', k: 'Master Angular and Advanced Architecture', f: 'angular'},
		{y: 'Framework', k: 'Master Django and Advanced Architecture', f: 'django'},
		{y: 'Framework', k: 'Master FastAPI and Advanced Architecture', f: 'fastapi'},
		{y: 'Framework', k: 'Master Flask and Advanced Architecture', f: 'flask'},
		{y: 'Framework', k: 'Master Express.js and Advanced Architecture', f: 'express-js'},
		{y: 'Framework', k: 'Master NestJS and Advanced Architecture', f: 'nestjs'},
		{y: 'Framework', k: 'Master Next.js and Advanced Architecture', f: 'next-js'},
		{y: 'Framework', k: 'Master GraphQL and Advanced Architecture', f: 'graphql'},
		{y: 'Framework', k: 'Master Ruby on Rails and Advanced Architecture', f: 'ruby-on-rails'},
		{y: 'Framework', k: 'Master ASP.NET and Advanced Architecture', f: 'asp-net'},
		{y: 'Framework', k: 'Master Laravel and Advanced Architecture', f: 'laravel'},
		{y: 'Framework', k: 'Master Ktor and Advanced Architecture', f: 'ktor'},
		{y: 'Framework', k: 'Master Quarkus and Advanced Architecture', f: 'quarkus'},
		{y: 'Framework', k: 'Master Elm and Advanced Architecture', f: 'elm'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with AWS', f: 'aws'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with GCP', f: 'gcp'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Azure', f: 'azure'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Kubernetes', f: 'kubernetes'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Docker', f: 'docker'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Terraform', f: 'terraform'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with CI/CD', f: 'ci-cd'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with DevOps', f: 'devops'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with SRE', f: 'sre'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with GitHub Actions', f: 'github-actions'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with GitLab CI', f: 'gitlab-ci'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Linux Administration', f: 'linux-administration'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Prometheus', f: 'prometheus'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Grafana', f: 'grafana'},
		{y: 'Infrastructure', k: 'Modernize Your Infrastructure with Datadog', f: 'datadog'},
		{y: 'Database', k: 'Scale Your Data Layer with PostgreSQL', f: 'postgresql'},
		{y: 'Database', k: 'Scale Your Data Layer with MongoDB', f: 'mongodb'},
		{y: 'Database', k: 'Scale Your Data Layer with Redis', f: 'redis'},
		{y: 'Database', k: 'Scale Your Data Layer with Kafka', f: 'kafka'},
		{y: 'Database', k: 'Scale Your Data Layer with RabbitMQ', f: 'rabbitmq'},
		{y: 'Database', k: 'Scale Your Data Layer with Elasticsearch', f: 'elasticsearch'},
		{y: 'Database', k: 'Scale Your Data Layer with Cassandra', f: 'cassandra'},
		{y: 'Database', k: 'Scale Your Data Layer with MySQL', f: 'mysql'},
		{y: 'Database', k: 'Scale Your Data Layer with DynamoDB', f: 'dynamodb'},
		{y: 'Database', k: 'Scale Your Data Layer with Apache Spark', f: 'apache-spark'},
		{y: 'Database', k: 'Scale Your Data Layer with Snowflake', f: 'snowflake'},
		{y: 'Database', k: 'Scale Your Data Layer with Event Sourcing', f: 'event-sourcing'},
		{y: 'Architecture', k: 'Master High-Scale System Design', f: 'system-design'},
		{y: 'Architecture', k: 'Master High-Scale Microservices', f: 'microservices'},
		{y: 'Architecture', k: 'Master High-Scale API Design', f: 'api-design'},
		{y: 'Architecture', k: 'Master High-Scale Backend Scalability', f: 'backend-scalability'},
		{y: 'Architecture', k: 'Master High-Scale Event-Driven Architecture', f: 'event-driven-architecture'},
		{y: 'Architecture', k: 'Master High-Scale REST API', f: 'rest-api'},
		{y: 'Architecture', k: 'Master High-Scale Serverless Architecture', f: 'serverless-architecture'},
		{y: 'Architecture', k: 'Master High-Scale Domain-Driven Design', f: 'domain-driven-design'},
		{y: 'Architecture', k: 'Master High-Scale Hexagonal Architecture', f: 'hexagonal-architecture'},
		{y: 'Architecture', k: 'Master High-Scale Cloud-Native', f: 'cloud-native'},
		{y: 'Architecture', k: 'Master High-Scale High Availability', f: 'high-availability'},
		{y: 'Leadership', k: 'Strategic Engineering Management and Technical Direction', f: 'engineering-management'},
		{y: 'Leadership', k: 'Strategic Tech Lead and Technical Direction', f: 'tech-lead'},
		{y: 'Leadership', k: 'Strategic Fractional CTO and Technical Direction', f: 'fractional-cto'},
		{y: 'Leadership', k: 'Strategic VP of Engineering and Technical Direction', f: 'vp-of-engineering'},
		{y: 'Leadership', k: 'Strategic Agile Leadership and Technical Direction', f: 'agile-leadership'},
		{y: 'Leadership', k: 'Strategic Scrum Mastery and Technical Direction', f: 'scrum-mastery'},
		{y: 'Leadership', k: 'Strategic Remote Team Building and Technical Direction', f: 'remote-team-building'},
		{y: 'Leadership', k: 'Strategic Tech Due Diligence and Technical Direction', f: 'tech-due-diligence'},
		{y: 'Leadership', k: 'Strategic Developer Productivity and Technical Direction', f: 'developer-productivity'},
		{y: 'Leadership', k: 'Strategic Startup MVP Development and Technical Direction', f: 'startup-mvp-development'},
		{y: 'Leadership', k: 'Strategic Fintech CTO and Technical Direction', f: 'fintech-cto'},
		{y: 'Leadership', k: 'Strategic Legal-Tech and Technical Direction', f: 'legal-tech'},
		{y: 'Career', k: 'Accelerate Your Career with Big Tech Careers Mentorship', f: 'big-tech-careers'},
		{y: 'Career', k: 'Accelerate Your Career with FAANG Interviews Mentorship', f: 'faang-interviews'},
		{y: 'Career', k: 'Accelerate Your Career with Algorithms Mentorship', f: 'algorithms'},
		{y: 'Career', k: 'Accelerate Your Career with Data Structures Mentorship', f: 'data-structures'},
		{y: 'Career', k: 'Accelerate Your Career with Resume Review Mentorship', f: 'resume-review'},
		{y: 'Career', k: 'Accelerate Your Career with Salary Negotiation Mentorship', f: 'salary-negotiation'},
		{y: 'Career', k: 'Accelerate Your Career with Career Pivot Mentorship', f: 'career-pivot'},
		{y: 'Career', k: 'Accelerate Your Career with Junior to Senior Mentorship', f: 'junior-to-senior'},
		{y: 'Career', k: 'Accelerate Your Career with Mock Interviews Mentorship', f: 'mock-interviews'},
		{y: 'Career', k: 'Accelerate Your Career with Full-Stack Transition Mentorship', f: 'full-stack-transition'},
		{y: 'AI', k: 'Integrate Generative AI into Your Product Stack', f: 'generative-ai'},
		{y: 'AI', k: 'Integrate LLM Integration into Your Product Stack', f: 'llm-integration'},
		{y: 'AI', k: 'Integrate RAG Architecture into Your Product Stack', f: 'rag-architecture'},
		{y: 'AI', k: 'Integrate Prompt Engineering into Your Product Stack', f: 'prompt-engineering'},
		{y: 'AI', k: 'Integrate LangChain into Your Product Stack', f: 'langchain'},
		{y: 'AI', k: 'Integrate Vector Databases into Your Product Stack', f: 'vector-databases'},
		{y: 'AI', k: 'Integrate Machine Learning Engineering into Your Product Stack', f: 'machine-learning-engineering'},
		{y: 'AI', k: 'Integrate AI Product Strategy into Your Product Stack', f: 'ai-product-strategy'}
	]);
var $author$project$Data$LegalPages$countByLanguage = function (lang) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(p.c, lang);
			},
			$author$project$Data$LegalPages$allPages));
};
var $author$project$Main$getPageTitle = function (route) {
	switch (route.$) {
		case 0:
			return 'Abdu Códigos - Engineer, Interview Coach & Legal Scholar';
		case 1:
			return 'Tech Talks & Speaking | Abdu Mappuji';
		case 2:
			return 'Credentials | Abdurrachman Mappuji';
		case 3:
			return 'Mentee Outcomes | Abdu Mappuji';
		case 4:
			return 'Hire Abdu Mappuji | Fractional CTO & Mentor';
		case 5:
			return 'Works | Blogs & Publications | Abdu Mappuji';
		case 6:
			return 'Codex | Archive by Abdu Mappuji';
		case 7:
			return 'Signals | Five 👋🏻 Signal Fridays | Abdu Mappuji';
		case 8:
			var slug = route.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Weekly Signal | Abdu Mappuji',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.I;
					},
					$author$project$Data$WeeklySignals$getBySlug(slug)));
		case 9:
			return 'Entrepreneurship & Investing | Abdu Mappuji';
		case 10:
			return 'Exclusive Tech Offers | Abdu Mappuji';
		case 11:
			return 'MentorCruise Mentoring | Abdu Mappuji';
		case 12:
			return 'Find Me On Social Platforms | Abdu Mappuji';
		case 13:
			return 'Group Mentoring on mentor.sh | Abdu Mappuji';
		case 14:
			return 'MeetAPro Mentoring & Consulting | Abdu Mappuji';
		case 15:
			var count = $elm$core$List$length($author$project$Data$Tags$allTags);
			var baseCount = ((count / 10) | 0) * 10;
			return 'Specialized Technical Services | ' + ($elm$core$String$fromInt(baseCount) + '+ Specialized Use Cases (Coding, AI, Architecture)');
		case 16:
			var count = $author$project$Data$LegalPages$countByLanguage('en');
			var baseCount = ((count / 10) | 0) * 10;
			return 'Technical Expert Witness | ' + ($elm$core$String$fromInt(baseCount) + '+ Specialized Use Cases (IT, AI, Software)');
		case 17:
			var count = $author$project$Data$LegalPages$countByLanguage('id');
			var baseCount = ((count / 10) | 0) * 10;
			return 'Saksi Ahli Teknologi Informasi | ' + ($elm$core$String$fromInt(baseCount) + '+ Kasus Penggunaan');
		case 18:
			var lang = route.a;
			var region = route.b;
			var topic = route.c;
			var forum = route.d;
			return A2(
				$elm$core$Maybe$withDefault,
				'Technical Expert Witness | Abdu Mappuji',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.I;
					},
					A4($author$project$Data$LegalPages$getByHierarchy, lang, region, topic, forum)));
		case 19:
			var slug = route.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Abdu Códigos - Engineer, Interview Coach & Legal Scholar',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.I;
					},
					$author$project$Data$SeoPages$getBySlug(slug)));
		case 20:
			return 'Portfolio (Beta) | Abdu Mappuji';
		case 21:
			return 'Referrals (Beta) | Abdu Mappuji';
		default:
			return 'Page Not Found | Abdu Mappuji';
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Main$getStructuredDataForRoute = function (route) {
	switch (route.$) {
		case 0:
			return '\n            {\n                "@context": "https://schema.org",\n                "@type": "Person",\n                "name": "Abdu Mappuji",\n                "url": "https://mpj.io",\n                "image": "https://mpj.io/hero-1.jpg",\n                "jobTitle": "Full Stack Engineer & Technical Expert Witness",\n                "worksFor": {\n                    "@type": "Organization",\n                    "name": "bol"\n                },\n                "sameAs": [\n                    "https://www.linkedin.com/in/abdurrachman-mappuji/",\n                    "https://twitter.com/mpjme",\n                    "https://github.com/empeje",\n                    "https://scholar.google.com/citations?user=aRReMSEAAAAJ&hl=en"\n                ]\n            }\n            ';
		case 19:
			var slug = route.a;
			var _v1 = $author$project$Data$SeoPages$getBySlug(slug);
			if (!_v1.$) {
				var page = _v1.a;
				var serviceSchema = '{\"@type\": \"Product\", \"name\": \"' + (page.I + ('\", \"brand\": {\"@type\": \"Person\", \"name\": \"Abdu Mappuji\", \"url\": \"https://mpj.io\", \"image\": \"https://mpj.io/hero-1.jpg\"}, \"image\": \"https://mpj.io/hero-1.jpg\", \"description\": \"' + (page.i + '\", \"offers\": { \"@type\": \"AggregateOffer\", \"priceCurrency\": \"USD\", \"lowPrice\": \"90\", \"highPrice\": \"1350\", \"offerCount\": \"4\" }, \"aggregateRating\": { \"@type\": \"AggregateRating\", \"ratingValue\": \"5.0\", \"bestRating\": \"5\", \"worstRating\": \"1\", \"ratingCount\": \"5\" }}')));
				var faqItems = A2(
					$elm$core$String$join,
					',',
					A2(
						$elm$core$List$map,
						function (f) {
							return '{\"@type\": \"Question\", \"name\": \"' + (f.b + ('\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"' + (f.a + '\"}}')));
						},
						page.j));
				var faqSchema = '{\"@type\": \"FAQPage\", \"mainEntity\": [' + (faqItems + ']}');
				var breadcrumbSchema = '{\"@type\": \"BreadcrumbList\", \"itemListElement\": [' + ('{\"@type\": \"ListItem\", \"position\": 1, \"name\": \"Home\", \"item\": \"https://mpj.io/\"},' + ('{\"@type\": \"ListItem\", \"position\": 2, \"name\": \"Services\", \"item\": \"https://mpj.io/services/\"},' + ('{\"@type\": \"ListItem\", \"position\": 3, \"name\": \"' + (page.k + ('\", \"item\": \"https://mpj.io/mentoring/' + (slug + '/\"}]}'))))));
				return '{\"@context\": \"https://schema.org\", \"@graph\": [' + (breadcrumbSchema + (',' + (serviceSchema + (',' + (faqSchema + ']}')))));
			} else {
				return '';
			}
		case 4:
			return '\n            {\n                "@context": "https://schema.org",\n                "@type": "Product",\n                "name": "Exclusive Mentoring by Abdu Mappuji",\n                "description": "One-on-one mentoring for high-potential engineers. 200+ engineers mentored one-on-one since 2019 across multiple platforms, with 100+ five-star reviews. Mentees have gone on to Amazon, Meta, Netflix, NVIDIA, Two Sigma, Red Hat and SAP.",\n                "brand": {\n                    "@type": "Person",\n                    "name": "Abdu Mappuji",\n                    "url": "https://mpj.io"\n                },\n                "offers": {\n                    "@type": "AggregateOffer",\n                    "priceCurrency": "USD",\n                    "lowPrice": "90",\n                    "highPrice": "1350",\n                    "offerCount": "3"\n                },\n                "aggregateRating": {\n                    "@type": "AggregateRating",\n                    "ratingValue": "5.0",\n                    "bestRating": "5",\n                    "worstRating": "1",\n                    "ratingCount": "2"\n                },\n                "review": [\n                    {\n                        "@type": "Review",\n                        "reviewRating": {\n                            "@type": "Rating",\n                            "ratingValue": "5",\n                            "bestRating": "5"\n                        },\n                        "author": {\n                            "@type": "Person",\n                            "name": "Wihlarko Prasdegdho (Edo)",\n                            "jobTitle": "Senior Engineer at Tridorian",\n                            "url": "https://www.linkedin.com/in/wihlarko-prasdegdho"\n                        },\n                        "reviewBody": "I recently have the privilege of being mentored in a 1-on-1 session with MPJ, and i\'am incredibly grateful for the experience. He shared insightful tips and tricks on how to win the hearts of HR and hiring managers during interviews, and also gave me valuable feedback on my CV. From that session, i realized there were many aspects of my CV and self-presentation that needed improvement, with his guidance i was able to refine my CV and develop a better approach to interviews. As a result, i started receiving multiple interview invitations including opportunities offering relocation to Europe and i\'am now excited to share that I have landed a fulltime remote role at a multinational company based in Singapore. Thank you so much, MPJ, for your support and mentorship, it truly made a real difference in my journey!",\n                        "datePublished": "2024-01-15"\n                    },\n                    {\n                        "@type": "Review",\n                        "reviewRating": {\n                            "@type": "Rating",\n                            "ratingValue": "5",\n                            "bestRating": "5"\n                        },\n                        "author": {\n                            "@type": "Person",\n                            "name": "Aurélien Lair",\n                            "url": "https://twitter.com/aurelien_lair"\n                        },\n                        "reviewBody": "Find out my last proof of concept of a CI/CD Gitlab pipeline runnable both locally or on gitlab with custom gitlab-runner. A special thanks to MPJ @YoKulGuy for his help on this. You are my Miyagi sensei bro 🇯🇵 🙇 🙏",\n                        "datePublished": "2023-04-24"\n                    }\n                ]\n            }\n            ';
		case 1:
			return '\n            {\n                "@context": "https://schema.org",\n                "@type": "ItemList",\n                "name": "Tech Talks and Speaking Engagements by Abdu Mappuji",\n                "description": "Public speaking engagements, tech talks, and conference presentations by Abdu Mappuji covering topics like Web3, blockchain, DevOps, Python, Elm, and software engineering.",\n                "itemListElement": [\n                    {\n                        "@type": "ListItem",\n                        "position": 1,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Cracking the Code: Master Algorithm Interviews with Abdu Mappuji",\n                            "description": "Master algorithm interviews in this MentorCruise event with Abdu Mappuji",\n                            "startDate": "2026-03-20",\n                            "endDate": "2026-03-20",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.linkedin.com/events/7436431710008872961/"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "MentorCruise",\n                                "url": "https://mentorcruise.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 2,\n                        "item": {\n                            "@type": "Event",\n                            "name": "#WeekdAI8 : Finding your path to big tech",\n                            "description": "Talk about finding path to big tech at WeekdAI event",\n                            "startDate": "2026-03-01",\n                            "endDate": "2026-03-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://luma.com/10kz2ca9?tk=LHfXAj"\n                            },\n                            "recordedIn": {\n                                "@type": "VideoObject",\n                                "url": "https://www.youtube.com/watch?v=5W_R-2zlZpg"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "WeekdAI",\n                                "url": "https://lu.ma/weekdai"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 3,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Building and monetizing MCP servers on Apify",\n                            "description": "Talk about building and monetizing MCP servers on Apify platform",\n                            "startDate": "2025-01-01",\n                            "endDate": "2025-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/live/w3AH3jIrXXo?feature=shared&t=1579"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Apify",\n                                "url": "https://apify.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 4,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Road to Devcon: Empowering the Next Generation of Web3 Innovators",\n                            "description": "Talk at Gadjah Mada Blockchain Club about empowering Web3 innovators",\n                            "startDate": "2024-01-01",\n                            "endDate": "2024-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://youtu.be/-2fBQXFpN7Q?feature=shared&t=3264"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Gadjah Mada Blockchain Club",\n                                "url": "https://www.instagram.com/gmblockchainclub/"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 5,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Hologram AI Pitch at Encode Club",\n                            "description": "Pitch presentation for Hologram AI project",\n                            "startDate": "2023-01-01",\n                            "endDate": "2023-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=n0U_7fK-YBY"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Encode Club",\n                                "url": "https://encode.club"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 6,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Run Rust Continuous Integration (CI) on ARM Architecture using Buildjet",\n                            "description": "Tutorial video about running Rust Continuous Integration (CI) on ARM Architecture using Buildjet.",\n                            "startDate": "2023-01-01",\n                            "endDate": "2023-01-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=_U2kRO_DpGE"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "YouTube",\n                                "url": "https://youtube.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 7,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Complete Web3 & Ethereum with Scala",\n                            "description": "Ya!vaConf talk about Web3 and Ethereum development with Scala",\n                            "startDate": "2022-09-28",\n                            "endDate": "2022-09-28",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "Place",\n                                "name": "Ya!vaConf",\n                                "url": "https://yavaconf.com/en/",\n                                "address": "Warsaw, Poland"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Ya!vaConf",\n                                "url": "https://yavaconf.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 8,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Web3 & Ethereum with Scala",\n                            "description": "ScalaWAW meetup talk about Web3 and Ethereum with Scala",\n                            "startDate": "2022-09-06",\n                            "endDate": "2022-09-06",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "Place",\n                                "name": "ScalaWAW",\n                                "url": "https://www.meetup.com/scalawaw/events/288163720/",\n                                "address": "Warsaw, Poland"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "ScalaWAW",\n                                "url": "https://www.meetup.com/scalawaw"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 9,\n                        "item": {\n                            "@type": "Event",\n                            "name": "DAO Masterclass",\n                            "description": "Remote Skills Academy masterclass on Decentralized Autonomous Organizations",\n                            "startDate": "2022-01-01",\n                            "endDate": "2022-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://youtu.be/SXljxRDzfGY"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Remote Skills Academy",\n                                "url": "https://remoteskills.academy"\n                            },\n                            "inLanguage": "id"\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 10,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Developer Perspective on Web3: Building During Bear Market",\n                            "description": "Republik Rupiah talk about Web3 development perspective during bear market",\n                            "startDate": "2022-01-01",\n                            "endDate": "2022-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://youtu.be/hPCP_42jcH0"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Republik Rupiah",\n                                "url": "https://republikrupiah.com"\n                            },\n                            "inLanguage": "id"\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 11,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Smart Contract Discussion",\n                            "description": "Podcast Indonesia Belajar episode about smart contracts",\n                            "startDate": "2022-01-01",\n                            "endDate": "2022-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=HE-81zhcCig&t=3027s"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Podcast Indonesia Belajar",\n                                "url": "https://www.youtube.com/watch?v=HE-81zhcCig&t=3027s"\n                            },\n                            "inLanguage": "id"\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 12,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Live Stream #2 - Belajar Software Engineer",\n                            "description": "Live stream session about learning to be a Software Engineer.",\n                            "startDate": "2022-01-01",\n                            "endDate": "2022-01-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=7guYU1KYO7w"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "YouTube",\n                                "url": "https://youtube.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 13,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Live Stream #1 - Belajar Software Engineer",\n                            "description": "Live stream session about learning to be a Software Engineer.",\n                            "startDate": "2022-01-01",\n                            "endDate": "2022-01-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=yN6CiiMM6Ks"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "YouTube",\n                                "url": "https://youtube.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 14,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Low-code Masterclass with Retool",\n                            "description": "Remote Skills Academy Bali masterclass on low-code development with Retool",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://us02web.zoom.us/rec/play/UR3gIJNnMzttJ_THqBtL8OWMJ4lCYOzGM_lM4BGggHnWrpcAWod0bwauaeXUxdVksBDAYtHkKlUsJWkN.te-e7mqNlXT-SN9c"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Remote Skills Academy Bali",\n                                "url": "https://remoteskills.academy"\n                            },\n                            "inLanguage": "id"\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 15,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Blockchain 101: Deploy your first smart contract with Python",\n                            "description": "PyCon Indonesia talk about blockchain and smart contract deployment with Python",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://pycon.id/speaker/"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "PyCon Indonesia",\n                                "url": "https://pycon.id"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 16,\n                        "item": {\n                            "@type": "Event",\n                            "name": "How Russian Doll Caching Can Improve Server Side Rendering",\n                            "description": "Web Directions Lazy Load talk about Russian Doll caching technique for SSR",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://player.vimeo.com/video/561110523"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Web Directions",\n                                "url": "https://www.webdirections.org"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 17,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Enjoy Typesafe Web Development with Eta",\n                            "description": "Conf42 Java talk about typesafe web development using Eta language",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=xGcQK0VCngI"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Conf42",\n                                "url": "https://www.meetup.com/Conf42-Online-Tech-Events"\n                            },\n                            "about": {\n                                "@type": "Thing",\n                                "name": "Java"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 18,\n                        "item": {\n                            "@type": "Event",\n                            "name": "KulWeekend #3: Markov Chain Bots",\n                            "description": "KulWeekend session about Markov Chain bots",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=YXOCGFzOtPo"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Kulkul Tech",\n                                "url": "https://kulkul.tech"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 19,\n                        "item": {\n                            "@type": "Event",\n                            "name": "E2E Test in Angular with Gitlab CI",\n                            "description": "Tutorial video about end-to-end testing in Angular using GitLab CI.",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=_RbJq7yH0D8"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "YouTube",\n                                "url": "https://youtube.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 20,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Intro to Low-code Internal Tool Development with Retool",\n                            "description": "Introductory session to low-code internal tool development with Retool.",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=-N2bstcbKec"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "YouTube",\n                                "url": "https://youtube.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 21,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Introduction to Abdu Códigos",\n                            "description": "Introduction video to Abdu Códigos channel and content.",\n                            "startDate": "2021-01-01",\n                            "endDate": "2021-01-01",\n                            "image": "https://mpj.io/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=ovBggeKly4k"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io",\n                                "image": "https://mpj.io/hero-1.jpg"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "YouTube",\n                                "url": "https://youtube.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 22,\n                        "item": {\n                            "@type": "Event",\n                            "name": "KulWeekend #2: Data Cleaning",\n                            "description": "KulWeekend session about data cleaning techniques",\n                            "startDate": "2020-01-01",\n                            "endDate": "2020-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=4wuN2UOVSp4"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Kulkul Tech",\n                                "url": "https://kulkul.tech"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 23,\n                        "item": {\n                            "@type": "Event",\n                            "name": "KulWeekend #1: Introduction to Python & Web Scraping",\n                            "description": "KulWeekend session introducing Python and web scraping",\n                            "startDate": "2020-01-01",\n                            "endDate": "2020-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=n-Em6-Xt4Co"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Kulkul Tech",\n                                "url": "https://kulkul.tech"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 24,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Build and Deploy Your First Website",\n                            "description": "KulTalks session on building and deploying websites",\n                            "startDate": "2020-01-01",\n                            "endDate": "2020-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=HOkyc23ZKE4"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "Kulkul Tech",\n                                "url": "https://kulkul.tech"\n                            },\n                            "inLanguage": "id"\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 25,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Intro to Social Coding with Git & GitHub",\n                            "description": "SabernX talk introducing Git and GitHub for social coding",\n                            "startDate": "2020-01-01",\n                            "endDate": "2020-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=gHi4l1N62wc"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "SabernX",\n                                "url": "https://www.youtube.com/watch?v=gHi4l1N62wc"\n                            },\n                            "inLanguage": "id"\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 26,\n                        "item": {\n                            "@type": "Event",\n                            "name": "How Teaching Convinced Me to Use Elm in Production",\n                            "description": "ElmJapan talk about using Elm in production environments (cancelled due to COVID-19)",\n                            "startDate": "2020-01-01",\n                            "endDate": "2020-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventCancelled",\n                            "location": {\n                                "@type": "Place",\n                                "name": "ElmJapan",\n                                "url": "https://elmjapan.guupa.com/speakers/Abdurrachman_Mappuji",\n                                "address": "Tokyo, Japan"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "ElmJapan",\n                                "url": "https://elmjapan.com"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 27,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Deploy Moodle in Raspberry Pi with Docker",\n                            "description": "MoodleMoot Philippines talk about deploying Moodle on Raspberry Pi using Docker",\n                            "startDate": "2018-01-01",\n                            "endDate": "2018-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "VirtualLocation",\n                                "url": "https://www.youtube.com/watch?v=jFP_ompB0vs"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "MoodleMoot Philippines",\n                                "url": "https://nephilaweb.com.ph"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 28,\n                        "item": {\n                            "@type": "Event",\n                            "name": "DevOps Practice in Nonprofit",\n                            "description": "DevOpsDay Jakarta talk about implementing DevOps practices in nonprofit organizations",\n                            "startDate": "2018-01-01",\n                            "endDate": "2018-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "Place",\n                                "name": "DevOpsDay Jakarta",\n                                "url": "https://www.youtube.com/watch?v=kTeUuLXzwzk",\n                                "address": "Jakarta, Indonesia"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "DevOpsDay Jakarta",\n                                "url": "https://devopsdays.org/events/jakarta"\n                            }\n                        }\n                    },\n                    {\n                        "@type": "ListItem",\n                        "position": 29,\n                        "item": {\n                            "@type": "Event",\n                            "name": "Playful Load Testing with Locust",\n                            "description": "PyCon Indonesia Surabaya talk about load testing using Locust framework",\n                            "startDate": "2017-01-01",\n                            "endDate": "2017-01-01",\n                            "image": "/hero-1.jpg",\n                            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",\n                            "eventStatus": "https://schema.org/EventScheduled",\n                            "location": {\n                                "@type": "Place",\n                                "name": "PyCon Indonesia Surabaya",\n                                "url": "https://www.youtube.com/watch?v=hLw0WZQajUo",\n                                "address": "Surabaya, Indonesia"\n                            },\n                            "offers": [],\n                            "performer": {\n                                "@type": "Person",\n                                "name": "Abdu Mappuji",\n                                "url": "https://mpj.io"\n                            },\n                            "organizer": {\n                                "@type": "Organization",\n                                "name": "PyCon Indonesia",\n                                "url": "https://pycon.id"\n                            }\n                        }\n                    }\n                ]\n            }\n            ';
		case 11:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 24, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 25, "name": "Services", "item": "https://mpj.io/services/"},\n                            {"@type": "ListItem", "position": 26, "name": "MentorCruise", "item": "https://mpj.io/mentorcruise/"}\n                        ]\n                    },\n                    {\n                        "@type": "Person",\n                        "name": "Abdu Mappuji",\n                        "url": "https://mpj.io",\n                        "jobTitle": "Full Stack Engineer",\n                        "worksFor": {\n                            "@type": "Organization",\n                            "name": "bol"\n                        },\n                        "knowsAbout": ["Software Engineering", "Career Advice & Self Mastery", "Leadership & Management", "DataScience & Analytics", "Entrepreneurship", "Artificial Intelligence", "Cloud Computing", "Mobile Development", "Web Development"],\n                        "alumniOf": ["Universitas Gadjah Mada (UGM)", "Institut Teknologi Bandung (ITB)", "Udacity Institute of AI & Technology (degree awarded by Woolf, EU-accredited)"],\n                        "sameAs": [\n                            "https://www.linkedin.com/in/abdurrachman-mappuji/",\n                            "https://twitter.com/mpjme",\n                            "https://github.com/empeje",\n                            "https://scholar.google.com/citations?user=aRReMSEAAAAJ&hl=en"\n                        ]\n                    },\n                    {\n                        "@type": "Product",\n                        "name": "Tech Career Mentoring by Abdu Mappuji (MentorCruise)",\n                        "description": "Mentoring for tech career growth, interview preparation (Algorithms, Data Structures, System Design), and confidence building. Helping engineers land jobs at Amazon, Meta, Netflix, NVIDIA, and other big techs.",\n                        "brand": {\n                            "@type": "Person",\n                            "name": "Abdu Mappuji",\n                            "url": "https://mpj.io",\n                            "image": "https://mpj.io/hero-1.jpg"\n                        },\n                        "offers": {\n                            "@type": "AggregateOffer",\n                            "priceCurrency": "USD",\n                            "lowPrice": "90",\n                            "highPrice": "1350",\n                            "offerCount": "3"\n                        },\n                        "aggregateRating": {\n                            "@type": "AggregateRating",\n                            "ratingValue": "5.0",\n                            "bestRating": "5",\n                            "worstRating": "1",\n                            "ratingCount": "5"\n                        }\n                    },\n                    {\n                        "@type": "FAQPage",\n                        "mainEntity": [\n                            {\n                                "@type": "Question",\n                                "name": "How does MentorCruise work?",\n                                "acceptedAnswer": {\n                                    "@type": "Answer",\n                                    "text": "MentorCruise provides structured programs and flexible scheduling for 1-on-1 mentoring with vetted professionals."\n                                }\n                            },\n                            {\n                                "@type": "Question",\n                                "name": "What are the benefits of MentorCruise?",\n                                "acceptedAnswer": {\n                                    "@type": "Answer",\n                                    "text": "Benefits include verified mentors, clear communication, a goal-oriented approach, and a comprehensive resource library."\n                                }\n                            }\n                        ]\n                    }\n                ]\n            }\n            ';
		case 13:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 30, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 31, "name": "Services", "item": "https://mpj.io/services/"},\n                            {"@type": "ListItem", "position": 32, "name": "mentor.sh", "item": "https://mpj.io/mentor-sh/"}\n                        ]\n                    },\n                    {\n                        "@type": "Person",\n                        "name": "Abdu Mappuji",\n                        "url": "https://mpj.io",\n                        "image": "https://mpj.io/hero-1.jpg",\n                        "jobTitle": "Full Stack Engineer",\n                        "worksFor": {\n                            "@type": "Organization",\n                            "name": "bol"\n                        },\n                        "knowsAbout": ["Software Engineering", "Career Advice & Self Mastery", "Leadership & Management", "DataScience & Analytics", "Entrepreneurship", "Artificial Intelligence", "Cloud Computing", "Mobile Development", "Web Development"],\n                        "alumniOf": ["Universitas Gadjah Mada (UGM)", "Institut Teknologi Bandung (ITB)", "Udacity Institute of AI & Technology (degree awarded by Woolf, EU-accredited)"],\n                        "sameAs": [\n                            "https://www.linkedin.com/in/abdurrachman-mappuji/",\n                            "https://twitter.com/mpjme",\n                            "https://github.com/empeje",\n                            "https://scholar.google.com/citations?user=aRReMSEAAAAJ&hl=en"\n                        ]\n                    },\n                    {\n                        "@type": "Product",\n                        "name": "Group Mentoring at mentor.sh by Abdu Mappuji",\n                        "description": "Collaborative group mentoring sessions on mentor.sh, focusing on active, peer-based learning, system design, and career growth for software engineers.",\n                        "brand": {\n                            "@type": "Person",\n                            "name": "Abdu Mappuji",\n                            "url": "https://mpj.io",\n                            "image": "https://mpj.io/hero-1.jpg"\n                        },\n                        "offers": {\n                            "@type": "AggregateOffer",\n                            "priceCurrency": "USD",\n                            "lowPrice": "20",\n                            "highPrice": "100",\n                            "offerCount": "1"\n                        },\n                        "aggregateRating": {\n                            "@type": "AggregateRating",\n                            "ratingValue": "5.0",\n                            "bestRating": "5",\n                            "worstRating": "1",\n                            "ratingCount": "5"\n                        }\n                    },\n                    {\n                        "@type": "FAQPage",\n                        "mainEntity": [\n                            {\n                                "@type": "Question",\n                                "name": "What is mentor.sh?",\n                                "acceptedAnswer": {\n                                    "@type": "Answer",\n                                    "text": "mentor.sh is a platform for active, peer-based group learning and architectural discussions."\n                                }\n                            }\n                        ]\n                    }\n                ]\n            }\n            ';
		case 14:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 1, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 2, "name": "Services", "item": "https://mpj.io/services/"},\n                            {"@type": "ListItem", "position": 3, "name": "MeetAPro", "item": "https://mpj.io/meetapro/"}\n                        ]\n                    },\n                    {\n                        "@type": "Person",\n                        "name": "Abdu Mappuji",\n                        "url": "https://mpj.io/",\n                        "image": "https://mpj.io/hero-1.jpg",\n                        "jobTitle": "Full Stack Engineer",\n                        "worksFor": {\n                            "@type": "Organization",\n                            "name": "bol"\n                        },\n                        "knowsAbout": ["Software Engineering", "Career Advice & Self Mastery", "Leadership & Management", "DataScience & Analytics", "Entrepreneurship", "Artificial Intelligence", "Cloud Computing", "Mobile Development", "Web Development"],\n                        "alumniOf": ["Universitas Gadjah Mada (UGM)", "Institut Teknologi Bandung (ITB)", "Udacity Institute of AI & Technology (degree awarded by Woolf, EU-accredited)"],\n                        "sameAs": [\n                            "https://www.linkedin.com/in/abdurrachman-mappuji/",\n                            "https://twitter.com/mpjme",\n                            "https://github.com/empeje",\n                            "https://scholar.google.com/citations?user=aRReMSEAAAAJ&hl=en",\n                            "https://www.meetapro.com/provider/empeje#listings"\n                        ]\n                    },\n                    {\n                        "@type": "Product",\n                        "name": "Tech Consulting & Coaching by Abdu Mappuji (MeetAPro)",\n                        "description": "Mock interviews, resume review, system design consulting, and tech leadership advisory on MeetAPro platform.",\n                        "brand": {\n                            "@type": "Person",\n                            "name": "Abdu Mappuji",\n                            "url": "https://mpj.io/",\n                            "image": "https://mpj.io/hero-1.jpg"\n                        },\n                        "offers": {\n                            "@type": "AggregateOffer",\n                            "priceCurrency": "USD",\n                            "lowPrice": "90",\n                            "highPrice": "1350",\n                            "offerCount": "4"\n                        },\n                        "aggregateRating": {\n                            "@type": "AggregateRating",\n                            "ratingValue": "5.0",\n                            "bestRating": "5",\n                            "worstRating": "1",\n                            "ratingCount": "5"\n                        }\n                    },\n                    {\n                        "@type": "FAQPage",\n                        "mainEntity": [\n                            {\n                                "@type": "Question",\n                                "name": "What is MeetAPro?",\n                                "acceptedAnswer": {\n                                    "@type": "Answer",\n                                    "text": "MeetAPro is a platform offering Mock Interviews, Resume Reviews, Career Coaching, and Consulting from industry experts."\n                                }\n                            }\n                        ]\n                    }\n                ]\n            }\n            ';
		case 15:
			var serviceItems = A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, tag) {
							return '{\"@type\": \"ListItem\", \"position\": ' + ($elm$core$String$fromInt(idx + 1) + (', \"item\": {\"@type\": \"Product\", \"name\": \"' + (tag.k + ('\", \"url\": \"https://mpj.io/mentoring/' + (tag.f + '/\", \"image\": \"https://mpj.io/hero-1.jpg\", \"brand\": {\"@type\": \"Person\", \"name\": \"Abdu Mappuji\"}, \"offers\": { \"@type\": \"AggregateOffer\", \"priceCurrency\": \"USD\", \"lowPrice\": \"90\", \"highPrice\": \"1350\", \"offerCount\": \"4\" }, \"aggregateRating\": { \"@type\": \"AggregateRating\", \"ratingValue\": \"5.0\", \"bestRating\": \"5\", \"worstRating\": \"1\", \"ratingCount\": \"5\" }}}')))));
						}),
					$author$project$Data$Tags$allTags));
			var itemListSchema = '{\"@type\": \"ItemList\", \"name\": \"Specialized Mentoring Services by Abdu Mappuji\", \"image\": \"https://mpj.io/hero-1.jpg\", \"numberOfItems\": ' + ($elm$core$String$fromInt(
				$elm$core$List$length($author$project$Data$Tags$allTags)) + (', \"itemListElement\": [' + (serviceItems + ']}')));
			var breadcrumbSchema = '{\"@type\": \"BreadcrumbList\", \"itemListElement\": [' + ('{\"@type\": \"ListItem\", \"position\": 1, \"name\": \"Home\", \"item\": \"https://mpj.io/\"},' + ('{\"@type\": \"ListItem\", \"position\": 2, \"name\": \"Services\", \"item\": \"https://mpj.io/services/\"}' + ']}'));
			return '{\"@context\": \"https://schema.org\", \"@graph\": [' + (breadcrumbSchema + (',' + (itemListSchema + ']}')));
		case 16:
			var langPages = A2(
				$elm$core$List$filter,
				function (p) {
					return p.c === 'en';
				},
				$author$project$Data$LegalPages$allPages);
			var itemListElement = A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, p) {
							return '{\"@type\": \"ListItem\", \"position\": ' + ($elm$core$String$fromInt(idx + 1) + (', \"item\": {\"@type\": \"Product\", \"name\": \"' + (p.k + ('\", \"url\": \"https://mpj.io/expert-witness/' + (p.e + ('/' + (p.g + ('/' + (p.d + ('/\", \"description\": \"' + (p.i + '\", \"brand\": {\"@type\": \"Person\", \"name\": \"Abdu Mappuji\"}, \"offers\": {\"@type\": \"AggregateOffer\", \"priceCurrency\": \"USD\", \"lowPrice\": \"500\", \"highPrice\": \"10000\", \"offerCount\": \"1\"}, \"aggregateRating\": {\"@type\": \"AggregateRating\", \"ratingValue\": \"5.0\", \"bestRating\": \"5\", \"worstRating\": \"1\", \"ratingCount\": \"5\"}}}')))))))))));
						}),
					langPages));
			var h1 = 'Technical Expert Witness';
			var description = 'A decade of engineering across Booking.com, bol.com, Picnic and Delivery Hero\'s Glovo, combined with an MS in Artificial Intelligence, published HPC research, doctoral work in Explainable AI, and LLB(candidate) legal scholarship.';
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 33, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 34, "name": "Expert Witness", "item": "https://mpj.io/expert-witness/"}\n                        ]\n                    },\n                    {\n                        "@type": "ItemList",\n                        "name": "Technical Expert Witness Services Catalog",\n                        "numberOfItems": ' + ($elm$core$String$fromInt(
				$elm$core$List$length(langPages)) + (',\n                        "itemListElement": [' + (itemListElement + (']\n                    },\n                    {\n                        "@type": "Product",\n                        "name": \"' + (h1 + ('",\n                        "brand": {\n                            "@type": "Person",\n                            "name": "Abdu Mappuji",\n                            "jobTitle": "Technical Expert Witness & CTO",\n                            "hasCredential": ["LLB (Candidate)", "ITB Graduate", "UGM Graduate"]\n                        },\n                        "offers": {\n                            "@type": "AggregateOffer",\n                            "priceCurrency": "USD",\n                            "lowPrice": "500",\n                            "highPrice": "10000",\n                            "offerCount": "1"\n                        },\n                        "description": \"' + (description + '"\n                    }\n                ]\n            }\n            ')))))));
		case 17:
			var langPages = A2(
				$elm$core$List$filter,
				function (p) {
					return p.c === 'id';
				},
				$author$project$Data$LegalPages$allPages);
			var itemListElement = A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, p) {
							return '{\"@type\": \"ListItem\", \"position\": ' + ($elm$core$String$fromInt(idx + 1) + (', \"item\": {\"@type\": \"Product\", \"name\": \"' + (p.k + ('\", \"url\": \"https://mpj.io/saksi-ahli/' + (p.e + ('/' + (p.g + ('/' + (p.d + ('/\", \"description\": \"' + (p.i + '\", \"brand\": {\"@type\": \"Person\", \"name\": \"Abdu Mappuji\"}, \"offers\": {\"@type\": \"AggregateOffer\", \"priceCurrency\": \"IDR\", \"lowPrice\": \"5000000\", \"highPrice\": \"50000000\", \"offerCount\": \"1\"}, \"aggregateRating\": {\"@type\": \"AggregateRating\", \"ratingValue\": \"5.0\", \"bestRating\": \"5\", \"worstRating\": \"1\", \"ratingCount\": \"5\"}}}')))))))))));
						}),
					langPages));
			var h1 = 'Saksi Ahli Teknologi Informasi';
			var description = 'Satu dekade pengalaman engineering di Booking.com, bol.com, Picnic dan Delivery Hero\'s Glovo, dipadukan dengan MS Artificial Intelligence, riset HPC terpublikasi, penelitian doktoral di bidang Explainable AI, dan landasan hukum LLB(candidate).';
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 35, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 36, "name": "Saksi Ahli", "item": "https://mpj.io/saksi-ahli/"}\n                        ]\n                    },\n                    {\n                        "@type": "ItemList",\n                        "name": "Katalog Layanan Saksi Ahli Teknologi Informasi",\n                        "numberOfItems": ' + ($elm$core$String$fromInt(
				$elm$core$List$length(langPages)) + (',\n                        "itemListElement": [' + (itemListElement + (']\n                    },\n                    {\n                        "@type": "Product",\n                        "name": \"' + (h1 + ('",\n                        "brand": {\n                            "@type": "Person",\n                            "name": "Abdu Mappuji",\n                            "jobTitle": "Saksi Ahli TI & CTO",\n                            "hasCredential": ["LLB (Candidate)", "ITB Graduate", "UGM Graduate"]\n                        },\n                        "offers": {\n                            "@type": "AggregateOffer",\n                            "priceCurrency": "IDR",\n                            "lowPrice": "5000000",\n                            "highPrice": "50000000",\n                            "offerCount": "1"\n                        },\n                        "description": \"' + (description + '"\n                    }\n                ]\n            }\n            ')))))));
		case 18:
			var lang = route.a;
			var region = route.b;
			var topic = route.c;
			var forum = route.d;
			var _v2 = A4($author$project$Data$LegalPages$getByHierarchy, lang, region, topic, forum);
			if (!_v2.$) {
				var page = _v2.a;
				var rootUrl = (lang === 'en') ? 'https://mpj.io/expert-witness/' : 'https://mpj.io/saksi-ahli/';
				var rootLabel = (lang === 'en') ? 'Expert Witness' : 'Saksi Ahli';
				var productSchema = '{\"@type\": \"Product\", \"name\": \"' + (page.k + ('\", \"brand\": {\"@type\": \"Person\", \"name\": \"Abdu Mappuji\", \"jobTitle\": \"Technical Expert Witness & CTO\", \"hasCredential\": [\"LLB (Candidate)\", \"ITB Graduate\", \"UGM Graduate\"]}, \"offers\": {\"@type\": \"AggregateOffer\", \"priceCurrency\": \"' + (((lang === 'id') ? 'IDR' : 'USD') + ('\", \"lowPrice\": \"' + (((lang === 'id') ? '5000000' : '500') + ('\", \"highPrice\": \"' + (((lang === 'id') ? '50000000' : '10000') + ('\", \"offerCount\": \"1\"}, \"description\": \"' + (page.i + '\"}')))))))));
				var pageUrl = (lang === 'en') ? ('https://mpj.io/expert-witness/' + (region + ('/' + (topic + ('/' + (forum + '/')))))) : ('https://mpj.io/saksi-ahli/' + (region + ('/' + (topic + ('/' + (forum + '/'))))));
				var faqItems = A2(
					$elm$core$String$join,
					',',
					A2(
						$elm$core$List$map,
						function (f) {
							return '{\"@type\": \"Question\", \"name\": \"' + (f.b + ('\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"' + (f.a + '\"}}')));
						},
						page.j));
				var faqSchema = '{\"@type\": \"FAQPage\", \"mainEntity\": [' + (faqItems + ']}');
				var breadcrumbSchema = '{\"@type\": \"BreadcrumbList\", \"itemListElement\": [' + ('{\"@type\": \"ListItem\", \"position\": 1, \"name\": \"Home\", \"item\": \"https://mpj.io/\"},' + ('{\"@type\": \"ListItem\", \"position\": 2, \"name\": \"' + (rootLabel + ('\", \"item\": \"' + (rootUrl + ('\"},' + ('{\"@type\": \"ListItem\", \"position\": 3, \"name\": \"' + (page.k + ('\", \"item\": \"' + (pageUrl + '\"}]}'))))))))));
				return '{\"@context\": \"https://schema.org\", \"@graph\": [' + (breadcrumbSchema + (',' + (productSchema + (',' + (faqSchema + ']}')))));
			} else {
				return '';
			}
		case 9:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 37, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 38, "name": "Entrepreneurship", "item": "https://mpj.io/entrepreneurship"}\n                        ]\n                    },\n                    {\n                        "@type": "Product",\n                        "name": "Entrepreneurship & Venture Building by Abdu Mappuji",\n                        "description": "Insights and services related to building tech startups, venture building, and CTO leadership in the algorithm economy.",\n                        "brand": {\n                            "@type": "Person",\n                            "name": "Abdu Mappuji",\n                            "url": "https://mpj.io",\n                            "image": "https://mpj.io/hero-1.jpg"\n                        },\n                        "offers": {\n                            "@type": "AggregateOffer",\n                            "priceCurrency": "USD",\n                            "lowPrice": "90",\n                            "highPrice": "1350",\n                            "offerCount": "1"\n                        },\n                        "aggregateRating": {\n                            "@type": "AggregateRating",\n                            "ratingValue": "5.0",\n                            "bestRating": "5",\n                            "worstRating": "1",\n                            "ratingCount": "5"\n                        }\n                    }\n                ]\n            }\n            ';
		case 5:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 1, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 2, "name": "Works", "item": "https://mpj.io/writings/"}\n                        ]\n                    }\n                ]\n            }\n            ';
		case 6:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 1, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 2, "name": "Codex", "item": "https://mpj.io/codex/"}\n                        ]\n                    },\n                    {\n                        "@type": "ItemList",\n                        "name": "Blogs and Publications by Abdu Mappuji",\n                        "description": "Collection of technical blogs, research publications, and articles by Abdu Mappuji.",\n                        "itemListElement": [\n                            {\n                                "@type": "ListItem",\n                                "position": 1,\n                                "name": "Medium",\n                                "item": "https://medium.com/@empeje"\n                            },\n                            {\n                                "@type": "ListItem",\n                                "position": 2,\n                                "name": "Substack",\n                                "item": "https://com6.substack.com"\n                            }\n                        ]\n                    }\n                ]\n            }\n            ';
		case 7:
			return '\n            {\n                "@context": "https://schema.org",\n                "@graph": [\n                    {\n                        "@type": "BreadcrumbList",\n                        "itemListElement": [\n                            {"@type": "ListItem", "position": 1, "name": "Home", "item": "https://mpj.io/"},\n                            {"@type": "ListItem", "position": 2, "name": "Signals", "item": "https://mpj.io/signals/"}\n                        ]\n                    }\n                ]\n            }\n            ';
		case 8:
			var slug = route.a;
			var _v3 = $author$project$Data$WeeklySignals$getBySlug(slug);
			if (_v3.$ === 1) {
				return '';
			} else {
				var signal = _v3.a;
				var esc = function (s) {
					return A3(
						$elm$core$String$replace,
						'\"',
						'\\\"',
						A3($elm$core$String$replace, '\\', '\\\\', s));
				};
				return '{\"@context\":\"https://schema.org\",\"@graph\":[' + ('{\"@type\":\"BreadcrumbList\",\"itemListElement\":[' + ('{\"@type\":\"ListItem\",\"position\":1,\"name\":\"Home\",\"item\":\"https://mpj.io/\"},' + ('{\"@type\":\"ListItem\",\"position\":2,\"name\":\"Signals\",\"item\":\"https://mpj.io/signals/\"},' + ('{\"@type\":\"ListItem\",\"position\":3,\"name\":\"W' + ($elm$core$String$fromInt(signal.al) + ('\",\"item\":\"https://mpj.io/signals/' + (signal.f + ('/\"}]},' + ('{\"@type\":\"BlogPosting\",\"headline\":\"' + (esc(signal.I) + ('\",\"datePublished\":\"' + (signal.F + ('\",\"description\":\"' + (esc(signal.i) + ('\",\"author\":{\"@type\":\"Person\",\"name\":\"Abdu Mappuji\",\"url\":\"https://mpj.io/\"},\"url\":\"https://mpj.io/signals/' + (signal.f + ('/\"}' + ']}')))))))))))))))));
			}
		default:
			return '';
	}
};
var $author$project$Main$OnTime = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Main$getTime = A2($elm$core$Task$perform, $author$project$Main$OnTime, $elm$time$Time$now);
var $author$project$Pages$Codex$init = {aL: 20};
var $author$project$Pages$ExpertWitness$init = {ay: '', bt: $elm$core$Maybe$Nothing, bu: $elm$core$Maybe$Nothing};
var $author$project$Pages$MeetAPro$init = {};
var $author$project$Pages$MentorCruise$init = {};
var $author$project$Pages$MentorSh$init = {};
var $author$project$Pages$Offers$init = {a$: ''};
var $author$project$Pages$PortfolioBeta$Loading = {$: 0};
var $author$project$Pages$PortfolioBeta$init = {aA: $author$project$Pages$PortfolioBeta$Loading};
var $author$project$Pages$ReferralsBeta$Loading = {$: 0};
var $author$project$Pages$ReferralsBeta$init = {aA: $author$project$Pages$ReferralsBeta$Loading};
var $author$project$Pages$Services$init = {ay: '', bs: $elm$core$Maybe$Nothing};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Main$QueryParams = F4(
	function (q, category, topic, region) {
		return {y: category, b: q, e: region, g: topic};
	});
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elm$url$Url$Parser$Query$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		return function (dict) {
			return A4(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict));
		};
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aD: frag, aE: params, aB: unvisited, cp: value, aG: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aB;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.cp);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.cp);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.c7),
					$elm$url$Url$Parser$prepareQuery(url.b6),
					url.bK,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.aG;
		var unvisited = _v1.aB;
		var params = _v1.aE;
		var frag = _v1.aD;
		var value = _v1.cp;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Main$parseQueryParams = function (url) {
	var queryParser = A5(
		$elm$url$Url$Parser$Query$map4,
		$author$project$Main$QueryParams,
		A2(
			$elm$url$Url$Parser$Query$map,
			$elm$core$Maybe$withDefault(''),
			$elm$url$Url$Parser$Query$string('q')),
		$elm$url$Url$Parser$Query$string('category'),
		$elm$url$Url$Parser$Query$string('topic'),
		$elm$url$Url$Parser$Query$string('region'));
	return A2(
		$elm$core$Maybe$withDefault,
		A4($author$project$Main$QueryParams, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		A2(
			$elm$url$Url$Parser$parse,
			A2($elm$url$Url$Parser$questionMark, $elm$url$Url$Parser$top, queryParser),
			_Utils_update(
				url,
				{c7: ''})));
};
var $author$project$Main$NotFound = {$: 22};
var $author$project$Main$Appearances = {$: 1};
var $author$project$Main$Codex = {$: 6};
var $author$project$Main$Credentials = {$: 2};
var $author$project$Main$Entrepreneurship = {$: 9};
var $author$project$Main$ExpertWitness = {$: 16};
var $author$project$Main$FindMeIn = {$: 12};
var $author$project$Main$HireMe = {$: 4};
var $author$project$Main$Home = {$: 0};
var $author$project$Main$LegalDetail = F4(
	function (a, b, c, d) {
		return {$: 18, a: a, b: b, c: c, d: d};
	});
var $author$project$Main$MeetAPro = {$: 14};
var $author$project$Main$MentorCruise = {$: 11};
var $author$project$Main$MentorSh = {$: 13};
var $author$project$Main$Offers = {$: 10};
var $author$project$Main$Outcomes = {$: 3};
var $author$project$Main$SaksiAhli = {$: 17};
var $author$project$Main$Services = {$: 15};
var $author$project$Main$SignalDetail = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$Signals = {$: 7};
var $author$project$Main$TagDetail = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$Writings = {$: 5};
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aG;
		var unvisited = _v0.aB;
		var params = _v0.aE;
		var frag = _v0.aD;
		var value = _v0.cp;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aG;
			var unvisited = _v1.aB;
			var params = _v1.aE;
			var frag = _v1.aD;
			var value = _v1.cp;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aG;
		var unvisited = _v0.aB;
		var params = _v0.aE;
		var frag = _v0.aD;
		var value = _v0.cp;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aG;
			var unvisited = _v0.aB;
			var params = _v0.aE;
			var frag = _v0.aD;
			var value = _v0.cp;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Main$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Main$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Appearances,
			$elm$url$Url$Parser$s('appearances')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Credentials,
			$elm$url$Url$Parser$s('credentials')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Outcomes,
			$elm$url$Url$Parser$s('outcomes')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$HireMe,
			$elm$url$Url$Parser$s('hire-me')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Writings,
			$elm$url$Url$Parser$s('writings')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Codex,
			$elm$url$Url$Parser$s('codex')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Signals,
			$elm$url$Url$Parser$s('signals')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$SignalDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('signals'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Entrepreneurship,
			$elm$url$Url$Parser$s('entrepreneurship')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Offers,
			$elm$url$Url$Parser$s('offers')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$MentorCruise,
			$elm$url$Url$Parser$s('mentorcruise')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$FindMeIn,
			$elm$url$Url$Parser$s('find-me-in')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$MentorSh,
			$elm$url$Url$Parser$s('mentor-sh')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$MeetAPro,
			$elm$url$Url$Parser$s('meetapro')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$Services,
			$elm$url$Url$Parser$s('services')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$ExpertWitness,
			$elm$url$Url$Parser$s('expert-witness')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$SaksiAhli,
			$elm$url$Url$Parser$s('saksi-ahli')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$LegalDetail('en'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('expert-witness'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$LegalDetail('id'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('saksi-ahli'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$TagDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('mentoring'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$PortfolioBeta,
			$elm$url$Url$Parser$s('portfolio-beta')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Main$ReferralsBeta,
			$elm$url$Url$Parser$s('referrals-beta'))
		]));
var $author$project$Main$parseUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Main$NotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Main$routeParser, url));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Main$updateMetaDescription = _Platform_outgoingPort('updateMetaDescription', $elm$json$Json$Encode$string);
var $author$project$Main$updateOgUrl = _Platform_outgoingPort('updateOgUrl', $elm$json$Json$Encode$string);
var $author$project$Main$updateStructuredData = _Platform_outgoingPort('updateStructuredData', $elm$json$Json$Encode$string);
var $author$project$Main$updateTitle = _Platform_outgoingPort('updateTitle', $elm$json$Json$Encode$string);
var $author$project$Main$init = F3(
	function (_v0, url, key) {
		var servicesModel = $author$project$Pages$Services$init;
		var route = $author$project$Main$parseUrl(url);
		var params = $author$project$Main$parseQueryParams(url);
		var updatedServicesModel = _Utils_update(
			servicesModel,
			{ay: params.b, bs: params.y});
		var expertWitnessModel = $author$project$Pages$ExpertWitness$init;
		var updatedExpertWitnessModel = _Utils_update(
			expertWitnessModel,
			{ay: params.b, bt: params.e, bu: params.g});
		return _Utils_Tuple2(
			{
				aN: $author$project$Pages$Codex$init,
				ar: updatedExpertWitnessModel,
				aO: key,
				aR: $author$project$Pages$MeetAPro$init,
				aS: $author$project$Pages$MentorCruise$init,
				aT: $author$project$Pages$MentorSh$init,
				aU: $author$project$Pages$Offers$init,
				aY: $author$project$Pages$PortfolioBeta$init,
				a_: $author$project$Pages$ReferralsBeta$init,
				aq: route,
				az: updatedServicesModel,
				bh: $elm$time$Time$millisToPosix(0)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Main$getTime,
						_Utils_eq(route, $author$project$Main$PortfolioBeta) ? A2($elm$core$Platform$Cmd$map, $author$project$Main$PortfolioBetaMsg, $author$project$Pages$PortfolioBeta$fetch) : $elm$core$Platform$Cmd$none,
						_Utils_eq(route, $author$project$Main$ReferralsBeta) ? A2($elm$core$Platform$Cmd$map, $author$project$Main$ReferralsBetaMsg, $author$project$Pages$ReferralsBeta$fetch) : $elm$core$Platform$Cmd$none,
						$author$project$Main$updateStructuredData(
						$author$project$Main$getStructuredDataForRoute(route)),
						$author$project$Main$updateOgUrl(
						$author$project$Main$getCanonicalUrl(route)),
						$author$project$Main$updateTitle(
						$author$project$Main$getPageTitle(route)),
						$author$project$Main$updateMetaDescription(
						$author$project$Main$getMetaDescription(route))
					])));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.b5;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.bK,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.b6,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.b2,
					_Utils_ap(http, url.bP)),
				url.c7)));
};
var $author$project$Pages$Codex$update = F2(
	function (msg, model) {
		return _Utils_update(
			model,
			{aL: model.aL + 20});
	});
var $author$project$Pages$ExpertWitness$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var query = msg.a;
				return _Utils_update(
					model,
					{ay: query});
			case 1:
				var region = msg.a;
				return _Utils_update(
					model,
					{bt: region});
			default:
				var topic = msg.a;
				return _Utils_update(
					model,
					{bu: topic});
		}
	});
var $author$project$Pages$MeetAPro$update = F2(
	function (msg, model) {
		return model;
	});
var $author$project$Pages$MentorCruise$update = F2(
	function (msg, model) {
		return model;
	});
var $author$project$Pages$MentorSh$update = F2(
	function (msg, model) {
		return model;
	});
var $author$project$Pages$Offers$update = F2(
	function (msg, model) {
		var filter = msg;
		return _Utils_update(
			model,
			{a$: filter});
	});
var $author$project$Pages$PortfolioBeta$Failed = {$: 1};
var $author$project$Pages$PortfolioBeta$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PortfolioBeta$isPublic = function (project) {
	return project.b0 === 'Public';
};
var $author$project$Pages$PortfolioBeta$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var projects = msg.a;
			return _Utils_update(
				model,
				{
					aA: $author$project$Pages$PortfolioBeta$Loaded(
						A2($elm$core$List$filter, $author$project$Pages$PortfolioBeta$isPublic, projects))
				});
		} else {
			return _Utils_update(
				model,
				{aA: $author$project$Pages$PortfolioBeta$Failed});
		}
	});
var $author$project$Pages$ReferralsBeta$Failed = {$: 1};
var $author$project$Pages$ReferralsBeta$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ReferralsBeta$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var referrals = msg.a;
			return _Utils_update(
				model,
				{
					aA: $author$project$Pages$ReferralsBeta$Loaded(
						A2(
							$elm$core$List$filter,
							function ($) {
								return $.bT;
							},
							referrals))
				});
		} else {
			return _Utils_update(
				model,
				{aA: $author$project$Pages$ReferralsBeta$Failed});
		}
	});
var $author$project$Pages$Services$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var query = msg.a;
			return _Utils_update(
				model,
				{ay: query});
		} else {
			var cat = msg.a;
			return _Utils_update(
				model,
				{bs: cat});
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Main$updateExpertUrl = F3(
	function (key, route, model) {
		var topicParam = function () {
			var _v1 = model.bu;
			if (!_v1.$) {
				var topic = _v1.a;
				return 'topic=' + topic;
			} else {
				return '';
			}
		}();
		var regionParam = function () {
			var _v0 = model.bt;
			if (!_v0.$) {
				var region = _v0.a;
				return 'region=' + region;
			} else {
				return '';
			}
		}();
		var qParam = $elm$core$String$isEmpty(model.ay) ? '' : ('q=' + model.ay);
		var params = A2(
			$elm$core$String$join,
			'&',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				_List_fromArray(
					[qParam, topicParam, regionParam])));
		var base = _Utils_eq(route, $author$project$Main$SaksiAhli) ? '/saksi-ahli' : '/expert-witness';
		var url = $elm$core$String$isEmpty(params) ? base : (base + ('?' + params));
		return A2($elm$browser$Browser$Navigation$replaceUrl, key, url);
	});
var $author$project$Main$updateServicesUrl = F2(
	function (key, model) {
		var qParam = $elm$core$String$isEmpty(model.ay) ? '' : ('q=' + model.ay);
		var catParam = function () {
			var _v0 = model.bs;
			if (!_v0.$) {
				var cat = _v0.a;
				return 'category=' + cat;
			} else {
				return '';
			}
		}();
		var params = A2(
			$elm$core$String$join,
			'&',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				_List_fromArray(
					[qParam, catParam])));
		var url = $elm$core$String$isEmpty(params) ? '/services' : ('/services?' + params);
		return A2($elm$browser$Browser$Navigation$replaceUrl, key, url);
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bh: time}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.aO,
							$elm$url$Url$toString(url)));
				} else {
					var href = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 3:
				var url = msg.a;
				var params = $author$project$Main$parseQueryParams(url);
				var newRoute = $author$project$Main$parseUrl(url);
				var currentServices = model.az;
				var updatedServices = _Utils_eq(newRoute, $author$project$Main$Services) ? _Utils_update(
					currentServices,
					{ay: params.b, bs: params.y}) : currentServices;
				var currentExpert = model.ar;
				var updatedExpert = (_Utils_eq(newRoute, $author$project$Main$ExpertWitness) || _Utils_eq(newRoute, $author$project$Main$SaksiAhli)) ? _Utils_update(
					currentExpert,
					{ay: params.b, bt: params.e, bu: params.g}) : currentExpert;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ar: updatedExpert, aq: newRoute, az: updatedServices}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$updateStructuredData(
								$author$project$Main$getStructuredDataForRoute(newRoute)),
								$author$project$Main$updateOgUrl(
								$author$project$Main$getCanonicalUrl(newRoute)),
								$author$project$Main$updateMetaDescription(
								$author$project$Main$getMetaDescription(newRoute)),
								$author$project$Main$updateTitle(
								$author$project$Main$getPageTitle(newRoute)),
								(_Utils_eq(newRoute, $author$project$Main$PortfolioBeta) && (!_Utils_eq(model.aq, $author$project$Main$PortfolioBeta))) ? A2($elm$core$Platform$Cmd$map, $author$project$Main$PortfolioBetaMsg, $author$project$Pages$PortfolioBeta$fetch) : $elm$core$Platform$Cmd$none,
								(_Utils_eq(newRoute, $author$project$Main$ReferralsBeta) && (!_Utils_eq(model.aq, $author$project$Main$ReferralsBeta))) ? A2($elm$core$Platform$Cmd$map, $author$project$Main$ReferralsBetaMsg, $author$project$Pages$ReferralsBeta$fetch) : $elm$core$Platform$Cmd$none
							])));
			case 4:
				var offersMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aU: A2($author$project$Pages$Offers$update, offersMsg, model.aU)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var mentorCruiseMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aS: A2($author$project$Pages$MentorCruise$update, mentorCruiseMsg, model.aS)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var mentorShMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: A2($author$project$Pages$MentorSh$update, mentorShMsg, model.aT)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var meetAProMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aR: A2($author$project$Pages$MeetAPro$update, meetAProMsg, model.aR)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var servicesMsg = msg.a;
				var newServicesModel = A2($author$project$Pages$Services$update, servicesMsg, model.az);
				var urlCmd = (!_Utils_eq(newServicesModel, model.az)) ? A2($author$project$Main$updateServicesUrl, model.aO, newServicesModel) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: newServicesModel}),
					urlCmd);
			case 9:
				var expertWitnessMsg = msg.a;
				var newExpertModel = A2($author$project$Pages$ExpertWitness$update, expertWitnessMsg, model.ar);
				var urlCmd = (!_Utils_eq(newExpertModel, model.ar)) ? A3($author$project$Main$updateExpertUrl, model.aO, model.aq, newExpertModel) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ar: newExpertModel}),
					urlCmd);
			case 10:
				var codexMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aN: A2($author$project$Pages$Codex$update, codexMsg, model.aN)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var portfolioBetaMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2($author$project$Pages$PortfolioBeta$update, portfolioBetaMsg, model.aY)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var referralsBetaMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a_: A2($author$project$Pages$ReferralsBeta$update, referralsBetaMsg, model.a_)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Main$routeToString = function (route) {
	switch (route.$) {
		case 0:
			return 'home';
		case 1:
			return 'appearances';
		case 2:
			return 'credentials';
		case 3:
			return 'outcomes';
		case 4:
			return 'hire-me';
		case 5:
			return 'writings';
		case 6:
			return 'codex';
		case 7:
			return 'signals';
		case 8:
			return 'signals';
		case 9:
			return 'entrepreneurship';
		case 10:
			return 'offers';
		case 11:
			return 'mentorcruise';
		case 12:
			return 'find-me-in';
		case 13:
			return 'mentor-sh';
		case 14:
			return 'meetapro';
		case 15:
			return 'services';
		case 16:
			return 'expert-witness';
		case 17:
			return 'saksi-ahli';
		case 18:
			var lang = route.a;
			var region = route.b;
			var topic = route.c;
			var forum = route.d;
			var root = (lang === 'en') ? 'expert-witness/' : 'saksi-ahli/';
			return root + (region + ('/' + (topic + ('/' + forum))));
		case 19:
			var slug = route.a;
			return 'tags-' + slug;
		case 20:
			return 'portfolio-beta';
		case 21:
			return 'referrals-beta';
		default:
			return 'not-found';
	}
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Shared$hrefWithUtmSource = function (url) {
	var separator = A2($elm$core$String$contains, '?', url) ? '&' : '?';
	var urlWithUtm = url + (separator + 'utm_source=mpj.io');
	return $elm$html$Html$Attributes$href(urlWithUtm);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Shared$linkNewTab = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						A2($elm$html$Html$Attributes$attribute, 'rel', 'noopener noreferrer')
					]),
				attrs),
			children);
	});
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Pages$Home$viewAsSeenAt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('as-seen-at-hero')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('as-seen-at-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('as-seen-at-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('As seen at')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('as-seen-at-logos')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://formation.dev/blog/july-2026-monthly-deploy'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Featured in Formation')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/about_formation.avif'),
											$elm$html$Html$Attributes$alt('Formation'),
											$elm$html$Html$Attributes$title('Formation logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://blog.venturemagazine.net/'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Featured on Venture Magazine')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/venturemagazine.png'),
											$elm$html$Html$Attributes$alt('Venture Magazine'),
											$elm$html$Html$Attributes$title('Venture Magazine logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://ieeexplore.ieee.org/author/37086081499'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Published on IEEE')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/ieee.png'),
											$elm$html$Html$Attributes$alt('IEEE'),
											$elm$html$Html$Attributes$title('IEEE logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://yavaconf.com/'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Featured at Ya!vaConf')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/yava-config.svg'),
											$elm$html$Html$Attributes$alt('Ya!vaConf'),
											$elm$html$Html$Attributes$title('Ya!vaConf logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://webdirections.org/lazyload21/speakers/abdurrachman-mappuji.php'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Featured at Web Directions')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/web-directions.svg'),
											$elm$html$Html$Attributes$alt('Web Directions'),
											$elm$html$Html$Attributes$title('Web Directions logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://www.youtube.com/watch?v=kTeUuLXzwzk'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Featured at DevOps Days')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/devopsdays.png'),
											$elm$html$Html$Attributes$alt('DevOps Days'),
											$elm$html$Html$Attributes$title('DevOps Days logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://medium.com/compfest/software-engineering-academy-camp-1-berbagai-cara-untuk-membangun-software-481055ad70d1'),
									$elm$html$Html$Attributes$class('logo-link'),
									$elm$html$Html$Attributes$title('Featured in Compfest')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/coverages/compfest.png'),
											$elm$html$Html$Attributes$alt('Compfest'),
											$elm$html$Html$Attributes$title('Compfest logo'),
											$elm$html$Html$Attributes$class('coverage-logo')
										]),
									_List_Nil)
								]))
						]))
				]))
		]));
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.O, posixMinutes) < 0) {
					return posixMinutes + era.E;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		bF: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		bZ: month,
		am: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).am;
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Shared$viewFooter = function (time) {
	var zone = $elm$time$Time$utc;
	var currentYear = A2($elm$time$Time$toYear, zone, time);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('footer')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('footer-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('footer-copyright')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'© 2017-' + ($elm$core$String$fromInt(currentYear) + ' Abdu \"Códigos\" Mappuji · All Rights Reserved'))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('footer-easter-egg')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Because you read until the end, here\'s an easter egg for you: I\'m a big fan of Marvel\'s Rocket Raccoon. If you\'ve already navigated through my other pages, you might have noticed it already.')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('footer-quick-links')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Links')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/credentials'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Verifiable record: degrees, employment, publications, certifications')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Credentials')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/outcomes'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('What mentees achieved: testimonials and mentee work')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Outcomes')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/appearances'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('View public speaking engagements and talks')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Appearances')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/entrepreneurship'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('View entrepreneurial ventures and investments')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Investments')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('footer-quick-links')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Connect')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/find-me-in'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Find me on other platforms')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Find me in')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://discord.com/invite/TEAJHURh2e'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Join Discord community')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Discord')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://lu.ma/u/mpj'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Find upcoming events on Lu.ma')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Lu.ma')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('footer-quick-links')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Elsewhere')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://com6.substack.com'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Subscribe to Substack newsletter')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Substack')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://blog.mpj.io'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Read blog posts on Medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Medium')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://www.youtube.com/channel/UCHxI3i2iobjq226ze-N-QBA'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Watch YouTube videos')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('YouTube')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://leanpub.com/u/empeje'),
										$elm$html$Html$Attributes$class('footer-link'),
										$elm$html$Html$Attributes$title('Read books on Leanpub')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Leanpub')
									]))
							]))
					]))
			]));
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Shared$Email = 0;
var $author$project$Shared$mentoringCtaTarget = 0;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Shared$mentoringEmail = $elm$core$String$concat(
	_List_fromArray(
		['zing', '.', 'passers0k', '@', 'icloud', '.', 'com']));
var $author$project$Shared$mentoringMentorCruiseUrl = 'https://mentorcruise.com/mentor/abdumappuji/';
var $author$project$Shared$viewMentoringCta = function () {
	var _v0 = $author$project$Shared$mentoringCtaTarget;
	if (!_v0) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('mailto:' + ($author$project$Shared$mentoringEmail + '?subject=Intro%20Call%20Inquiry')),
					$elm$html$Html$Attributes$class('nav-cta-btn'),
					$elm$html$Html$Attributes$title('Inquire about an Intro Call via Email')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Book Intro Call')
				]));
	} else {
		return A2(
			$author$project$Shared$linkNewTab,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href($author$project$Shared$mentoringMentorCruiseUrl),
					$elm$html$Html$Attributes$class('nav-cta-btn'),
					$elm$html$Html$Attributes$title('Book Intro Call on MentorCruise')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Book Intro Call')
				]));
	}
}();
var $author$project$Shared$viewNav = function (currentPage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navigation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/'),
										$elm$html$Html$Attributes$title('Home page')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									]))
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropbtn')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Product')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/services'),
														$elm$html$Html$Attributes$title('Explore all specialized services')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Services')
													])),
												A2(
												$author$project$Shared$linkNewTab,
												_List_fromArray(
													[
														$author$project$Shared$hrefWithUtmSource('https://starter.kulkul.tech/'),
														$elm$html$Html$Attributes$title('Visit AI Starter Kit')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Starter Kit')
													])),
												A2(
												$author$project$Shared$linkNewTab,
												_List_fromArray(
													[
														$author$project$Shared$hrefWithUtmSource('https://work-abroad.kul.to/'),
														$elm$html$Html$Attributes$title('Visit Work Abroad Finder')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Work Abroad')
													])),
												A2(
												$author$project$Shared$linkNewTab,
												_List_fromArray(
													[
														$author$project$Shared$hrefWithUtmSource('https://sistemas.mpj.io'),
														$elm$html$Html$Attributes$title('Visit Sistemas')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Sistemas')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropbtn')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Erudition')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/codex'),
														$elm$html$Html$Attributes$title('Browse Codex — living archive of essays and signals')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Codex')
													])),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/signals/'),
														$elm$html$Html$Attributes$title('Signals — Five 👋🏻 Signal Fridays')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Signals')
													])),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/writings'),
														$elm$html$Html$Attributes$title('Works — blogs, books, and publications')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Works')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropbtn')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Jurisprudence')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/expert-witness'),
														$elm$html$Html$Attributes$title('International technical expert witness services')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Expert Witness')
													])),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/saksi-ahli'),
														$elm$html$Html$Attributes$title('Jasa saksi ahli TI (Indonesia)')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Saksi Ahli')
													])),
												A2(
												$author$project$Shared$linkNewTab,
												_List_fromArray(
													[
														$author$project$Shared$hrefWithUtmSource('https://lawtech.mpj.io'),
														$elm$html$Html$Attributes$title('Visit LawTech website')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('LawTech')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropbtn')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('More')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/hire-me'),
														$elm$html$Html$Attributes$title('Hire as fractional CTO or mentor')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Hire Me')
													])),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/entrepreneurship'),
														$elm$html$Html$Attributes$title('View entrepreneurial ventures')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Entrepreneurship')
													])),
												A2(
												$author$project$Shared$linkNewTab,
												_List_fromArray(
													[
														$author$project$Shared$hrefWithUtmSource('https://scholar.google.com/citations?user=aRReMSEAAAAJ&hl=en'),
														$elm$html$Html$Attributes$title('View publications on Google Scholar')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Google Scholar')
													])),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/offers'),
														$elm$html$Html$Attributes$title('View special offers and referrals')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Offers')
													])),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('/referrals-beta'),
														$elm$html$Html$Attributes$title('Referrals (Beta) — opportunities and referral programs')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Referrals (Beta)')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[$author$project$Shared$viewMentoringCta]))
					]))
			]));
};
var $author$project$Main$CodexMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$ExpertWitnessMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$MeetAProMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$MentorCruiseMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$MentorShMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$OffersMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$ServicesMsg = function (a) {
	return {$: 8, a: a};
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Shared$viewBreak = A2($elm$html$Html$hr, _List_Nil, _List_Nil);
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Shared$pickBorder = function (index) {
	return (!A2($elm$core$Basics$modBy, 3, index)) ? 'red-border' : ((!A2($elm$core$Basics$modBy, 2, index)) ? 'green-border' : 'blue-border');
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Shared$viewTalksList = function (data) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, _v0) {
				var urls = _v0.a;
				var itemDetails = _v0.b;
				var links = function () {
					if (urls.b && (!urls.b.b)) {
						var url = urls.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('deco-none'),
										$author$project$Shared$hrefWithUtmSource(url)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(itemDetails.am + ('. ' + (itemDetails.bb + ('. ' + itemDetails.I))))
									]))
							]);
					} else {
						return _Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$text(itemDetails.am + ('. ' + (itemDetails.bb + ('. ' + itemDetails.I))))
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (idx, url) {
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' '),
													A2(
													$author$project$Shared$linkNewTab,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('deco-none'),
															$author$project$Shared$hrefWithUtmSource(url)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'[' + ($elm$core$String$fromInt(idx + 1) + ']'))
														]))
												]));
									}),
								urls));
					}
				}();
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							$author$project$Shared$pickBorder(index))
						]),
					links);
			}),
		data);
};
var $author$project$Pages$Appearances$viewCoverages = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2(
			_List_fromArray(
				['https://imaginecup.microsoft.com/en-us/competition/17382']),
			{bb: 'Microsoft Imagine Cup', I: 'Hello Cloud Challenge Winner', am: '2016'}),
			_Utils_Tuple2(
			_List_fromArray(
				['https://rizafahmi.com/2018/07/12/rangkuman-acara-devc-jakarta-build-day-2018/']),
			{bb: 'Facebook Developer Indonesia', I: 'Rangkuman Acara Developer Circles Jakarta Build Day', am: '2018'}),
			_Utils_Tuple2(
			_List_fromArray(
				['https://medium.com/compfest/software-engineering-academy-camp-1-berbagai-cara-untuk-membangun-software-481055ad70d1', 'https://x.com/COMPFEST/status/1423844550473248773']),
			{bb: 'COMPFEST 13 - Universitas Indonesia', I: 'SWE Academy Camp 1: Berbagai Cara untuk Membangun Software', am: '2021'}),
			_Utils_Tuple2(
			_List_fromArray(
				['https://twitter.com/StacksOrg/status/1647374496620314629?s=20']),
			{bb: 'Stacks Open Internet Foundation', I: 'Stacks Chapter', am: '2023'})
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Coverages')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Below is notable coverage of mine.')
						]))
				]),
			$author$project$Shared$viewTalksList(data)));
}();
var $author$project$Shared$talksData = _List_fromArray(
	[
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.linkedin.com/events/7436431710008872961/']),
		{bb: 'MentorCruise', I: 'Cracking the Code: Master Algorithm Interviews with Abdu Mappuji', am: '2026'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://luma.com/10kz2ca9?tk=LHfXAj', 'https://www.youtube.com/watch?v=5W_R-2zlZpg']),
		{bb: 'WeekdAI', I: '#WeekdAI8 : Finding your path to big tech', am: '2026'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/live/w3AH3jIrXXo?feature=shared&t=1579']),
		{bb: 'Apify', I: 'Building and monetizing MCP servers on Apify', am: '2025'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://youtu.be/-2fBQXFpN7Q?feature=shared&t=3264']),
		{bb: 'Gadjah Mada Blockchain Club', I: 'Road to Devcon Empowering the Next Generation of Web3 Innovators', am: '2024'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=n0U_7fK-YBY']),
		{bb: 'Encode Club', I: 'Hologram AI Pitch', am: '2023'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=_U2kRO_DpGE']),
		{bb: 'YouTube', I: 'Run Rust Continuous Integration (CI) on ARM Architecture using Buildjet', am: '2023'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://yavaconf.com/en/']),
		{bb: 'Ya!vaConf', I: 'Complete Web3 & Ethereun with Scala', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.meetup.com/scalawaw/events/288163720/']),
		{bb: 'ScalaWAW', I: 'ScalaWAW #24 - back to school - Web3 & Ethereun with Scala', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://youtu.be/SXljxRDzfGY']),
		{bb: 'Remote Skills Academy', I: 'DAO Masterclass (In Bahasa)', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://youtu.be/hPCP_42jcH0']),
		{bb: 'Republik Rupiah', I: 'Perspektif DEVELOPER Web3: Membangun Saat BEAR MARKET | Indonesia (In Bahasa)', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=HE-81zhcCig&t=3027s']),
		{bb: 'Podcast Indonesia Belajar', I: 'Seputar Smart Contract bersama Abdu Códigos (In Bahasa)', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=7guYU1KYO7w']),
		{bb: 'YouTube', I: 'Live Stream #2 - Belajar Software Engineer', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=yN6CiiMM6Ks']),
		{bb: 'YouTube', I: 'Live Stream #1 - Belajar Software Engineer', am: '2022'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://us02web.zoom.us/rec/play/UR3gIJNnMzttJ_THqBtL8OWMJ4lCYOzGM_lM4BGggHnWrpcAWod0bwauaeXUxdVksBDAYtHkKlUsJWkN.te-e7mqNlXT-SN9c?continueMode=true&_x_zm_rtaid=ucgVi34HRgqf1s1nCtieiQ.1650350871201.02dbdc11ba23e3e6d3d29524f3b907e5&_x_zm_rhtaid=503']),
		{bb: 'Remote Skills Academy Bali', I: 'Low-code Masterclass with Retool (In Bahasa) - Passcode: %UuDV0iG', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://2021.pycon.id/speaker', 'https://events.hubilo.com/python-conference-indonesia-2021/register']),
		{bb: 'Pycon Indonesia', I: 'Blockchain 101: Deploy your first smart contract with Python', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://player.vimeo.com/video/561110523?dnt=1&app_id=122963&controls=1&hd=1&autohide=1#t=7924']),
		{bb: 'Web Directions Lazy Load', I: 'How Russian Doll Caching Can Improve Server Side Rendering', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=xGcQK0VCngI']),
		{bb: 'Conf42 Java', I: 'Enjoy Typesafe Web Development with Eta', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=_RbJq7yH0D8']),
		{bb: 'YouTube', I: 'E2E Test in Angular with Gitlab CI', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=-N2bstcbKec']),
		{bb: 'YouTube', I: 'Intro to Low-code Internal Tool Development with Retool', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=ovBggeKly4k']),
		{bb: 'YouTube', I: 'Introduction to Abdu Códigos', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=YXOCGFzOtPo']),
		{bb: 'KulWeekend', I: '#3 Markov Chain Bots', am: '2021'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=4wuN2UOVSp4']),
		{bb: 'KulWeekend', I: '#2 Data Cleaning', am: '2020'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=n-Em6-Xt4Co']),
		{bb: 'KulWeekend', I: '#1 Introduction to Python & Web Scrapping', am: '2020'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=HOkyc23ZKE4']),
		{bb: 'KulTalks', I: 'Build and Deploy Your First Website (In Bahasa)', am: '2020'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=gHi4l1N62wc']),
		{bb: 'SabernX', I: 'Intro to Social Coding with Git & GitHub (In Bahasa)', am: '2020'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://elmjapan.guupa.com/speakers/Abdurrachman_Mappuji']),
		{bb: 'ElmJapan', I: 'How Teaching Convince Me to Use Elm in Production (Cancelled due to COVID-19)', am: '2020'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=jFP_ompB0vs']),
		{bb: 'MoodleMoot Philippines', I: 'Deploy Moodle in Raspberry Pi with Docker & Remote', am: '2018'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=kTeUuLXzwzk']),
		{bb: 'DevOpsDay Jakarta', I: 'DevOps practice in nonprofit', am: '2018'}),
		_Utils_Tuple2(
		_List_fromArray(
			['https://www.youtube.com/watch?v=hLw0WZQajUo', 'https://2017.pycon.id/']),
		{bb: 'PyCon Indonesia Surabaya', I: 'Playful Load Testing with Locust', am: '2017'})
	]);
var $author$project$Pages$Appearances$viewTalks = A2(
	$elm$html$Html$div,
	_List_Nil,
	A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Talks')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Occasionally, I speak in various tech events, these are my recent talks.')
					]))
			]),
		$author$project$Shared$viewTalksList($author$project$Shared$talksData)));
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Appearances$viewVideo = function (youtubeLink) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('responsive-iframe-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$iframe,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$width(560),
						$elm$html$Html$Attributes$height(315),
						$elm$html$Html$Attributes$src(youtubeLink),
						$elm$html$Html$Attributes$title(''),
						A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
						A2($elm$html$Html$Attributes$attribute, 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'),
						A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', '')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Appearances$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Appearances')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('My public speaking engagements and media coverages.')
				])),
			$author$project$Shared$viewBreak,
			$author$project$Pages$Appearances$viewVideo('https://www.youtube.com/embed/ZpMzprmWBfo'),
			$author$project$Shared$viewBreak,
			$author$project$Pages$Appearances$viewTalks,
			$author$project$Shared$viewBreak,
			$author$project$Pages$Appearances$viewCoverages
		]));
var $author$project$Pages$Codex$LoadMore = 0;
var $author$project$Data$BlogPosts$allBlogPosts = _List_fromArray(
	[
		{F: '2026-09-28', G: '', H: 'COM6 Substack', I: 'My First EAGx - EAGxOxford', J: 'https://com6.substack.com/p/my-first-eagx-eagxoxford'},
		{F: '2026-09-08', G: '', H: 'COM6 Substack', I: 'Delete More to Make More', J: 'https://com6.substack.com/p/delete-more-to-make-more'},
		{F: '2026-08-10', G: '', H: 'COM6 Substack', I: 'Downgrade your laptop, increase your productivity', J: 'https://com6.substack.com/p/downgrade-your-laptop-increase-your'},
		{F: '2026-08-09', G: '', H: 'COM6 Substack', I: '6 Secret Benefits of Using Antigravity', J: 'https://com6.substack.com/p/6-secret-benefits-of-using-antigravity'},
		{F: '2026-08-08', G: '', H: 'COM6 Substack', I: 'Get started with Antigravity', J: 'https://com6.substack.com/p/get-started-with-antigravity'},
		{F: '2026-07-16', G: 'Strong engineers often fail system design interviews due to communication habits, not technical gaps: moving too slowly, designing silently, or hiding trade-offs.', H: 'Formation.dev', I: '7 system design interview mistakes strong engineers make', J: 'https://formation.dev/blog/top-system-design-mistakes-how-to-pass-interviews'},
		{F: '2026-07-13', G: 'Welcome to the Formation Monthly Deploy, our newsletter highlighting achievements and insights across the Formation ecosystem.', H: 'Formation.dev', I: 'Formation Monthly Deploy: July 2026', J: 'https://formation.dev/blog/july-2026-monthly-deploy'},
		{F: '2026-07-07', G: 'A deep dive into system design interviews and what senior engineers really need to demonstrate.', H: 'Formation.dev', I: 'Signal Seniority: A System Design Interview', J: 'https://formation.dev/blog/signal-seniority-system-design-interview?utm_medium=email&_hsmi=33054655&utm_content=33054655&utm_source=hs_email'},
		{F: '2026-06-23', G: '', H: 'NoCode', I: 'How and why I use Retool to create Admin Back Offices | Codementor', J: 'https://nocode.mpj.io/how-and-why-i-use-retool-to-create-admin-back-offices-codementor-12dc5baec0dd?source=rss----6bfaf074988e---4'},
		{F: '2026-06-07', G: '', H: 'COM6 Substack', I: 'The New Labour', J: 'https://com6.substack.com/p/the-new-labour'},
		{F: '2026-03-23', G: 'Stop treating algorithm interviews like a coin flip. Learn how to find your \"edge\" and transform live coding sessions into a repeatable, disciplined engineering process.', H: 'MentorCruise', I: 'Cracking the Code: The \"Thorp Edge\" for Algo Interviews', J: 'https://mentorcruise.com/blog/cracking-the-code-mastering-algorithm-interviews-with-the-edge-8f062/'},
		{F: '2026-03-03', G: '', H: 'COM6 Substack', I: 'Growth Hack Your Career: A Journey Through 11 Heuristics', J: 'https://com6.substack.com/p/growth-hack-your-career-a-journey'},
		{F: '2026-01-28', G: '', H: 'COM6 Substack', I: 'Stop Asking Recipes for Success', J: 'https://com6.substack.com/p/stop-asking-recipes-for-success'},
		{F: '2025-12-06', G: '', H: 'COM6 Substack', I: 'This AI helps me write better English, and it\'s entirely offline', J: 'https://com6.substack.com/p/this-ai-helps-me-write-better-english'},
		{F: '2025-10-01', G: '', H: 'COM6 Substack', I: 'Why should you read a book (at least) twice?', J: 'https://com6.substack.com/p/why-should-you-read-a-book-at-least'},
		{F: '2025-09-12', G: '', H: 'Medium', I: 'Google One AI, Perplexity Pro, YouTube Premium free for students', J: 'https://medium.com/aimonks/google-one-ai-perplexity-pro-youtube-premium-free-for-students-1dee6b751783?source=rss-99a4a6e31148------2'},
		{F: '2025-08-30', G: '', H: 'Medium', I: 'Cool stuff I’ve been doing this week series', J: 'https://empeje.medium.com/cool-stuff-ive-been-doing-this-week-series-df1d3170c11a?source=rss-99a4a6e31148------2'},
		{F: '2025-07-25', G: '', H: 'Medium', I: 'Koleksi Penelitian Legal dibantu AI', J: 'https://lawtech.mpj.io/koleksi-penelitian-legal-dibantu-ai-ae29883a03e0?source=rss-99a4a6e31148------2'},
		{F: '2025-07-16', G: '', H: 'COM6 Substack', I: 'Season One Recap: A new chapter', J: 'https://com6.substack.com/p/season-one-recap-a-new-chapter'},
		{F: '2025-07-09', G: '', H: 'COM6 Substack', I: 'How Systems Shape Us: Jobs, Nations, Religions & the Self', J: 'https://com6.substack.com/p/how-systems-shape-us-jobs-nations'},
		{F: '2025-07-02', G: '', H: 'COM6 Substack', I: 'The NS Train Theory of Resilience', J: 'https://com6.substack.com/p/the-ns-train-theory-of-resilience'},
		{F: '2025-06-25', G: '', H: 'COM6 Substack', I: 'Exposure Is The Engine', J: 'https://com6.substack.com/p/exposure-is-the-engine'},
		{F: '2025-06-18', G: '', H: 'COM6 Substack', I: 'The First Asymmetry: You Didn’t Choose to Be Born', J: 'https://com6.substack.com/p/the-first-asymmetry-you-didnt-choose'},
		{F: '2025-06-11', G: '', H: 'COM6 Substack', I: 'The Internet Is an Infinite Lottery Machine', J: 'https://com6.substack.com/p/the-internet-is-an-infinite-lottery'},
		{F: '2025-06-04', G: '', H: 'COM6 Substack', I: 'The Subtle Art of Engineering Luck', J: 'https://com6.substack.com/p/the-subtle-art-of-engineering-luck'},
		{F: '2025-05-28', G: '', H: 'COM6 Substack', I: 'Navigating Extremistan: The Creator\'s Journey in the 21st Century', J: 'https://com6.substack.com/p/navigating-extremistan-the-creators'},
		{F: '2025-05-21', G: '', H: 'COM6 Substack', I: 'Build Something You’re Proud Of', J: 'https://com6.substack.com/p/build-something-youre-proud-of'},
		{F: '2025-05-14', G: '', H: 'COM6 Substack', I: 'Busy Mind, Focused Life. Focused Mind, Busy Life.', J: 'https://com6.substack.com/p/busy-mind-focused-life-focused-mind'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Menjadi manusia adalah menjadi lebih teratur', J: 'https://lawtech.mpj.io/menjadi-manusia-adalah-menjadi-lebih-teratur-3f3ece18a811?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Filsafat, dari Plato sampai Filsa', J: 'https://lawtech.mpj.io/filsafat-dari-plato-sampai-filsa-12123cdd0443?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Sebelumnya saya menjawab beberapa pertanyaan tentang filsafat, namun setelah mengikuti perkuliahan…', J: 'https://lawtech.mpj.io/sebelumnya-saya-menjawab-beberapa-pertanyaan-tentang-filsafat-namun-setelah-mengikuti-perkuliahan-eb1204664c01?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Filsafat Ilmu', J: 'https://lawtech.mpj.io/filsafat-ilmu-e5059a3429b7?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Berfikir Ilmiah dan Filsafat Ilmu', J: 'https://lawtech.mpj.io/berfikir-ilmiah-dan-filsafat-ilmu-65a6f1e78322?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Ontologi: Ilmu Pengetahuan tentang “Yang Ada”', J: 'https://lawtech.mpj.io/ontologi-ilmu-pengetahuan-tentang-yang-ada-9e435c02a0d3?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Logika Induksi', J: 'https://lawtech.mpj.io/logika-induksi-7b4ad03e4739?source=rss----cdc637d7b92b---4'},
		{F: '2025-01-05', G: '', H: 'Law & Tech', I: 'Pendidikan Pancasila', J: 'https://lawtech.mpj.io/pendidikan-pancasila-01bcbb695e52?source=rss----cdc637d7b92b---4'},
		{F: '2022-01-29', G: '', H: 'NoCode', I: 'Intro to low-code software development', J: 'https://nocode.mpj.io/intro-to-low-code-software-development-2610028c5444?source=rss----6bfaf074988e---4'},
		{F: '2021-10-03', G: '', H: 'NoCode', I: 'Tutorial #1 — Getting Started to Retool (Tables, Queries, & Modal)', J: 'https://nocode.mpj.io/tutorial-1-getting-started-to-retool-tables-queries-modal-8196d62fc5c1?source=rss----6bfaf074988e---4'},
		{F: '2021-09-12', G: '', H: 'NoCode', I: 'Hello World, I’m Retool, and I love Retooling!', J: 'https://nocode.mpj.io/hello-world-im-retool-and-i-love-retooling-c95b8dfc63c0?source=rss----6bfaf074988e---4'}
	]);
var $author$project$Pages$Codex$blogPostToTuple = function (post) {
	return _Utils_Tuple2(post.J, post.I + (' — ' + (post.H + (' (' + (post.F + ')')))));
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Shared$viewList = function (data) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, _v0) {
				var url = _v0.a;
				var txt = _v0.b;
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							$author$project$Shared$pickBorder(index))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('deco-none'),
									$author$project$Shared$hrefWithUtmSource(url)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(txt)
								]))
						]));
			}),
		data);
};
var $author$project$Pages$Codex$viewPosts = function (model) {
	var visiblePosts = A2($elm$core$List$take, model.aL, $author$project$Data$BlogPosts$allBlogPosts);
	var hasMore = _Utils_cmp(
		model.aL,
		$elm$core$List$length($author$project$Data$BlogPosts$allBlogPosts)) < 0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('All works')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Posts aggregated from Substack, Medium, Kulkul Tech, Legacy Blog, Law & Tech, NoCode, and featured articles.')
						]))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Shared$viewList(
					A2($elm$core$List$map, $author$project$Pages$Codex$blogPostToTuple, visiblePosts)),
				hasMore ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin', '20px 0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('referral-button'),
										$elm$html$Html$Events$onClick(0)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Load more')
									]))
							]))
					]) : _List_Nil)));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Codex$weeklyToTuple = function (s) {
	return _Utils_Tuple2(
		'/signals/' + (s.f + '/'),
		'W' + ($elm$core$String$fromInt(s.al) + (' · ' + (s.F + ' — Five Signal Fridays'))));
};
var $author$project$Pages$Codex$viewWeeklySignals = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Signals')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Five 👋🏻 Signal Fridays — native short briefs. '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/signals/'),
							$elm$html$Html$Attributes$title('All signals')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Browse all →')
						]))
				])),
			$elm$core$List$isEmpty($author$project$Data$WeeklySignals$allWeeklySignals) ? A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No signals published yet.')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			$author$project$Shared$viewList(
				A2(
					$elm$core$List$map,
					$author$project$Pages$Codex$weeklyToTuple,
					A2($elm$core$List$take, 10, $author$project$Data$WeeklySignals$allWeeklySignals))))
		]));
var $author$project$Pages$Codex$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Codex')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('A living archive of essays, technical reflections, signals, and explorations across engineering, systems, and the craft of building.')
					])),
				$author$project$Shared$viewBreak,
				$author$project$Pages$Codex$viewWeeklySignals,
				$author$project$Shared$viewBreak,
				$author$project$Pages$Codex$viewPosts(model)
			]));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Pages$Credentials$viewDegree = function (d) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('credentials-year')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(d.aC)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(d.au)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(d.av)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(d.aA)
					]))
			]));
};
var $author$project$Pages$Credentials$viewRow3 = function (_v0) {
	var a1 = _v0.a;
	var b1 = _v0.b;
	var c1 = _v0.c;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('credentials-year')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(a1)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(b1)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(c1)
					]))
			]));
};
var $author$project$Pages$Credentials$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('page')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Credentials')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('A dated, verifiable record. Everything here can be checked against the linked sources. For public writing and mentoring, see '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Abdu Códigos')
						])),
					$elm$html$Html$text('.')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('education')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Education')
				])),
			A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credentials-table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Years')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Qualification')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Institution')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Credentials$viewDegree,
						_List_fromArray(
							[
								{au: 'BEng Nuclear Engineering & Engineering Physics', av: 'Universitas Gadjah Mada (UGM), Yogyakarta', aA: 'Graduated', aC: '2012–2017'},
								{au: 'Program Profesi Insinyur (Ir.), Informatics', av: 'Institut Teknologi Bandung (ITB)', aA: 'Graduated', aC: '2026'},
								{au: 'MS Artificial Intelligence', av: 'Udacity Institute of AI & Technology (member college of Woolf, EU-accredited)', aA: 'Graduated', aC: '2025–2026'},
								{au: 'MSc Cyber Security', av: 'Royal Holloway, University of London', aA: 'In progress', aC: '2024–'},
								{au: 'MS Data Center Engineering', av: 'HELHa (Haute École Louvain en Hainaut), Belgium', aA: 'In progress', aC: '2025–'},
								{au: 'PhD, Mathematics & Explainable AI', av: 'GCAS College Dublin (member college of Woolf, EU-accredited)', aA: 'In progress', aC: '2026–'},
								{au: 'LLB, Law', av: 'Universitas Siber Muhammadiyah, Yogyakarta', aA: 'In progress', aC: '2024–2027'}
							])))
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('employment')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Employment')
				])),
			A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credentials-table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Years')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Organisation')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Location')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Credentials$viewRow3,
						_List_fromArray(
							[
								_Utils_Tuple3('2026–', 'Booking.com\'s FareHarbor — Full Stack Engineer', 'Netherlands'),
								_Utils_Tuple3('2025–2026', 'bol.com', 'Netherlands'),
								_Utils_Tuple3('2024–2025', 'Picnic', 'Netherlands'),
								_Utils_Tuple3('2022–2024', 'Delivery Hero\'s Glovo', 'Poland'),
								_Utils_Tuple3('2020–2021', 'Mekari — Engineering Manager', 'Indonesia'),
								_Utils_Tuple3('2019–2020', 'ErudiFi (Danacita) — Tech Lead / Engineering Manager', 'Indonesia'),
								_Utils_Tuple3('2017–2019', 'Gojek (Midtrans division)', 'Indonesia'),
								_Utils_Tuple3('2016–2017', 'Wonderlabs', 'Indonesia')
							])))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credentials-note')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Alongside full-time work: founder of '),
					A2(
					$author$project$Shared$linkNewTab,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://kulkul.tech')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Kulkul Technology')
						])),
					$elm$html$Html$text(' (2020–, stepped down as CEO) and 084Soft (closed), both built nights and weekends; tech lead for hojilabs as a client engagement (~2021–2022); Software Engineering Intern, later Tech Volunteer, at Open Learning Exchange (~2016–2018); and intern on the Microsoft Academy for College Hires (MACH) programme, Microsoft SEA, 2016.')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('research')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Research')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Six peer-reviewed publications in high-performance computing and instrumentation, 30 citations, h-index 2. Most cited: '),
					A2(
					$author$project$Shared$linkNewTab,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://arxiv.org/abs/1612.07128')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('\"Study of Raspberry Pi 2 Quad-core Cortex-A7 CPU Cluster as a Mini Supercomputer\"')
						])),
					$elm$html$Html$text(' (ICITEE 2016), 26 citations.')
				])),
			A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credentials-links')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://scholar.google.com/citations?user=aRReMSEAAAAJ&hl=en')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Google Scholar')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://ieeexplore.ieee.org/author/37086081499')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('IEEE Xplore')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://arxiv.org/a/mappuji_a_1.html')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('arXiv')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://dblp.uni-trier.de/pid/192/1647.html')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('dblp')
								]))
						]))
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('certifications')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Certifications & awards')
				])),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('credentials-year')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('2016')
								])),
							$elm$html$Html$text(' — MTA: Software Development Fundamentals, '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Microsoft')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('credentials-year')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('2016')
								])),
							$elm$html$Html$text(' — Winner, Hello Cloud Challenge, '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Microsoft Imagine Cup')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('credentials-year')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('2024')
								])),
							$elm$html$Html$text(' — Google Cybersecurity Professional Certificate, '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Coursera')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('credentials-year')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('2023')
								])),
							$elm$html$Html$text(' — Encode × Gnosis and Encode × Aurora hackathon winner')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credentials-note')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Continuing education: 12 badges in total, including IBM Data Science Foundations, AWS Educate Machine Learning Foundations and O\'Reilly engineering courses. '),
					A2(
					$author$project$Shared$linkNewTab,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://www.credly.com/users/empeje/badges')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Full badge wallet on Credly')
						])),
					$elm$html$Html$text('.')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('community')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Community')
				])),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('credentials-year')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('2022–')
								])),
							$elm$html$Html$text(' — Chapter lead, '),
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://stacks.foundation/chapters-program')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Stacks Indonesia')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('credentials-year')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('2017–2026')
								])),
							$elm$html$Html$text(' — 29 talks and appearances. See '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/appearances')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Appearances')
								])),
							$elm$html$Html$text('.')
						]))
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('elsewhere')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Elsewhere')
				])),
			A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credentials-links')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://www.linkedin.com/in/mappuji')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('LinkedIn')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://github.com/empeje')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('GitHub')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://www.credly.com/users/empeje/badges')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Credly')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://leanpub.com/u/empeje')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Leanpub')
								]))
						]))
				]))
		]));
var $author$project$Pages$Entrepreneurship$viewCompanies = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2('https://kulkul.tech', 'Kulkul Technology — founded 2020, stepped down as CEO')
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Companies')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('I am drawn to entrepreneurial work. In 2020, despite the pandemic, I started one. Both this and 084Soft (since closed) were built on nights and weekends alongside full-time engineering roles.')
						]))
				]),
			$author$project$Shared$viewList(data)));
}();
var $author$project$Pages$Entrepreneurship$viewInvestments = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2('https://www.ycombinator.com/companies/aptdeco', 'AptDeco (YC W14)'),
			_Utils_Tuple2('https://www.ycombinator.com/companies/airthium', 'Airthium (YC S17)'),
			_Utils_Tuple2('https://www.ycombinator.com/companies/innamed', 'InnaMed (YC W17) - Closed'),
			_Utils_Tuple2('https://earnestcapital.com/', 'Earnest Capital'),
			_Utils_Tuple2('https://en.aktpictures.com/', 'Akt Pictures - When I Was a Human'),
			_Utils_Tuple2('https://republic.co/abdurrachman-mappuji', 'Gumroad'),
			_Utils_Tuple2('https://legionm.com/', 'Legion M'),
			_Utils_Tuple2('https://lppfusion.com/', 'LPPFusion'),
			_Utils_Tuple2('https://vinsocial.co/', 'Vin Social'),
			_Utils_Tuple2('https://arc.dev/', 'Arc (Previously Codementor, Exited to Toptal)'),
			_Utils_Tuple2('https://kyndoo.com/', 'Kyndoo (Exited to CIPIO.ai)')
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Investments')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Small investments made from time to time, mostly through equity-crowdfunding platforms rather than private rounds. My approach is value investing, and where I can I add something beyond the cheque — evangelism and constructive feedback. These are businesses I have backed.')
						]))
				]),
			$author$project$Shared$viewList(data)));
}();
var $author$project$Pages$Entrepreneurship$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Entrepreneurship')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('My entrepreneurial ventures and the small investments I have made through crowdfunding platforms.')
				])),
			$author$project$Shared$viewBreak,
			$author$project$Pages$Entrepreneurship$viewCompanies,
			$author$project$Shared$viewBreak,
			$author$project$Pages$Entrepreneurship$viewInvestments
		]));
var $author$project$Pages$FindMeIn$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('You can find me in')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Here are some of the platforms where you can find me:')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/mentorcruise')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('MentorCruise (Preferred)')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('My preferred platform for booking long-term structured mentoring and coaching.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/mentor-sh')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('mentor.sh')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Join me on mentor.sh for group mentoring and peer learning sessions.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/meetapro')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('MeetAPro')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Book targeted consulting, coaching, and mock interviews directly.')
						]))
				]))
		]));
var $author$project$Pages$HireMe$consultEmail = $elm$core$String$concat(
	_List_fromArray(
		['zing', '.', 'passers0k', '@', 'icloud', '.', 'com']));
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$dir = $elm$html$Html$Attributes$stringProperty('dir');
var $elm$html$Html$Attributes$lang = $elm$html$Html$Attributes$stringProperty('lang');
var $author$project$Pages$HireMe$viewAurelien = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$blockquote,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('twitter-tweet')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$lang('en'),
							$elm$html$Html$Attributes$dir('ltr')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('📣📣📣 Find out my last proof of concept of a CI/CD Gitlab pipeline runnable both locally or on'),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://twitter.com/hashtag/gitlab?src=hash&ref_src=twsrc%5Etfw')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('#gitlab')
								])),
							$elm$html$Html$text('with custom gitlab-runner'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('A special thanks to MPJ'),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://twitter.com/YoKulGuy?ref_src=twsrc%5Etfw')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('@YoKulGuy')
								])),
							$elm$html$Html$text('for his help on this. You are my Miyagi sensei bro 🇯🇵 🙇 🙏'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('↪'),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://t.co/WLrzXDarWp')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('https://t.co/WLrzXDarWp')
								]))
						])),
					$elm$html$Html$text('— Aurélien Lair (@aurelien_lair)'),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://twitter.com/aurelien_lair/status/1650490509645758471?ref_src=twsrc%5Etfw')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('April 24, 2023')
						]))
				])),
			A3(
			$elm$html$Html$node,
			'script',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'async', ''),
					$elm$html$Html$Attributes$src('https://platform.twitter.com/widgets.js'),
					A2($elm$html$Html$Attributes$attribute, 'charset', 'utf-8')
				]),
			_List_Nil)
		]));
var $author$project$Pages$HireMe$viewEdo = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Shared$linkNewTab,
					_List_fromArray(
						[
							$author$project$Shared$hrefWithUtmSource('https://www.linkedin.com/in/wihlarko-prasdegdho')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Wihlarko Prasdegdho')
						])),
					$elm$html$Html$text(' - Senior Engineer at Tridorian '),
					A2(
					$author$project$Shared$linkNewTab,
					_List_fromArray(
						[
							$author$project$Shared$hrefWithUtmSource('https://www.linkedin.com/in/wihlarko-prasdegdho')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('↗')
						]))
				])),
			A2(
			$elm$html$Html$blockquote,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('edo-testimonial')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\"I recently have the privilege of being mentored in a 1-on-1 session with MPJ, and i\'am incredibly grateful for the experience. He shared insightful tips and tricks on how to win the hearts of HR and hiring managers during interviews, and also gave me valuable feedback on my CV. From that session, i realized there were many aspects of my CV and self-presentation that needed improvement, with his guidance i was able to refine my CV and develop a better approach to interviews. As a result, i started receiving multiple interview invitations including opportunities offering relocation to Europe and i\'am now excited to share that I have landed a fulltime remote role at a multinational company based in Singapore. Thank you so much, MPJ, for your support and mentorship, it truly made a real difference in my journey!\"')
				]))
		]));
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Pages$HireMe$viewMenteeCard = F2(
	function (title, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mentee-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mentee-card-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mentee-card-content')
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Pages$HireMe$viewMyMentees = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('mentee-works')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mentee works')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Here are some examples of the work that has been done by my mentees.')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mentee-showcase')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$HireMe$viewMenteeCard, 'CI/CD Gitlab Pipeline - Aurélien Lair', $author$project$Pages$HireMe$viewAurelien),
					A2($author$project$Pages$HireMe$viewMenteeCard, 'Tech Interview Success - Edo', $author$project$Pages$HireMe$viewEdo)
				]))
		]));
var $author$project$Pages$HireMe$viewHireMe = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('hire-me')
		]),
	A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('hire-me-cto')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Fractional/Consulting CTO')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Beside my full-time role, I serve as a fractional Chief Technology Officer (fCTO) to highly-selected companies from time to time! I work with companies that need technical guidance for tech products who want to scale, from complex web applications to data science, AI, and blockchain even before it was cool. I work with companies top management to translate the business strategy into a solid tech roadmap.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Here are some curated list of companies/startups I have advised as their fractional CTO.')
					]))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Shared$viewList(
				_List_fromArray(
					[
						_Utils_Tuple2('#', 'A confidential mining company'),
						_Utils_Tuple2('#', 'A confidential NFT marketplace'),
						_Utils_Tuple2('https://hologram.kul.to', 'Hologram AI')
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('If you\'re a business owner who wants to bring your company\'s tech to the next level, consult with me at '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('mailto:' + $author$project$Pages$HireMe$consultEmail)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Pages$HireMe$consultEmail)
								])),
							$elm$html$Html$text('.')
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('hire-me-mentor')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Exclusive Mentoring')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('I run one-on-one mentoring for high-potential engineers. Since 2019 I have mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews. Mentees have gone on to Amazon, Meta, Netflix, NVIDIA, Two Sigma, Red Hat and SAP.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Book a session or an ongoing programme through '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/mentorcruise')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('MentorCruise')
								])),
							$elm$html$Html$text(', which handles scheduling, milestones and payment protection.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('responsive-iframe-container'),
							$elm$html$Html$Attributes$class('placid-embed'),
							$elm$html$Html$Attributes$class('placid-embed-standalone')
						]),
					_List_fromArray(
						[
							A3(
							$elm$html$Html$node,
							'iframe',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'src', 'https://mentorcruise.com/mentor/abdumappuji/embed/?mode=light'),
									A2($elm$html$Html$Attributes$attribute, 'frameborder', '0')
								]),
							_List_Nil)
						])),
					$author$project$Shared$viewBreak,
					$author$project$Pages$HireMe$viewMyMentees
				]))));
var $author$project$Shared$viewRecentEvent = A2(
	$elm$html$Html$div,
	_List_Nil,
	A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Recent Event')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Please refer below for an interesting event that I recently participated / involved with')
					]))
			]),
		$author$project$Shared$viewTalksList(
			A2($elm$core$List$take, 2, $author$project$Shared$talksData))));
var $author$project$Pages$HireMe$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Hire Me')
				])),
			$author$project$Shared$viewBreak,
			$author$project$Pages$HireMe$viewHireMe,
			$author$project$Shared$viewBreak,
			$author$project$Shared$viewRecentEvent
		]));
var $author$project$Pages$Home$viewHeader = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hero-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hero-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hero-image')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/hero-1.jpg'),
											A2($elm$html$Html$Attributes$attribute, 'alt', 'Abdu Códigos Mappuji'),
											$elm$html$Html$Attributes$title('Abdu Códigos Mappuji - Interview Coach and Engineer')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hero-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hero-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Abdu \"Códigos\" Mappuji')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hero-credentials')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Full Stack Engineer @ Booking.com\'s FareHarbor · Interview Coach')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hero-description')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Abdu has built systems at bol.com, Picnic, Glovo and Gojek, and hired and managed engineers at ErudiFi and Mekari. Since 2019 he has mentored 200+ engineers into roles at Amazon, Meta, Netflix and NVIDIA. A true polymath, he\'s also a PhD Researcher in AI Explainability and a Legal Scholar.')
										]))
								]))
						]))
				]))
		]));
var $author$project$Pages$Home$viewNewsletter = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('newsletter-section')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('newsletter-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('newsletter-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('newsletter-headline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Want to excel in your career? Subscribe to Abdu\'s Newsletter')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('newsletter-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sign up to join more than 2,000 subscribers who receive Abdu\'s essays delivered to their inbox every week.')
								]))
						])),
					A3($elm$html$Html$node, 'kit-form', _List_Nil, _List_Nil)
				]))
		]));
var $author$project$Pages$Home$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[$author$project$Pages$Home$viewHeader, $author$project$Pages$Home$viewNewsletter]));
var $author$project$Pages$MeetAPro$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumbs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/services')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Services')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('current')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('MeetAPro')
							]))
					])),
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Expert Technical Consulting & Coaching on MeetAPro')
					])),
				$author$project$Shared$viewBreak,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mentorcruise-intro')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('What is MeetAPro?')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('MeetAPro is a leading professional services platform that connects clients with industry experts for on-demand consulting, technical tutoring, mock interviews, and career coaching. The platform simplifies professional services by offering direct scheduling, transparent packages, and secure payments.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Whether you are a software engineer preparing for FAANG interviews, a startup founder looking for fractional CTO guidance, or an aspiring developer seeking system design mentorship, MeetAPro provides a streamlined workspace to work with seasoned professionals.')
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Work 1-on-1 with Abdu Mappuji')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('On MeetAPro, I offer targeted, action-oriented services tailored to your professional objectives. As an engineering leader currently at FareHarbor (Booking.com), with previous experience at Microsoft, Delivery Hero, Bol.com, and Gojek, and academic background as a Nuclear Engineer (UGM), Informatics Engineer (ITB), and Legal Scholar (Universitas Sibermu Yogyakarta), I bring a structured, rigorous, and multidisciplinary approach to every session.')
					])),
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Services Offered on MeetAPro:')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Technical Mock Interviews: Realistic practice for coding, algorithms, data structures, and system design interviews.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Resume & LinkedIn Review: Optimization of your professional assets to stand out to big tech recruiters.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('System Design Consulting: Architecture reviews, scalability planning, and technology stack selection.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Fractional CTO & Tech Leadership: Strategic guidance on team building, processes, and technical roadmap execution.')
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Book My Services Directly')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Ready to advance your career or project? Visit my profile on MeetAPro to see my listings, read client reviews, and book a session directly.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Explore my profile and current offerings:')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('green-border')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://www.meetapro.com/provider/empeje#listings'),
										$elm$html$Html$Attributes$class('deco-none')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('👉 View Abdu Mappuji\'s Listings on MeetAPro')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mentorcruise-assets')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Scan this QR code to visit my MeetAPro profile:')
							])),
						A2(
						$author$project$Shared$linkNewTab,
						_List_fromArray(
							[
								$author$project$Shared$hrefWithUtmSource('https://www.meetapro.com/provider/empeje#listings'),
								$elm$html$Html$Attributes$class('mentorcruise-qr-code')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'src', 'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=https%3A%2F%2Fwww.meetapro.com%2Fprovider%2Fempeje%23listings&format=svg'),
										A2($elm$html$Html$Attributes$attribute, 'alt', 'QR Code for MeetAPro Profile'),
										A2($elm$html$Html$Attributes$attribute, 'width', '250'),
										A2($elm$html$Html$Attributes$attribute, 'height', '250')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Pages$MentorCruise$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumbs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/services')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Services')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('current')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('MentorCruise')
							]))
					])),
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Accelerate Your Growth: Mentoring with MentorCruise')
					])),
				$author$project$Shared$viewBreak,
				A2(
				$author$project$Shared$linkNewTab,
				_List_fromArray(
					[
						$author$project$Shared$hrefWithUtmSource('https://mentorcruise.com/mentor/abdumappuji/?source=embed'),
						$elm$html$Html$Attributes$class('mentorcruise-badge')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'src', 'https://cdn.mentorcruise.com/img/banner/navy-sm.svg'),
								A2($elm$html$Html$Attributes$attribute, 'width', '180'),
								A2($elm$html$Html$Attributes$attribute, 'alt', 'MentorCruise')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('preferred-booking-banner')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('💡 '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Preferred Platform:')
									])),
								$elm$html$Html$text(' MentorCruise is my preferred channel for managing structured 1-on-1 mentoring, milestones, and scheduling.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mentorcruise-intro')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you looking to break into big tech or accelerate your career growth?')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Many talented engineers struggle to navigate the complex landscape of tech interviews, career progression, and skill development. You might be feeling stuck, unsure how to land that dream job at Amazon, Meta, Netflix, NVIDIA, or Two Sigma, or simply seeking expert guidance to refine your craft.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('That\'s where I come in. I\'m Abdu, a Full Stack Engineer at Booking.com\'s FareHarbor, with previous experience at bol.com, Picnic, Delivery Hero\'s Glovo and Gojek, and two years hiring and managing engineers — Tech Lead at ErudiFi, then Engineering Manager at Mekari. I was trained as a Nuclear Engineer at UGM, and I hold an MS in Artificial Intelligence and a professional postgraduate degree in Informatics from ITB. With the same rigor, I now mentor engineers landing roles at Amazon, Meta, Netflix, NVIDIA, and Two Sigma. I am also a PhD Researcher in AI Explainability and a Legal Scholar. My greatest joy comes from empowering my mentees to achieve their long-awaited career goals.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If you resonate with these challenges and are ready to unlock your full potential, I\'m excited to offer my structured mentoring services through MentorCruise.')
							]))
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Structured Programs: Access tailored mentorship programs designed for specific career stages and goals.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Flexible Scheduling: Easily book sessions that fit your busy schedule.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Global Community: Connect with a diverse community of mentors and mentees worldwide.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Accountability & Tracking: MentorCruise provides tools to track your progress and ensure accountability.')
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('My MentorCruise Profile')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Ready to take the next step in your career? Explore my MentorCruise profile to learn more about my mentoring approach, specialties, and testimonials from other mentees.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pros-cons-embed-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pros-cons-section')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pros and Cons of MentorCruise')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pros:')
									])),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Verified Mentors: All mentors are vetted professionals, ensuring high-quality guidance.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Clear Communication: The platform facilitates seamless communication and scheduling.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Resource Library: Access to exclusive resources and learning materials.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Goal-Oriented: Programs are designed to help you achieve measurable outcomes.')
											]))
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cons:')
									])),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Cost: While an investment in your career, mentoring services on any platform can be a significant cost. MentorCruise\'s pricing is competitive, but it\'s something to consider.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Platform Dependency: All interactions are within the MentorCruise ecosystem, which might not suit everyone who prefers direct engagement.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Availability: Popular mentors might have limited availability, requiring advance booking.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('responsive-iframe-container'),
								$elm$html$Html$Attributes$class('placid-embed')
							]),
						_List_fromArray(
							[
								A3(
								$elm$html$Html$node,
								'iframe',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'src', 'https://mentorcruise.com/mentor/abdumappuji/embed/?mode=light'),
										A2($elm$html$Html$Attributes$attribute, 'frameborder', '0')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mentorcruise-banner-and-social')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Shared$linkNewTab,
						_List_fromArray(
							[
								$author$project$Shared$hrefWithUtmSource('https://mentorcruise.com/mentor/abdumappuji/?source=embed'),
								$elm$html$Html$Attributes$class('mentorcruise-link')
							]),
						_List_fromArray(
							[
								A3(
								$elm$html$Html$node,
								'svg',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'height', '32px'),
										A2($elm$html$Html$Attributes$attribute, 'fill', 'none'),
										A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 55 44'),
										A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
									]),
								_List_fromArray(
									[
										A3(
										$elm$html$Html$node,
										'mask',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'id', 'a'),
												A2($elm$html$Html$Attributes$attribute, 'x', '0'),
												A2($elm$html$Html$Attributes$attribute, 'y', '0'),
												A2($elm$html$Html$Attributes$attribute, 'width', '55'),
												A2($elm$html$Html$Attributes$attribute, 'height', '44'),
												A2($elm$html$Html$Attributes$attribute, 'style', 'mask-type:luminance'),
												A2($elm$html$Html$Attributes$attribute, 'maskUnits', 'userSpaceOnUse')
											]),
										_List_fromArray(
											[
												A3(
												$elm$html$Html$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'M55 0H0V44H55V0Z'),
														A2($elm$html$Html$Attributes$attribute, 'fill', '#fff')
													]),
												_List_Nil)
											])),
										A3(
										$elm$html$Html$node,
										'g',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'fill', '#20917E'),
												A2($elm$html$Html$Attributes$attribute, 'mask', 'url(#a)')
											]),
										_List_fromArray(
											[
												A3(
												$elm$html$Html$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'm54.14 28.47h-53.457c-0.5029 0-0.8327 0.5269-0.6138 0.9807l2.8198 5.8442c0.0427 0.0885 0.1321 0.1447 0.2302 0.1447h48.585c0.0981 0 0.1875-0.0562 0.2302-0.1447l2.8198-5.8442c0.2189-0.4537-0.1109-0.9807-0.6138-0.9807z')
													]),
												_List_Nil),
												A3(
												$elm$html$Html$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'm4.006 37.61c1.8857 3.9083 5.8358 6.3913 10.167 6.3913h26.476c4.3317 0 8.2818-2.483 10.168-6.3913l0.1607-0.3331c0.0547-0.1134-0.0277-0.2452-0.1534-0.2452h-46.825c-0.1258 0-0.2082 0.1318-0.1535 0.2452l0.1607 0.3331z')
													]),
												_List_Nil),
												A3(
												$elm$html$Html$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'm25.971 0.21533-14.328 25.469c-0.2563 0.4555 0.0721 1.0188 0.5938 1.0188h13.986c0.2825 0 0.5114-0.2294 0.5114-0.5124v-25.773c0-0.42015-0.5562-0.56735-0.7632-0.20205z')
													]),
												_List_Nil),
												A3(
												$elm$html$Html$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'm43.304 25.685-14.328-25.469-0.0056-0.009921c-0.2056-0.36261-0.7576-0.21641-0.7576 0.20056v25.785c0 0.283 0.2289 0.5124 0.5113 0.5124h13.986c0.5217 0 0.8502-0.5634 0.594-1.0189z')
													]),
												_List_Nil)
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mentorcruise-assets')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Find my profile and offerings:')
									])),
								A2(
								$author$project$Shared$linkNewTab,
								_List_fromArray(
									[
										$author$project$Shared$hrefWithUtmSource('https://mentorcruise.com/mentor/abdumappuji/?source=embed'),
										$elm$html$Html$Attributes$class('mentorcruise-qr-code')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'src', 'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=https%3A%2F%2Fmentorcruise.com/mentor/abdumappuji/%3Fsource%3Dembed&format=svg'),
												A2($elm$html$Html$Attributes$attribute, 'alt', 'QR Code'),
												A2($elm$html$Html$Attributes$attribute, 'width', '250'),
												A2($elm$html$Html$Attributes$attribute, 'height', '250')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$MentorSh$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumbs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/services')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Services')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('current')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('mentor.sh')
							]))
					])),
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Master Your Tech Career with mentor.sh')
					])),
				$author$project$Shared$viewBreak,
				A2(
				$author$project$Shared$linkNewTab,
				_List_fromArray(
					[
						$author$project$Shared$hrefWithUtmSource('https://mentor.sh/mentors/empeje?utm_source=marketing_hub&utm_medium=banner&utm_campaign=mentor_asset_share&utm_content=standard_banner&utm_term=empeje'),
						$elm$html$Html$Attributes$class('mentorsh-badge')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('https://mentor.sh/marketing/banner-light.png'),
								$elm$html$Html$Attributes$alt('Book a mentoring session with Abdu Mappuji'),
								A2($elm$html$Html$Attributes$attribute, 'height', '20')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mentorsh-intro')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Power of Collective Growth: Why Group Mentoring?')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('In the fast-paced world of software engineering, learning in isolation can often feel like a slow climb. While one-on-one sessions are valuable, there\'s a unique magic that happens when you learn alongside peers who are facing similar challenges. mentor.sh is built around this philosophy of active, peer-based learning.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('I\'m Abdu, a Full Stack Engineer at Booking.com\'s FareHarbor, with previous experience at bol.com, Picnic, Delivery Hero\'s Glovo and Gojek, and two years hiring and managing engineers — Tech Lead at ErudiFi, then Engineering Manager at Mekari. I\'ve realized that the most breakthrough moments often happen during collaborative discussions. Trained as a Nuclear Engineer at UGM, with an MS in Artificial Intelligence and a professional postgraduate degree in Informatics from ITB, I bring that same rigor to collective deconstruction. I\'m also a Legal Scholar at Universitas Sibermu Yogyakarta. On mentor.sh, I host group sessions designed to foster this environment. It\'s not just about me teaching you; it\'s about us, as a group, deconstructing complex systems, solving architectural puzzles, and growing together.')
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('What to Expect on mentor.sh')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Active Peer Learning: Engage with other high-potential engineers, sharing insights and learning from collective experiences.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Group Problem Solving: We tackle real-world scenarios, from system design to career navigation, in a collaborative setting.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Dynamic Sessions: Each session is interactive, ensuring you\'re not just a passive listener but an active participant in your own growth.')
							])),
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Structured Guidance: Benefit from my decade of experience in top tech companies, translated into actionable group workshops.')
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Join My Next Session')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Ready to experience the benefits of peer-driven growth? Visit my profile on mentor.sh to see upcoming group sessions and join a community of engineers dedicated to active learning.')
					])),
				A2(
				$author$project$Shared$linkNewTab,
				_List_fromArray(
					[
						$author$project$Shared$hrefWithUtmSource('https://mentor.sh/m/empeje'),
						$elm$html$Html$Attributes$class('mentorsh-profile-link')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View My mentor.sh Profile')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mentorcruise-assets')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Scan to visit my profile:')
							])),
						A2(
						$author$project$Shared$linkNewTab,
						_List_fromArray(
							[
								$author$project$Shared$hrefWithUtmSource('https://mentor.sh/mentors/empeje?utm_source=marketing_hub&utm_medium=qr_code&utm_campaign=mentor_asset_share&utm_content=qr_code_scan&utm_term=empeje'),
								$elm$html$Html$Attributes$class('mentorcruise-qr-code')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('https://mentor.sh/api/qr-code?url=https%3A%2F%2Fmentor.sh%2Fmentors%2Fempeje%3Futm_source%3Dmarketing_hub%26utm_medium%3Dqr_code%26utm_campaign%3Dmentor_asset_share%26utm_content%3Dqr_code_scan%26utm_term%3Dempeje&mode=light'),
										$elm$html$Html$Attributes$alt('QR Code for mentor.sh profile'),
										$elm$html$Html$Attributes$width(250),
										$elm$html$Html$Attributes$height(250)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Pages$Offers$referralData = _List_fromArray(
	[
		{a5: '4-month trial of Google AI Pro when subscribing with this link.', aZ: 'Google AI Pro', bd: 'https://g.co/g1referral/FEG47N9D'},
		{a5: 'Get zero fees on a transfer up to IDR 9,000,000.', aZ: 'Wise', bd: 'https://wise.com/invite/dic/abdurrachmanm'}
	]);
var $elm$core$String$toLower = _String_toLower;
var $author$project$Pages$Offers$UpdateReferralsFilter = $elm$core$Basics$identity;
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pages$Offers$viewReferralsSearchFilter = function (searchFilter) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$placeholder('Search products...'),
						$elm$html$Html$Attributes$value(searchFilter),
						$elm$html$Html$Events$onInput($elm$core$Basics$identity),
						$elm$html$Html$Attributes$class('search-input')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Offers$viewReferralTableRow = F2(
	function (index, link) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('product-name'),
							A2($elm$html$Html$Attributes$attribute, 'data-label', 'Product Name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(link.aZ)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('referral-link'),
							A2($elm$html$Html$Attributes$attribute, 'data-label', 'Referral Link')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource(link.bd),
									$elm$html$Html$Attributes$class('referral-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sign Up')
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('benefit'),
							A2($elm$html$Html$Attributes$attribute, 'data-label', 'Benefit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(link.a5)
						]))
				]));
	});
var $author$project$Pages$Offers$viewReferralsTable = function (links) {
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('referral-table')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Product Name')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Referral Link')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Benefit')
									]))
							]))
					])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2($elm$core$List$indexedMap, $author$project$Pages$Offers$viewReferralTableRow, links))
			]));
};
var $author$project$Pages$Offers$viewReferrals = function (model) {
	var filteredLinks = A2(
		$elm$core$List$filter,
		function (link) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(model.a$),
				$elm$core$String$toLower(link.aZ));
		},
		$author$project$Pages$Offers$referralData);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('referrals')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Referrals')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Here are some great services I use and recommend. Sign up through these links to get special benefits!')
					])),
				$author$project$Pages$Offers$viewReferralsSearchFilter(model.a$),
				$author$project$Pages$Offers$viewReferralsTable(filteredLinks),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('disclaimer')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('* Benefits may vary and are subject to the terms and conditions of each service provider.')
					]))
			]));
};
var $author$project$Pages$Offers$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Offers & Referrals')
					])),
				$author$project$Pages$Offers$viewReferrals(model)
			]));
};
var $author$project$Pages$Outcomes$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('page')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Outcomes')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('What mentees have gone on to do. Named and linked wherever they have given permission, so you can check it rather than take my word for it.')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('testimonials')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('In their words')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('outcome-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('outcome-attribution')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://www.linkedin.com/in/wihlarko-prasdegdho')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Wihlarko Prasdegdho')
								])),
							$elm$html$Html$text(' — Senior Engineer at Tridorian')
						])),
					A2(
					$elm$html$Html$blockquote,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('outcome-quote')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('\"I recently had the privilege of being mentored in a 1-on-1 session with MPJ, and I am incredibly grateful for the experience. He shared insightful tips and tricks on how to win the hearts of HR and hiring managers during interviews, and also gave me valuable feedback on my CV. From that session, I realised there were many aspects of my CV and self-presentation that needed improvement; with his guidance I was able to refine my CV and develop a better approach to interviews. As a result, I started receiving multiple interview invitations, including opportunities offering relocation to Europe, and I am now excited to share that I have landed a full-time remote role at a multinational company based in Singapore. Thank you so much, MPJ, for your support and mentorship — it truly made a real difference in my journey!\"')
						]))
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('mentee-work')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mentee work')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Work produced by mentees during and after our sessions.')
				])),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Shared$linkNewTab,
							_List_fromArray(
								[
									$author$project$Shared$hrefWithUtmSource('https://twitter.com/aurelien_lair/status/1650490509645758471')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Aurélien Lair — a CI/CD GitLab pipeline runnable both locally and on GitLab')
								]))
						]))
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('where')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Where mentees have gone')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Since 2019 I have mentored 200+ engineers one-on-one across multiple platforms, with 100+ five-star reviews. Mentees have gone on to roles at Amazon, Meta, Netflix, NVIDIA, Two Sigma, Red Hat and SAP.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('outcome-note')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Companies are listed only where a mentee has confirmed the placement. Individual names appear only with permission, which is why this page is shorter than the review count — most mentees prefer not to be named, and that is the right default.')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('If you want the same, book through '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/mentorcruise')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('MentorCruise')
						])),
					$elm$html$Html$text('.')
				]))
		]));
var $author$project$Pages$PortfolioBeta$accentClass = function (index) {
	var _v0 = A2($elm$core$Basics$modBy, 3, index);
	switch (_v0) {
		case 0:
			return 'red-border';
		case 1:
			return 'green-border';
		default:
			return 'blue-border';
	}
};
var $author$project$Pages$PortfolioBeta$imageClass = function (project) {
	return $elm$core$String$isEmpty(project.a9) ? '' : 'pb-tile--image';
};
var $author$project$Pages$PortfolioBeta$sizeClass = function (index) {
	var _v0 = A2($elm$core$Basics$modBy, 7, index);
	switch (_v0) {
		case 0:
			return 'pb-tile--large';
		case 3:
			return 'pb-tile--wide';
		case 5:
			return 'pb-tile--tall';
		default:
			return '';
	}
};
var $author$project$Pages$PortfolioBeta$viewImage = function (project) {
	return $elm$core$String$isEmpty(project.a9) ? $elm$html$Html$text('') : A3(
		$elm$html$Html$node,
		'canvas',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pb-tile-mosaic'),
				A2($elm$html$Html$Attributes$attribute, 'data-mosaic-src', project.a9),
				A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', project.bo)
			]),
		_List_Nil);
};
var $author$project$Pages$PortfolioBeta$viewOptional = F2(
	function (className, value) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Pages$PortfolioBeta$viewTile = F2(
	function (index, project) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$elm$core$String$join,
						' ',
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							_List_fromArray(
								[
									'pb-tile',
									$author$project$Pages$PortfolioBeta$accentClass(index),
									$author$project$Pages$PortfolioBeta$sizeClass(index),
									$author$project$Pages$PortfolioBeta$imageClass(project)
								]))))
				]),
			_List_fromArray(
				[
					$author$project$Pages$PortfolioBeta$viewImage(project),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pb-tile-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-tile-meta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$join,
										' · ',
										A2(
											$elm$core$List$filter,
											A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
											_List_fromArray(
												[project.y, project.am]))))
								])),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-tile-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(project.bo)
								])),
							A2($author$project$Pages$PortfolioBeta$viewOptional, 'pb-tile-client', project.bC),
							A2($author$project$Pages$PortfolioBeta$viewOptional, 'pb-tile-summary', project.ck),
							A2($author$project$Pages$PortfolioBeta$viewOptional, 'pb-tile-metrics', project.bY),
							A2($author$project$Pages$PortfolioBeta$viewOptional, 'pb-tile-stack', project.ci)
						]))
				]));
	});
var $author$project$Pages$PortfolioBeta$viewBody = function (status) {
	switch (status.$) {
		case 0:
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Loading projects…')
					]));
		case 1:
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Couldn\'t load projects right now. Refresh the page to try again.')
					]));
		default:
			if (!status.a.b) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pb-status')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No public projects to show yet.')
						]));
			} else {
				var projects = status.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pb-mosaic')
						]),
					A2($elm$core$List$indexedMap, $author$project$Pages$PortfolioBeta$viewTile, projects));
			}
	}
};
var $author$project$Pages$PortfolioBeta$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pb-page')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Portfolio')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-note')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Beta: an experimental gallery of selected projects, loaded live.')
					])),
				$author$project$Shared$viewBreak,
				$author$project$Pages$PortfolioBeta$viewBody(model.aA)
			]));
};
var $author$project$Pages$ReferralsBeta$isWebUrl = function (url) {
	return A2($elm$core$String$startsWith, 'https://', url) || A2($elm$core$String$startsWith, 'http://', url);
};
var $author$project$Pages$ReferralsBeta$viewApply = function (referral) {
	return $author$project$Pages$ReferralsBeta$isWebUrl(referral.bl) ? A2(
		$author$project$Shared$linkNewTab,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(referral.bl),
				$elm$html$Html$Attributes$title('Open referral: ' + referral.a0),
				$elm$html$Html$Attributes$class('referral-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('View')
			])) : $elm$html$Html$text('');
};
var $elm$core$String$trim = _String_trim;
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $author$project$Pages$ReferralsBeta$viewEmailMe = function (referral) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(
				'mailto:' + ($author$project$Shared$mentoringEmail + ('?subject=' + $elm$url$Url$percentEncode('Referral inquiry: ' + referral.a0)))),
				$elm$html$Html$Attributes$title('Email me first about ' + referral.a0),
				$elm$html$Html$Attributes$class('rb-email-me')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Email me first')
			]));
};
var $author$project$Pages$ReferralsBeta$viewMethod = function (referral) {
	return ($elm$core$String$toLower(
		$elm$core$String$trim(referral.br)) === 'email me first') ? $author$project$Pages$ReferralsBeta$viewEmailMe(referral) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(referral.br)
			]));
};
var $author$project$Pages$ReferralsBeta$viewOptional = F2(
	function (className, value) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Pages$ReferralsBeta$viewRow = function (referral) {
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Role')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rb-role')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(referral.a0)
							])),
						A2($author$project$Pages$ReferralsBeta$viewOptional, 'rb-notes', referral.b_)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Company')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(referral.bE)
							])),
						A2($author$project$Pages$ReferralsBeta$viewOptional, 'rb-department', referral.bG)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Type')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(referral.bV)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Location')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(referral.bX)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(referral.aA)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Method')
					]),
				_List_fromArray(
					[
						$author$project$Pages$ReferralsBeta$viewMethod(referral)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-label', 'Link')
					]),
				_List_fromArray(
					[
						$author$project$Pages$ReferralsBeta$viewApply(referral)
					]))
			]));
};
var $author$project$Pages$ReferralsBeta$viewBody = function (status) {
	switch (status.$) {
		case 0:
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rb-status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Loading referrals…')
					]));
		case 1:
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rb-status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Couldn\'t load referrals right now. Refresh the page to try again.')
					]));
		default:
			if (!status.a.b) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rb-status')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No public referrals to show yet.')
						]));
			} else {
				var referrals = status.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rb-table-wrap')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('referral-table rb-table')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Role')
														])),
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Company')
														])),
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Type')
														])),
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Location')
														])),
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Status')
														])),
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Method')
														])),
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Link')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Pages$ReferralsBeta$viewRow, referrals))
								]))
						]));
			}
	}
};
var $author$project$Pages$ReferralsBeta$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rb-page')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Referrals')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rb-note')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Beta: opportunities and referral programs I can pass along, loaded live.')
					])),
				$author$project$Shared$viewBreak,
				$author$project$Pages$ReferralsBeta$viewBody(model.aA)
			]));
};
var $author$project$Pages$Services$SetCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Services$SetSearchQuery = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Pages$Services$viewCategoryFilter = F3(
	function (selectedCategory, index, category) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					_Utils_eq(
						selectedCategory,
						$elm$core$Maybe$Just(category)) ? 'filter-btn active' : 'filter-btn'),
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index + 1)),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Services$SetCategory(
						$elm$core$Maybe$Just(category)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(category)
				]));
	});
var $author$project$Pages$Services$viewServiceItem = F2(
	function (index, tag) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index) + ' service-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/mentoring/' + tag.f),
							$elm$html$Html$Attributes$title(tag.k),
							$elm$html$Html$Attributes$class('deco-none')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(tag.k)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('view-details')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Learn more →')
								]))
						]))
				]));
	});
var $author$project$Pages$Services$viewCategoryGroup = function (_v0) {
	var category = _v0.a;
	var tags = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('category-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('category-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(category)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('services-grid')
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Services$viewServiceItem, tags))
			]));
};
var $author$project$Pages$Services$view = function (model) {
	var filteredTags = A2(
		$elm$core$List$filter,
		function (tag) {
			return function () {
				var _v2 = model.bs;
				if (!_v2.$) {
					var cat = _v2.a;
					return _Utils_eq(tag.y, cat);
				} else {
					return true;
				}
			}() && function () {
				var q = $elm$core$String$toLower(model.ay);
				return A2(
					$elm$core$String$contains,
					q,
					$elm$core$String$toLower(tag.k)) || A2(
					$elm$core$String$contains,
					q,
					$elm$core$String$toLower(tag.f));
			}();
		},
		$author$project$Data$Tags$allTags);
	var categories = $elm$core$List$sort(
		A3(
			$elm$core$List$foldl,
			F2(
				function (cat, acc) {
					return A2($elm$core$List$member, cat, acc) ? acc : A2($elm$core$List$cons, cat, acc);
				}),
			_List_Nil,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.y;
				},
				$author$project$Data$Tags$allTags)));
	var groupedTags = A2(
		$elm$core$List$filter,
		function (_v1) {
			var tags = _v1.b;
			return !$elm$core$List$isEmpty(tags);
		},
		A2(
			$elm$core$List$map,
			function (cat) {
				return _Utils_Tuple2(
					cat,
					A2(
						$elm$core$List$filter,
						function (tag) {
							return _Utils_eq(tag.y, cat);
						},
						filteredTags));
			},
			A2(
				$elm$core$List$filter,
				function (cat) {
					var _v0 = model.bs;
					if (!_v0.$) {
						var selected = _v0.a;
						return _Utils_eq(cat, selected);
					} else {
						return true;
					}
				},
				categories)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('services-catalog')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumbs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('separator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' › ')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('current')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Services')
							]))
					])),
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Specialized Technical Services')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lead')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Find the right strategic guidance for your engineering journey or product development.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('catalog-controls')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('search-box')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$placeholder('Search services (e.g. Python, AWS, Architecture...)'),
										$elm$html$Html$Attributes$value(model.ay),
										$elm$html$Html$Events$onInput($author$project$Pages$Services$SetSearchQuery),
										$elm$html$Html$Attributes$class('search-input')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('category-filters')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										_Utils_eq(model.bs, $elm$core$Maybe$Nothing) ? 'filter-btn active' : 'filter-btn'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Services$SetCategory($elm$core$Maybe$Nothing)),
										$elm$html$Html$Attributes$class('red-border')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('All')
									])),
							A2(
								$elm$core$List$indexedMap,
								$author$project$Pages$Services$viewCategoryFilter(model.bs),
								categories)))
					])),
				$author$project$Shared$viewBreak,
				$elm$core$List$isEmpty(filteredTags) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('no-results')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No services found matching your criteria.')
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('categories-stack')
					]),
				A2($elm$core$List$map, $author$project$Pages$Services$viewCategoryGroup, groupedTags)),
				$author$project$Shared$viewBreak,
				$author$project$Shared$viewRecentEvent
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.db) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.w)));
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 10};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 11, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 0};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			z: A2($elm$core$List$cons, linkRef, state.z),
			A: state.A
		};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.dd);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.E, offset) < 0,
					0,
					{bD: col, L: s0.L, N: s0.N, E: offset, db: row, dd: s0.dd});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.E, s.db, s.bD, s);
	};
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u000D',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\n',
	$elm$parser$Parser$Expecting('a newline'));
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {bD: col, cD: contextStack, w: problem, db: row};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.db, s.bD, x, s.L));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.E, s.db, s.bD, s.dd);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bD: newCol, L: s.L, N: s.N, E: newOffset, db: newRow, dd: s.dd});
	};
};
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(0)
					])))
		]));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char) {
		case '\n':
			return true;
		case '\u000D':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.E, s1.E, s0.dd),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.dd),
			s.E) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $elm$core$String$endsWith = _String_endsWith;
var $dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph = function (block) {
	endWithOpenBlockOrParagraph:
	while (true) {
		switch (block.$) {
			case 1:
				var str = block.a;
				return !A2($elm$core$String$endsWith, str, '\n');
			case 12:
				var blocks = block.a;
				if (blocks.b) {
					var last = blocks.a;
					var $temp$block = last;
					block = $temp$block;
					continue endWithOpenBlockOrParagraph;
				} else {
					return false;
				}
			case 4:
				var blockslist = block.e;
				if (blockslist.b) {
					var blocks = blockslist.a;
					if (blocks.b) {
						var last = blocks.a;
						var $temp$block = last;
						block = $temp$block;
						continue endWithOpenBlockOrParagraph;
					} else {
						return false;
					}
				} else {
					return false;
				}
			case 0:
				return true;
			default:
				return false;
		}
	}
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.E, s.dd);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bD: 1, L: s.L, N: s.N, E: s.E + 1, db: s.db + 1, dd: s.dd}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bD: s.bD + 1, L: s.L, N: s.N, E: newOffset, db: s.db, dd: s.dd}));
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c) {
		case ' ':
			return false;
		case '\u000D':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (!_v0.$) {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (c !== ';');
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\''),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (!mValue.$) {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000D':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{bo: key, cp: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.E, s.db, s.bD, s.dd);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.dd) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.E, adjustedOffset) < 0,
			0,
			{bD: newCol, L: s.L, N: s.N, E: adjustedOffset, db: newRow, dd: s.dd});
	};
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\t',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? 1 : 0;
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\n' + string2);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {ac: body, cU: intended, cY: marker, c4: order};
	});
var $elm$parser$Parser$Advanced$getCol = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.bD, s);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.cU, item.cY, item.c4, _List_Nil, item.ac);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.P;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.C);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.C);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.U));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.U));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 7:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.U));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.U));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return {M: childMatch.M - parentMatch.W, U: childMatch.U, O: childMatch.O - parentMatch.W, C: childMatch.C, ab: childMatch.ab - parentMatch.W, W: childMatch.W - parentMatch.W, P: childMatch.P};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return {
			M: parentMatch.M,
			U: A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
				parentMatch.U),
			O: parentMatch.O,
			C: parentMatch.C,
			ab: parentMatch.ab,
			W: parentMatch.W,
			P: parentMatch.P
		};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
	var match = _v4;
	return {
		M: match.M,
		U: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.U),
		O: match.O,
		C: match.C,
		ab: match.ab,
		W: match.W,
		P: match.P
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v2 = A2(
		$elm$core$List$sortBy,
		function (_v3) {
			var match = _v3;
			return match.O;
		},
		matches);
	if (!_v2.b) {
		return _List_Nil;
	} else {
		var first = _v2.a;
		var rest = _v2.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
					matchesTail);
			} else {
				var match = remaining.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.M, match.O) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = match,
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.O, match.O) < 0) && (_Utils_cmp(prevMatch.M, match.M) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = prevMatch,
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {D: index, aQ: match, c0: number, bx: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{cy: false, c$: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.bx;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (!_v1.$) {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.aQ;
		}
	} else {
		return match.aQ;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.bx;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.aQ;
		}
	} else {
		return match.aQ;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.bx;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.aQ;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.bx;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.aQ;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		M: 0,
		U: _List_Nil,
		O: 0,
		C: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		ab: 0,
		W: 0,
		P: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = {
			M: matchModel.M,
			U: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.C, _List_Nil, matchModel.U),
			O: matchModel.O,
			C: matchModel.C,
			ab: matchModel.ab,
			W: matchModel.W,
			P: matchModel.P
		};
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.M, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var _v4 = matchHead.P;
			if (!_v4.$) {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.M, matchHead.O) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.M, matchHead.O) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.M, matchHead.O, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.O > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.O, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens = F3(
	function (tokensL, tokensR, countL) {
		cleanAngleBracketTokens:
		while (true) {
			if (!tokensR.b) {
				return _List_Nil;
			} else {
				var hd1 = tokensR.a;
				var rest1 = tokensR.b;
				if (!tokensL.b) {
					if (countL > 1) {
						var $temp$tokensL = tokensL,
							$temp$tokensR = rest1,
							$temp$countL = countL - 1;
						tokensL = $temp$tokensL;
						tokensR = $temp$tokensR;
						countL = $temp$countL;
						continue cleanAngleBracketTokens;
					} else {
						if (countL === 1) {
							return A2(
								$elm$core$List$cons,
								hd1,
								A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, tokensL, rest1, countL - 1));
						} else {
							var $temp$tokensL = tokensL,
								$temp$tokensR = rest1,
								$temp$countL = 0;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						}
					}
				} else {
					var hd = tokensL.a;
					var rest = tokensL.b;
					if (_Utils_cmp(hd.D, hd1.D) < 0) {
						if (!countL) {
							return A2(
								$elm$core$List$cons,
								hd,
								A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, rest, tokensR, countL + 1));
						} else {
							var $temp$tokensL = rest,
								$temp$tokensR = tokensR,
								$temp$countL = countL + 1;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						}
					} else {
						if (countL > 1) {
							var $temp$tokensL = tokensL,
								$temp$tokensR = rest1,
								$temp$countL = countL - 1;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						} else {
							if (countL === 1) {
								return A2(
									$elm$core$List$cons,
									hd1,
									A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, tokensL, rest1, countL - 1));
							} else {
								var $temp$tokensL = tokensL,
									$temp$tokensR = rest1,
									$temp$countL = 0;
								tokensL = $temp$tokensL;
								tokensR = $temp$tokensR;
								countL = $temp$countL;
								continue cleanAngleBracketTokens;
							}
						}
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 4};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.bx;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{D: regMatch.D + backslashesLength, bm: 1, K: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.bx;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				D: regMatch.D + backslashesLength,
				bm: 1,
				K: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c) {
		case '!':
			return true;
		case '\"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000C':
			return true;
		case '\n':
			return true;
		case '\u000D':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u00A0':
			return true;
		case '\u2028':
			return true;
		case '\u2029':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (!mstring.$) {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.bx;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var leftFringeLength = function () {
				if (!maybeLeftFringe.$) {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var mLeftFringe = ((!(!regMatch.D)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.D - 1, regMatch.D, rawText)) : maybeLeftFringe;
			var backslashesLength = function () {
				if (!maybeBackslashes.$) {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((!mLeftFringe.$) && (mLeftFringe.a === '\\')) {
					return true;
				} else {
					return false;
				}
			}();
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			if ((delimiterLength <= 0) || ((_char === '_') && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.D + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						D: index,
						bm: delimiterLength,
						K: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{ba: lFringeRank, bf: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.bx;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				D: regMatch.D + backslashesLength,
				bm: $elm$core$String$length(backtick),
				K: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.bx;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{D: (regMatch.D + backslashesLength) - 1, bm: 2, K: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							D: regMatch.D,
							bm: $elm$core$String$length(regMatch.aQ),
							K: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.bx;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{D: regMatch.D + backslashesLength, bm: 1, K: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{D: (regMatch.D + backslashesLength) - 1, bm: 2, K: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							D: regMatch.D,
							bm: $elm$core$String$length(regMatch.aQ),
							K: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 3};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.bx;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{D: regMatch.D + backslashesLength, bm: 1, K: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.bx;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.D + backslashesLength) + 1) : (regMatch.D + backslashesLength);
		if (isEscaped) {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{
						D: index,
						bm: 1,
						K: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{D: index, bm: 2, K: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						D: index,
						bm: 1,
						K: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.bx;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{D: regMatch.D + backslashesLength, bm: length, K: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.D, rfirst.D) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.D;
				},
				$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText)),
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.D;
				},
				$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText)),
			0),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
								$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $elm$regex$Regex$contains = _Regex_contains;
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.aQ,
				$elm$url$Url$percentDecode(match.aQ));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.C) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				P: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.C,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.C)))
			})) : $elm$core$Result$Err(match);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.C : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.C,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bx;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var type_ = function () {
				var _v3 = matchModel.P;
				if (_v3.$ === 5) {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			var regexMatchLength = function () {
				if (!maybeRegexMatch.$) {
					var match = maybeRegexMatch.a.aQ;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_update(
					matchModel,
					{M: matchModel.M + regexMatchLength, P: type_}));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.bx;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						M: matchModel.M + $elm$core$String$length(regexMatch.aQ),
						P: function () {
							var _v5 = matchModel.P;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
			}
		} else {
			return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.M, testMatch.O) > 0) && (_Utils_cmp(match.M, testMatch.M) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2($elm$core$List$cons, match, remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.C) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				P: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.C,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.C)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 0;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.E, s);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{bD: 1, L: _List_Nil, N: 1, E: 0, db: 1, dd: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {bQ: htmlTag, bm: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.O, rawText));
		if (!parsed.$) {
			var htmlTag = parsed.a.bQ;
			var length = parsed.a.bm;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, 0, htmlTag);
			return $elm$core$Maybe$Just(
				{D: match.O, bm: length, K: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.K;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.bm - 1, closeToken.bm);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.bm, closeToken.bm);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.K;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.K;
		if (_v0.$ === 7) {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.K;
			if (_v1.$ === 7) {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.ba, open.bf) || _Utils_eq(close.ba, close.bf)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.bm + openToken.bm))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.bm)) && (!A2($elm$core$Basics$modBy, 3, openToken.bm)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = openToken.K;
			if (_v1.$ === 9) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, openToken.bm - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, openToken.bm);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v0.a;
		var openTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = closeToken.K;
			if (_v5.$ === 9) {
				if (!_v5.a) {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, closeToken.bm - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, closeToken.bm);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v4.a;
		var closeTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {M: token.D + token.bm, U: _List_Nil, O: token.D, C: '', ab: 0, W: 0, P: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F2(
	function (remaining, matches) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.K;
				if (_v1.$ === 8) {
					var $temp$remaining = tokensTail,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches);
					remaining = $temp$remaining;
					matches = $temp$matches;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$matches = matches;
					remaining = $temp$remaining;
					matches = $temp$matches;
					continue lineBreakTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.D, match.M) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v44) {
		var openToken = _v44.a;
		var remainTokens = _v44.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 1) {
			var tempMatch = result.a;
			if (escaped === 1) {
				var _v47 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (!_v47.$) {
					var newToken = _v47.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v36 = token.K;
				switch (_v36.$) {
					case 0:
						var _v37 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (!_v37.$) {
							var code = _v37.a;
							var _v38 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v38.a;
							var newMatches = _v38.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 5:
						var isEscaped = _v36.a;
						var isAngleBracketOpen = function (_v43) {
							var meaning = _v43.K;
							if (meaning.$ === 4) {
								return true;
							} else {
								return false;
							}
						};
						var _v39 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (!_v39.$) {
							var found = _v39.a;
							var _v40 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (!_v40.$) {
								var _v41 = _v40.a;
								var newTokens = _v41.a;
								var newMatches = _v41.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v32) {
		var openToken = _v32.a;
		var remainTokens = _v32.c;
		var updatedOpenToken = function () {
			var _v33 = openToken.K;
			if ((!_v33.$) && (!_v33.a)) {
				var _v34 = _v33.a;
				return _Utils_update(
					openToken,
					{D: openToken.D + 1, bm: openToken.bm - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v27 = token.K;
				if (_v27.$ === 7) {
					var _char = _v27.a;
					var leftFringeRank = _v27.b.ba;
					var rightFringeRank = _v27.b.bf;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((_char !== '_') || (rightFringeRank === 1))) {
							var _v28 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v28.$) {
								var found = _v28.a;
								var _v29 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v29.a;
								var match = _v29.b;
								var newTokens = _v29.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v30 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v30.$) {
								var found = _v30.a;
								var _v31 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v31.a;
								var match = _v31.b;
								var newTokens = _v31.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v25) {
		var openToken = _v25.a;
		var innerTokens = _v25.b;
		var remainTokens = _v25.c;
		var remainLength = openToken.bm - closeToken.bm;
		var updt = (!remainLength) ? {a8: closeToken, aV: openToken, be: remainTokens, bj: tokensTail} : ((remainLength > 0) ? {
			a8: closeToken,
			aV: _Utils_update(
				openToken,
				{D: openToken.D + remainLength, bm: closeToken.bm}),
			be: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{bm: remainLength}),
				remainTokens),
			bj: tokensTail
		} : {
			a8: _Utils_update(
				closeToken,
				{bm: openToken.bm}),
			aV: openToken,
			be: remainTokens,
			bj: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{D: closeToken.D + openToken.bm, bm: -remainLength}),
				tokensTail)
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.aV.bm),
			updt.aV,
			updt.a8,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.bj, match, updt.be);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v23 = token.K;
				if (_v23.$ === 6) {
					var isOpen = _v23.a;
					var htmlModel = _v23.b;
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
							token,
							$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
						matches),
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v18 = token.K;
				if (_v18.$ === 3) {
					var _v19 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (!_v19.$) {
						var found = _v19.a;
						var _v20 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (!_v20.$) {
							var _v21 = _v20.a;
							var x = _v21.a;
							var newMatches = _v21.b;
							var newTokens = _v21.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
		var openToken = _v8.a;
		var innerTokens = _v8.b;
		var remainTokens = _v8.c;
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var remainText = A2($elm$core$String$dropLeft, closeToken.D + 1, rawText);
		var inactivateLinkOpenToken = function (token) {
			var _v16 = token.K;
			if (_v16.$ === 1) {
				return _Utils_update(
					token,
					{
						K: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
					});
			} else {
				return token;
			}
		};
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var _v9 = openToken.K;
		switch (_v9.$) {
			case 2:
				var tempMatch = findTempMatch(false);
				var _v10 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v10.$ === 1) {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v10.a;
					var _v11 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (!_v11.$) {
						var matches = _v11.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 1:
				if (!_v9.a) {
					var _v12 = _v9.a;
					var tempMatch = findTempMatch(true);
					var _v13 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v13.$ === 1) {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v13.a;
						var _v14 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (!_v14.$) {
							var matches = _v14.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v15 = _v9.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					matches);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v5 = token.K;
				if (_v5.$ === 9) {
					var _v6 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (!_v6.$) {
						var content = _v6.a;
						var _v7 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v7.a;
						var newMatches = _v7.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v1) {
		var openToken = _v1.a;
		var remainTokens = _v1.c;
		var updatedOpenToken = function () {
			var _v2 = openToken.K;
			if ((_v2.$ === 9) && (!_v2.a)) {
				var _v3 = _v2.a;
				return _Utils_update(
					openToken,
					{D: openToken.D + 1, bm: openToken.bm - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.D + openToken.bm;
		var textEnd = closeToken.D;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var start = openToken.D;
		var end = closeToken.D + closeToken.bm;
		var match = {M: end, U: _List_Nil, O: start, C: text, ab: textEnd, W: textStart, P: type_};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return {M: end, U: matches, O: start, C: text, ab: textEnd, W: textStart, P: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\\'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {a4: alignment, aI: headerCell};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				headersWithAlignment(headers)) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (!_v1.$) {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {ac: body, c: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.bV;
	if (!_v0) {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (c !== '`') && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \'`\''));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {a6: '`', bV: 0, bi: $dillonkearns$elm_markdown$Parser$Token$backtick};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.bi)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter.a6))));
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {a6: '~', bV: 1, bi: $dillonkearns$elm_markdown$Parser$Token$tilde};
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
			$elm$parser$Parser$Advanced$succeed(0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {a7: character, bk: indent, bm: length};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(' ');
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $elm$parser$Parser$Advanced$getSource = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.dd, s);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.bm, fence.a7))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.bk)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.a7),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	dropTrailingHashes:
	while (true) {
		if (A2($elm$core$String$endsWith, '#', headingString)) {
			var $temp$headingString = A2($elm$core$String$dropRight, 1, headingString);
			headingString = $temp$headingString;
			continue dropTrailingHashes;
		} else {
			return headingString;
		}
	}
};
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(''),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
								$elm$core$String$trim(headingText));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.E, s.db, s.bD, s.dd);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.L)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.E, newOffset) < 0,
			0,
			{bD: newCol, L: s.L, N: s.N, E: newOffset, db: newRow, dd: s.dd});
	};
};
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {bD: col, L: context, db: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {bD: s.bD, L: newContext, N: s.N, E: s.E, db: s.db, dd: s.dd};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.db, s0.bD, context),
						s0.L),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.L, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\u000D':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\"',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\n\n', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\'',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{cE: destination, I: title});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(0),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar('-'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('*'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('_')
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, '='),
								A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, '-')
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\n'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return c === ':';
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return c === '-';
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return c === ':';
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just(2);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.co;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						b7: delimiterText,
						co: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0) {
			case 0:
				return A2($elm$core$List$take, expectedLength, row);
			case 1:
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok(0);
		case 2:
			return $elm$core$Result$Ok(1);
		case 3:
			return $elm$core$Result$Ok(2);
		case 4:
			return $elm$core$Result$Ok(3);
		case 5:
			return $elm$core$Result$Ok(4);
		case 6:
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 2};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 0:
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 1:
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(2),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F2(
		function (listmarker, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 0:
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						ac: body,
						cY: listmarker,
						Q: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				case 1:
					var body = unparsedListItem.a;
					return {ac: body, cY: listmarker, Q: $elm$core$Maybe$Nothing};
				default:
					return {ac: '', cY: listmarker, Q: $elm$core$Maybe$Nothing};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A2(parseListItem, listmarker, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 0:
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v106 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (!_v106.$) {
					var childrenAsBlocks = _v106.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v106.a;
					return $elm$core$Result$Err(err);
				}
			case 1:
				var innerText = node.a;
				var _v107 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (!_v107.$) {
					var value = _v107.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v107.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 2:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 3:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 4:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v91 = state.A;
	_v91$5:
	while (true) {
		if (_v91.b) {
			switch (_v91.a.$) {
				case 11:
					var body2 = _v91.a.a;
					var rest = _v91.b;
					var _v92 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (!_v92.$) {
						var value = _v92.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								z: _Utils_ap(state.z, value.z),
								A: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.A),
									rest)
							});
					} else {
						var error = _v92.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 3:
					var _v93 = _v91.a;
					var tight = _v93.a;
					var intended = _v93.b;
					var closeListItems = _v93.c;
					var openListItem = _v93.d;
					var rest = _v91.b;
					var _v94 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.ac);
					if (!_v94.$) {
						var value = _v94.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								z: _Utils_ap(state.z, value.z),
								A: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{ac: value.A, Q: openListItem.Q},
											closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v94.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 4:
					var _v99 = _v91.a;
					var tight = _v99.a;
					var intended = _v99.b;
					var marker = _v99.c;
					var order = _v99.d;
					var closeListItems = _v99.e;
					var openListItem = _v99.f;
					var rest = _v91.b;
					var _v100 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (!_v100.$) {
						var value = _v100.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								z: _Utils_ap(state.z, value.z),
								A: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.A, closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v100.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 10:
					if (_v91.b.b) {
						switch (_v91.b.a.$) {
							case 3:
								var _v95 = _v91.a;
								var _v96 = _v91.b;
								var _v97 = _v96.a;
								var tight = _v97.a;
								var intended = _v97.b;
								var closeListItems = _v97.c;
								var openListItem = _v97.d;
								var rest = _v96.b;
								var _v98 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.ac);
								if (!_v98.$) {
									var value = _v98.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: _Utils_ap(state.z, value.z),
											A: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{ac: value.A, Q: openListItem.Q},
														closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v98.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 4:
								var _v101 = _v91.a;
								var _v102 = _v91.b;
								var _v103 = _v102.a;
								var tight = _v103.a;
								var intended = _v103.b;
								var marker = _v103.c;
								var order = _v103.d;
								var closeListItems = _v103.e;
								var openListItem = _v103.f;
								var rest = _v102.b;
								var _v104 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (!_v104.$) {
									var value = _v104.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: _Utils_ap(state.z, value.z),
											A: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.A, closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v104.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v91$5;
						}
					} else {
						break _v91$5;
					}
				default:
					break _v91$5;
			}
		} else {
			break _v91$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v41 = _Utils_Tuple2(newRawBlock, state.A);
		_v41$13:
		while (true) {
			if (_v41.b.b) {
				switch (_v41.b.a.$) {
					case 5:
						if (_v41.a.$ === 5) {
							var block1 = _v41.a.a;
							var _v42 = _v41.b;
							var block2 = _v42.a.a;
							var rest = _v42.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									z: state.z,
									A: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												ac: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.ac, block1.ac),
												c: $elm$core$Maybe$Nothing
											}),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 6:
						switch (_v41.a.$) {
							case 6:
								var block1 = _v41.a.a;
								var _v43 = _v41.b;
								var block2 = _v43.a.a;
								var rest = _v43.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										z: state.z,
										A: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest)
									});
							case 10:
								var _v44 = _v41.a;
								var _v45 = _v41.b;
								var block = _v45.a.a;
								var rest = _v45.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										z: state.z,
										A: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\n')),
											rest)
									});
							default:
								break _v41$13;
						}
					case 11:
						var _v46 = _v41.b;
						var body2 = _v46.a.a;
						var rest = _v46.b;
						switch (newRawBlock.$) {
							case 11:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										z: state.z,
										A: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest)
									});
							case 1:
								var body1 = newRawBlock.a;
								var _v48 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v48.$) {
									var value = _v48.a;
									var _v49 = value.A;
									if (_v49.b) {
										var last = _v49.a;
										if ($dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph(last) && (!A2($elm$core$String$endsWith, '\n', body2))) {
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: state.z,
													A: A2(
														$elm$core$List$cons,
														$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
															A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
														rest)
												});
										} else {
											var _v50 = A2(
												$elm$parser$Parser$Advanced$run,
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
												body2);
											if (!_v50.$) {
												var value1 = _v50.a;
												return $elm$parser$Parser$Advanced$succeed(
													{
														z: _Utils_ap(state.z, value.z),
														A: A2(
															$elm$core$List$cons,
															newRawBlock,
															A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.A),
																rest))
													});
											} else {
												var e1 = _v50.a;
												return $elm$parser$Parser$Advanced$problem(
													$elm$parser$Parser$Problem(
														$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
											}
										}
									} else {
										var _v51 = A2(
											$elm$parser$Parser$Advanced$run,
											$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
											body2);
										if (!_v51.$) {
											var value1 = _v51.a;
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: _Utils_ap(state.z, value.z),
													A: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.A),
															rest))
												});
										} else {
											var e1 = _v51.a;
											return $elm$parser$Parser$Advanced$problem(
												$elm$parser$Parser$Problem(
													$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
										}
									}
								} else {
									var e = _v48.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 6:
								var body1 = newRawBlock.a;
								var _v52 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v52.$) {
									var value = _v52.a;
									var _v53 = value.A;
									if (_v53.b && (_v53.a.$ === 1)) {
										return $elm$parser$Parser$Advanced$succeed(
											{
												z: state.z,
												A: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
														A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, ' ', body2, body1)),
													rest)
											});
									} else {
										var _v54 = A2(
											$elm$parser$Parser$Advanced$run,
											$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
											body2);
										if (!_v54.$) {
											var value1 = _v54.a;
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: _Utils_ap(state.z, value.z),
													A: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.A),
															rest))
												});
										} else {
											var e1 = _v54.a;
											return $elm$parser$Parser$Advanced$problem(
												$elm$parser$Parser$Problem(
													$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
										}
									}
								} else {
									var e = _v52.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								var _v55 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v55.$) {
									var value = _v55.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: _Utils_ap(state.z, value.z),
											A: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.A),
													rest))
										});
								} else {
									var e = _v55.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 3:
						var _v56 = _v41.b;
						var _v57 = _v56.a;
						var tight = _v57.a;
						var intended1 = _v57.b;
						var closeListItems2 = _v57.c;
						var openListItem2 = _v57.d;
						var rest = _v56.b;
						switch (newRawBlock.$) {
							case 3:
								var intended2 = newRawBlock.b;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.cY, openListItem1.cY)) {
									var _v59 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.ac);
									if (!_v59.$) {
										var value = _v59.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? $elm$parser$Parser$Advanced$succeed(
											{
												z: _Utils_ap(state.z, value.z),
												A: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{ac: value.A, Q: openListItem2.Q},
															closeListItems2),
														openListItem1),
													rest)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												z: _Utils_ap(state.z, value.z),
												A: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{ac: value.A, Q: openListItem2.Q},
															closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v59.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v60 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.ac);
									if (!_v60.$) {
										var value = _v60.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												z: _Utils_ap(state.z, value.z),
												A: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{ac: value.A, Q: openListItem2.Q},
																closeListItems2),
															openListItem1),
														rest))
											});
									} else {
										var e = _v60.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										z: state.z,
										A: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														ac: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem2.ac, body1)
													})),
											rest)
									});
							default:
								var _v61 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.ac);
								if (!_v61.$) {
									var value = _v61.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: _Utils_ap(state.z, value.z),
											A: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{ac: value.A, Q: openListItem2.Q},
															closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v61.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 4:
						var _v62 = _v41.b;
						var _v63 = _v62.a;
						var tight = _v63.a;
						var intended1 = _v63.b;
						var marker = _v63.c;
						var order = _v63.d;
						var closeListItems2 = _v63.e;
						var openListItem2 = _v63.f;
						var rest = _v62.b;
						switch (newRawBlock.$) {
							case 4:
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v65 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v65.$) {
										var value = _v65.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												z: _Utils_ap(state.z, value.z),
												A: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.A, closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v65.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v66 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v66.$) {
										var value = _v66.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												z: _Utils_ap(state.z, value.z),
												A: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.A, closeListItems2),
															openListItem2),
														rest))
											});
									} else {
										var e = _v66.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										z: state.z,
										A: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\n' + body1)),
											rest)
									});
							default:
								var _v67 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (!_v67.$) {
									var value = _v67.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.A) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: _Utils_ap(state.z, value.z),
											A: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.A, closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v67.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 1:
						switch (_v41.a.$) {
							case 1:
								var body1 = _v41.a.a;
								var _v68 = _v41.b;
								var body2 = _v68.a.a;
								var rest = _v68.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										z: state.z,
										A: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							case 13:
								if (!_v41.a.a) {
									var _v69 = _v41.a;
									var _v70 = _v69.a;
									var _v71 = _v41.b;
									var unparsedInlines = _v71.a.a;
									var rest = _v71.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: state.z,
											A: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest)
										});
								} else {
									var _v72 = _v41.a;
									var _v73 = _v72.a;
									var _v74 = _v41.b;
									var unparsedInlines = _v74.a.a;
									var rest = _v74.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: state.z,
											A: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest)
										});
								}
							case 9:
								var _v75 = _v41.a.a;
								var text = _v75.a;
								var alignments = _v75.b;
								var _v76 = _v41.b;
								var rawHeaders = _v76.a.a;
								var rest = _v76.b;
								var _v77 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (!_v77.$) {
									var headers = _v77.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: state.z,
											A: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest)
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											z: state.z,
											A: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', rawHeaders, text.b7)),
												rest)
										});
								}
							default:
								break _v41$13;
						}
					case 8:
						if (_v41.a.$ === 8) {
							var updatedTable = _v41.a.a;
							var _v78 = _v41.b;
							var rest = _v78.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									z: state.z,
									A: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 10:
						if (_v41.b.b.b) {
							switch (_v41.b.b.a.$) {
								case 4:
									var _v79 = _v41.b;
									var _v80 = _v79.a;
									var _v81 = _v79.b;
									var _v82 = _v81.a;
									var tight = _v82.a;
									var intended1 = _v82.b;
									var marker = _v82.c;
									var order = _v82.d;
									var closeListItems2 = _v82.e;
									var openListItem2 = _v82.f;
									var rest = _v81.b;
									var _v83 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v83.$) {
										var value = _v83.a;
										if (newRawBlock.$ === 4) {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: _Utils_ap(state.z, value.z),
													A: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.A, closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: _Utils_ap(state.z, value.z),
													A: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.A, closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v83.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 3:
									var _v85 = _v41.b;
									var _v86 = _v85.a;
									var _v87 = _v85.b;
									var _v88 = _v87.a;
									var tight = _v88.a;
									var intended1 = _v88.b;
									var closeListItems2 = _v88.c;
									var openListItem2 = _v88.d;
									var rest = _v87.b;
									var _v89 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.ac);
									if (!_v89.$) {
										var value = _v89.a;
										if (newRawBlock.$ === 3) {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: _Utils_ap(state.z, value.z),
													A: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{ac: value.A, Q: openListItem2.Q},
																closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													z: _Utils_ap(state.z, value.z),
													A: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{ac: value.A, Q: openListItem2.Q},
																		closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v89.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v41$13;
							}
						} else {
							break _v41$13;
						}
					default:
						break _v41$13;
				}
			} else {
				break _v41$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				z: state.z,
				A: A2($elm$core$List$cons, newRawBlock, state.A)
			});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v36) {
		var unparsedInlines = _v36;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v37) {
						var destination = _v37.cE;
						var title = _v37.I;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 6:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 1) {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v31 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (!_v31.$) {
					var newSoFar = _v31.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v31.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v27 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v27.$ === 1) {
		var e = _v27.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v27.a;
		var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v28.$ === 1) {
			var e = _v28.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v28.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 5) && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.A, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v26 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.z, rawBlock);
				switch (_v26.$) {
					case 1:
						var newParsedBlock = _v26.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 0:
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v26.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v24) {
				var label = _v24.aI;
				var alignment = _v24.a4;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {a4: alignment, aI: parsedHeaderLabel};
					},
					label);
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (!_v17.$) {
					var parsedLevel = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 1:
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var tight = rawBlock.a;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (!rawBlockTask.$) {
								if (!rawBlockTask.a) {
									return 1;
								} else {
									return 2;
								}
							} else {
								return 0;
							}
						}();
						var blocks = function () {
							var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{z: linkReferences, A: rawBlocks});
							if (!_v18.$) {
								var parsedBlocks = _v18.a;
								return parsedBlocks;
							} else {
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.Q, item.ac);
								},
								unparsedItems))));
			case 4:
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{z: linkReferences, A: rawBlocks});
					if (!_v20.$) {
						var parsedBlocks = _v20.a;
						return parsedBlocks;
					} else {
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 10:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 11:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 12:
				var rawBlocks = rawBlock.a;
				var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{z: linkReferences, A: rawBlocks});
				if (!_v21.$) {
					var parsedBlocks = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{ac: codeBlockBody, c: $elm$core$Maybe$Nothing}));
			case 8:
				var _v22 = rawBlock.a;
				var header = _v22.a;
				var rows = _v22.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 9:
				var _v23 = rawBlock.a;
				var text = _v23.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, text.b7)));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, raw)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, column);
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v3 = revStmts.A;
				_v3$6:
				while (true) {
					if (_v3.b) {
						switch (_v3.a.$) {
							case 1:
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 8:
								var table = _v3.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 3:
								var _v4 = _v3.a;
								var tight = _v4.a;
								var intended = _v4.b;
								var closeListItems = _v4.c;
								var openListItem = _v4.d;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												A: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	ac: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.ac, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												A: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																ac: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.ac, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v5) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 4:
								var _v10 = _v3.a;
								var tight = _v10.a;
								var intended = _v10.b;
								var marker = _v10.c;
								var order = _v10.d;
								var closeListItems = _v10.e;
								var openListItem = _v10.f;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												A: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												A: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v11) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 10:
								if (_v3.b.b) {
									switch (_v3.b.a.$) {
										case 3:
											var _v6 = _v3.a;
											var _v7 = _v3.b;
											var _v8 = _v7.a;
											var tight = _v8.a;
											var intended = _v8.b;
											var closeListItems = _v8.c;
											var openListItem = _v8.d;
											var rest = _v7.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															A: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				ac: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.ac, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															A: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			ac: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.ac, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.ac) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v9) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 4:
											var _v12 = _v3.a;
											var _v13 = _v3.b;
											var _v14 = _v13.a;
											var tight = _v14.a;
											var intended = _v14.b;
											var marker = _v14.c;
											var order = _v14.d;
											var closeListItems = _v14.e;
											var openListItem = _v14.f;
											var rest = _v13.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															A: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															A: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v15) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v3$6;
									}
								} else {
									break _v3$6;
								}
							default:
								break _v3$6;
						}
					} else {
						break _v3$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 1:
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
		case 0:
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (!_v1.$) {
				var parsedChildren = _v1.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v1.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 2:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 3:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 4:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{z: _List_Nil, A: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v40) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v39) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v38) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
};
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var blocks = _v4.b;
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 2:
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.aI;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 7:
			var body = block.a.ac;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 7:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 8:
				return text + ' ';
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 3:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v12.$) {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.cN(
								{
									cA: children,
									cW: level,
									c8: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.c6,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.dr(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a === 1) && (_v5.b.$ === 5)) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 2:
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.c5,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a === 1) && (_v8.b.$ === 5)) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.cB(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.dp));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cx,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var label = _v11.aI;
							var alignment = _v11.a4;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.dm(
							$elm$core$List$singleton(
								renderer.$7(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.dn, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.dk(r)
						]);
				};
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.a4;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.$7,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.dl,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.dj(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.cP,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.dh,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cH,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 5:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.dg,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.cR(
							{
								bz: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								dd: src,
								I: title
							})));
			case 7:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.C(string)));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.cC(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.cX,
									{cE: destination, I: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.cM));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $author$project$MarkdownRender$alignAttr = function (maybeAlign) {
	if (!maybeAlign.$) {
		switch (maybeAlign.a) {
			case 0:
				var _v1 = maybeAlign.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$align('left')
					]);
			case 2:
				var _v2 = maybeAlign.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$align('center')
					]);
			default:
				var _v3 = maybeAlign.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$align('right')
					]);
		}
	} else {
		return _List_Nil;
	}
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.bo;
				var value = _v0.cp;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v4) {
			var rawDecoder = _v4;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (_v0, _v1, _v2) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $author$project$MarkdownRender$siteRenderer = {
	cx: $elm$html$Html$blockquote(_List_Nil),
	cB: function (_v0) {
		var body = _v0.ac;
		var language = _v0.c;
		var classes = function () {
			if (!language.$) {
				var lang = language.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + lang)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	cC: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	cH: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	cM: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	cN: function (_v2) {
		var level = _v2.cW;
		var children = _v2.cA;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	cP: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	cR: function (image) {
		return A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(image.dd),
					$elm$html$Html$Attributes$alt(image.bz),
					$elm$html$Html$Attributes$title(
					A2($elm$core$Maybe$withDefault, image.bz, image.I))
				]),
			_List_Nil);
	},
	cX: F2(
		function (_v4, children) {
			var title = _v4.I;
			var destination = _v4.cE;
			var external = A2($elm$core$String$startsWith, 'http://', destination) || A2($elm$core$String$startsWith, 'https://', destination);
			var base = _List_fromArray(
				[
					$elm$html$Html$Attributes$href(destination),
					$elm$html$Html$Attributes$title(
					A2($elm$core$Maybe$withDefault, destination, title))
				]);
			var attrs = external ? _Utils_ap(
				base,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						A2($elm$html$Html$Attributes$attribute, 'rel', 'noopener noreferrer')
					])) : base;
			return A2($elm$html$Html$a, attrs, children);
		}),
	c5: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$start(startingIndex)
					]),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	c6: $elm$html$Html$p(_List_Nil),
	dg: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	dh: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	dj: $elm$html$Html$table(_List_Nil),
	dk: $elm$html$Html$tbody(_List_Nil),
	dl: F2(
		function (maybeAlign, children) {
			return A2(
				$elm$html$Html$td,
				$author$project$MarkdownRender$alignAttr(maybeAlign),
				children);
		}),
	dm: $elm$html$Html$thead(_List_Nil),
	dn: F2(
		function (maybeAlign, children) {
			return A2(
				$elm$html$Html$th,
				$author$project$MarkdownRender$alignAttr(maybeAlign),
				children);
		}),
	$7: $elm$html$Html$tr(_List_Nil),
	C: $elm$html$Html$text,
	dp: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	dr: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $author$project$MarkdownRender$view = function (markdown) {
	var _v0 = $dillonkearns$elm_markdown$Markdown$Parser$parse(markdown);
	if (_v0.$ === 1) {
		var deadEnds = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('weekly-signal-md weekly-signal-md-error')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Could not parse markdown.')
						])),
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds)))
						]))
				]));
	} else {
		var blocks = _v0.a;
		var _v1 = A2($dillonkearns$elm_markdown$Markdown$Renderer$render, $author$project$MarkdownRender$siteRenderer, blocks);
		if (_v1.$ === 1) {
			var err = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('weekly-signal-md weekly-signal-md-error')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(err)
							]))
					]));
		} else {
			var html = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('weekly-signal-md')
					]),
				html);
		}
	}
};
var $author$project$Pages$SignalDetail$view = function (maybeSignal) {
	if (maybeSignal.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Signal not found')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('That weekly signal does not exist.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/signals/'),
							$elm$html$Html$Attributes$title('All signals')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('← Signals')
						]))
				]));
	} else {
		var signal = maybeSignal.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('weekly-signal-detail')
				]),
			_List_fromArray(
				[
					$author$project$MarkdownRender$view(signal.ac),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/signals/'),
									$elm$html$Html$Attributes$title('All signals')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('← All signals')
								])),
							$elm$html$Html$text(' · '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/codex/'),
									$elm$html$Html$Attributes$title('Codex')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Codex')
								]))
						]))
				]));
	}
};
var $author$project$Pages$Signals$shortTitle = function (t) {
	return A2($elm$core$String$startsWith, 'Five Signal Fridays: ', t) ? A2(
		$elm$core$String$dropLeft,
		$elm$core$String$length('Five Signal Fridays: '),
		t) : t;
};
var $author$project$Pages$Signals$signalToTuple = function (s) {
	return _Utils_Tuple2(
		'/signals/' + (s.f + '/'),
		'W' + ($elm$core$String$fromInt(s.al) + (' · ' + (s.F + (' — ' + $author$project$Pages$Signals$shortTitle(s.I))))));
};
var $author$project$Pages$Signals$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Signals')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Five 👋🏻 Signal Fridays — short, opinionated lines from the week’s noise. Native on mpj.io; mirrored to Substack when useful.')
				])),
			$author$project$Shared$viewBreak,
			A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('All weeks')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$isEmpty($author$project$Data$WeeklySignals$allWeeklySignals) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('No signals published yet.')
						]))
				]) : $author$project$Shared$viewList(
				A2($elm$core$List$map, $author$project$Pages$Signals$signalToTuple, $author$project$Data$WeeklySignals$allWeeklySignals)))
		]));
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$Pages$TagDetail$toLowerFirst = function (str) {
	var _v0 = $elm$core$String$uncons(str);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var c = _v1.a;
		var rest = _v1.b;
		return _Utils_ap(
			$elm$core$String$fromChar(
				$elm$core$Char$toLower(c)),
			rest);
	} else {
		return '';
	}
};
var $author$project$Pages$TagDetail$viewActivity = F2(
	function (index, activity) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index) + ' activity-item')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(activity)
				]));
	});
var $author$project$Shared$viewAuthority = function (raw) {
	var parts = A2(
		$elm$core$List$filter,
		function (part) {
			return part !== '';
		},
		A2(
			$elm$core$List$map,
			$elm$core$String$trim,
			A2($elm$core$String$split, '|', raw)));
	if (!parts.b) {
		return $elm$html$Html$text('');
	} else {
		if (!parts.b.b) {
			var only = parts.a;
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('authority')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(only)
					]));
		} else {
			var lead = parts.a;
			var credentials = parts.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('authority')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('authority-lead')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(lead)
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('authority-credentials')
							]),
						A2(
							$elm$core$List$map,
							function (item) {
								return A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(item)
										]));
							},
							credentials))
					]));
		}
	}
};
var $author$project$Pages$TagDetail$viewFaq = function (faq) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('faq-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(faq.b)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(faq.a)
					]))
			]));
};
var $author$project$Pages$TagDetail$viewPlanStep = F2(
	function (index, step) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('plan-step')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(index + 1) + '.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(step)
						]))
				]));
	});
var $author$project$Pages$TagDetail$view = function (maybePage) {
	if (!maybePage.$) {
		var page = maybePage.a;
		var currentTag = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (t) {
					return _Utils_eq(t.f, page.f);
				},
				$author$project$Data$Tags$allTags));
		var relatedTags = function () {
			if (!currentTag.$) {
				var tag = currentTag.a;
				return A2(
					$elm$core$List$take,
					4,
					A2(
						$elm$core$List$filter,
						function (t) {
							return _Utils_eq(t.y, tag.y) && (!_Utils_eq(t.f, tag.f));
						},
						$author$project$Data$Tags$allTags));
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tag-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumbs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Home')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('separator')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' › ')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/services')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Services')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('separator')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' › ')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('current')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										page.k,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.k;
											},
											currentTag)))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-hero-problem')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(page.k)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lead')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Are you '),
									$elm$html$Html$text(
									$author$project$Pages$TagDetail$toLowerFirst(page.l.s)),
									$elm$html$Html$text(' And are you '),
									$elm$html$Html$text(
									$author$project$Pages$TagDetail$toLowerFirst(page.l.w.t)),
									$elm$html$Html$text('?')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('problem-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(page.l.w.q)
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(page.l.w.u)
												]))
										]))
								]))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-guide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('empathy')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(page.l.r.p)
								])),
							$author$project$Shared$viewAuthority(page.l.r.m)
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-plan')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Our Path Forward')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('plan-steps')
								]),
							A2($elm$core$List$indexedMap, $author$project$Pages$TagDetail$viewPlanStep, page.l.v))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-cta')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cta-button'),
									$elm$html$Html$Attributes$href('https://go.mpj.io/schedule')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(page.l.o)
								]))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hands-on Mentoring')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To bridge the gap between where you are and where you want to be, we can focus on:')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activities-grid')
						]),
					A2($elm$core$List$indexedMap, $author$project$Pages$TagDetail$viewActivity, page.h)),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-success-failure')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('success-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(page.l.x)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('failure-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(page.l.n)
										]))
								]))
						])),
					$author$project$Shared$viewBreak,
					(!$elm$core$List$isEmpty(relatedTags)) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('related-services')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Related Strategic Services')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Explore more specialized guidance in ' + (A2(
										$elm$core$Maybe$withDefault,
										'this area',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.y;
											},
											currentTag)) + ':'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activities-grid')
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (i, t) {
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('/mentoring/' + t.f),
													$elm$html$Html$Attributes$class(
													$author$project$Shared$pickBorder(i) + ' activity-item deco-none'),
													$elm$html$Html$Attributes$title(t.k)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(t.k)
												]));
									}),
								relatedTags))
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('all-services-cta')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/services'),
									$elm$html$Html$Attributes$class('secondary-cta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Browse All 100+ Specialized Services →')
								]))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Frequently Asked Questions')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('faqs')
						]),
					A2($elm$core$List$map, $author$project$Pages$TagDetail$viewFaq, page.j)),
					$author$project$Shared$viewBreak,
					$author$project$Shared$viewRecentEvent
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Topic Not Found')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Sorry, we couldn\'t find the page you were looking for.')
						]))
				]));
	}
};
var $author$project$Pages$Writings$viewArticles = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2('https://com6.substack.com/p/growth-hack-your-career-a-journey', 'Growth Hack Your Career: A Journey Through 11 Heuristics'),
			_Utils_Tuple2('https://com6.substack.com/p/how-systems-shape-us-jobs-nations', 'How Systems Shape Us: Jobs, Nations, Religions & the Self'),
			_Utils_Tuple2('https://com6.substack.com/p/the-subtle-art-of-engineering-luck', 'The Subtle Art of Engineering Luck')
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Selected Articles')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('A selection of my newsletter posts and essays on technology, career growth, and systems thinking.')
						]))
				]),
			$author$project$Shared$viewList(data)));
}();
var $author$project$Pages$Writings$viewBlogs = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2('https://medium.com/@empeje/subscribe', 'Regular Writing on Tech, Wisdom & Philosophy—Medium'),
			_Utils_Tuple2('https://com6.substack.com', 'COM6: The Serial Dispatch from Abdu Códigos'),
			_Utils_Tuple2('https://www.codementor.io/@empeje#:~:text=Community%20Posts', 'Popular Blog on Codementor'),
			_Utils_Tuple2('https://formation.dev/blog/author/abdu-mappuji', 'Formation.dev: Blog Author Page'),
			_Utils_Tuple2('https://legacy.mpj.io', 'Legacy Blog (2018-2020)')
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Blogs')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('I write blogs on various platforms, here are links to places where I write tech stuff.')
						]))
				]),
			$author$project$Shared$viewList(data)));
}();
var $author$project$Pages$Writings$viewBooks = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2('https://leanpub.com/gitlabcheatsheet', 'GitLab Cheatsheet'),
			_Utils_Tuple2('https://leanpub.com/jump-swe', 'Jump Start Your Software Engineering Career'),
			_Utils_Tuple2('https://leanpub.com/c/kulkultech/qa-bootcamp', 'Quality Assurance and Test Automation with Java and Katalon Studio (Co-author)'),
			_Utils_Tuple2('https://leanpub.com/c/kulkultech/fullstackdevwithjavajs', 'Fullstack Software Development with Java & JavaScript (Co-author)')
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Books')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('I write books and guides on software engineering, test automation, and tools.')
						]))
				]),
			$author$project$Shared$viewList(data)));
}();
var $author$project$Pages$Writings$viewPublications = function () {
	var data = _List_fromArray(
		[
			_Utils_Tuple2('https://engj.org/index.php/ej/article/view/3432', '2020. Engineering Journal. Design of an Acoustic-Based Nondestructive Test (NDT) Instrument to Predict the Modulus of Elasticity of Wood'),
			_Utils_Tuple2('http://etd.repository.ugm.ac.id/home/detail_pencarian/111249', '2017. Undergraduate Thesis Universitas Gadjah Mada. Design and Implementation of Nondestructive Evaluation Instrument for Acoustics-based Prediction of Wood Modulus of Elasticity and a Method to Assess the Recorded Longitudinal Stress Wave'),
			_Utils_Tuple2('https://ieeexplore.ieee.org/document/7863250', '2016. International Conference on Information Technology and Electrical Engineering Yogyakarta. Study of Raspberry Pi 2 Quad-core Cortex-A7 CPU Cluster as a Mini Supercomputer'),
			_Utils_Tuple2('https://arxiv.org/abs/1612.08560', '2015. International Conference on Science and Technology Yogyakarta. PDM (Probes Distance Meter), Distance Measuring Instrument by Using Ultrasonic Propagation between Probes')
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Publications')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('I spent almost 5 years in college and it has a big influence on me. I learn how to learn solely for curiosity and it turned out resulting several research publications. Here are my past publications as I don\'t write any new research publications anymore.')
						]))
				]),
			$author$project$Shared$viewList(data)));
}();
var $author$project$Pages$Writings$viewVideo = function (youtubeLink) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('responsive-iframe-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$iframe,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$width(560),
						$elm$html$Html$Attributes$height(315),
						$elm$html$Html$Attributes$src(youtubeLink),
						$elm$html$Html$Attributes$title(''),
						A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
						A2($elm$html$Html$Attributes$attribute, 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'),
						A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', '')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Writings$view = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Works')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Blogs, publications, books, and written works.')
				])),
			$author$project$Shared$viewBreak,
			$author$project$Pages$Writings$viewVideo('https://www.youtube.com/embed/lFZ6e4Plfb4?si=ZproA6U2rNkDchlH&amp;start=14'),
			$author$project$Shared$viewBreak,
			$author$project$Pages$Writings$viewBlogs,
			$author$project$Shared$viewBreak,
			$author$project$Pages$Writings$viewArticles,
			$author$project$Shared$viewBreak,
			$author$project$Pages$Writings$viewBooks,
			$author$project$Shared$viewBreak,
			$author$project$Pages$Writings$viewPublications
		]));
var $author$project$Pages$ExpertWitness$toLowerFirst = function (str) {
	var _v0 = $elm$core$String$uncons(str);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var c = _v1.a;
		var rest = _v1.b;
		return _Utils_ap(
			$elm$core$String$fromChar(
				$elm$core$Char$toLower(c)),
			rest);
	} else {
		return '';
	}
};
var $author$project$Pages$ExpertWitness$viewActivity = F2(
	function (index, activity) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index) + ' activity-item')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(activity)
				]));
	});
var $author$project$Pages$ExpertWitness$viewFaq = function (faq) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('faq-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(faq.b)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(faq.a)
					]))
			]));
};
var $author$project$Pages$ExpertWitness$viewPlanStep = F2(
	function (index, step) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('plan-step')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(index + 1) + '.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(step)
						]))
				]));
	});
var $author$project$Pages$ExpertWitness$viewDetail = function (maybePage) {
	if (!maybePage.$) {
		var page = maybePage.a;
		var isEn = page.c === 'en';
		var rootLabel = isEn ? 'Expert Witness' : 'Saksi Ahli';
		var rootUrl = isEn ? '/expert-witness' : '/saksi-ahli';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('expert-witness-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumbs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Home')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('separator')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' › ')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(rootUrl)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(rootLabel)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('separator')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' › ')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('current')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(page.k)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-hero-problem')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(page.k)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hero-story-detail')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('story-para')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(page.l.w.q)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('story-para')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											(page.c === 'id') ? 'Apakah Anda ' : 'Are you '),
											$elm$html$Html$text(
											$author$project$Pages$ExpertWitness$toLowerFirst(page.l.s)),
											$elm$html$Html$text(
											(page.c === 'id') ? '? Dan apakah Anda ' : '? And are you '),
											$elm$html$Html$text(
											$author$project$Pages$ExpertWitness$toLowerFirst(page.l.w.t)),
											$elm$html$Html$text('?')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('philosophical-box')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(page.l.w.u)
										]))
								]))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-guide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('empathy')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(page.l.r.p)
								])),
							$author$project$Shared$viewAuthority(page.l.r.m)
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-plan')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									(page.c === 'id') ? 'Rencana Langkah Strategis' : 'The Strategic Path Forward')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('plan-steps')
								]),
							A2($elm$core$List$indexedMap, $author$project$Pages$ExpertWitness$viewPlanStep, page.l.v))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-cta')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cta-button'),
									$elm$html$Html$Attributes$href('https://go.mpj.io/schedule')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(page.l.o)
								]))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							(page.c === 'id') ? 'Cakupan Layanan Teknis' : 'Technical Service Scope')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activities-grid')
						]),
					A2($elm$core$List$indexedMap, $author$project$Pages$ExpertWitness$viewActivity, page.h)),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sb-success-failure')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('success-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											isEn ? 'Success' : 'Keberhasilan')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(page.l.x)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('failure-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											isEn ? 'Risk' : 'Risiko')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(page.l.n)
										]))
								]))
						])),
					$author$project$Shared$viewBreak,
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							(page.c === 'id') ? 'Pertanyaan yang Sering Diajukan' : 'Frequently Asked Questions')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('faqs thorough-faqs')
						]),
					A2($elm$core$List$map, $author$project$Pages$ExpertWitness$viewFaq, page.j)),
					$author$project$Shared$viewBreak,
					$author$project$Shared$viewRecentEvent
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Page Not Found')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Sorry, we couldn\'t find the specific expert witness service page.')
						]))
				]));
	}
};
var $author$project$Pages$ExpertWitness$SetRegion = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ExpertWitness$SetSearchQuery = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ExpertWitness$SetTopic = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pages$ExpertWitness$viewGeneralValueProp = function (isEn) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('value-prop-section subtle-value-prop')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						isEn ? 'The Bridge: CTO Depth + Legal Literacy' : 'Mengapa Memilih Abdu Mappuji?')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('value-prop-prose')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								$author$project$Shared$pickBorder(0))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										isEn ? 'Technical Authority: ' : 'Otoritas Teknis: ')
									])),
								$elm$html$Html$text(
								isEn ? 'With a decade of engineering experience at global scale-ups — Booking.com\'s FareHarbor, bol.com, Picnic and Delivery Hero\'s Glovo — plus two years hiring and managing engineers as Tech Lead at ErudiFi and Engineering Manager at Mekari, I provide a technical voice grounded in current practice rather than recollection. I hold an MS in Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, EU-accredited), the Program Profesi Insinyur in Informatics from Institut Teknologi Bandung — Indonesia\'s professional engineer qualification — and a BEng in Nuclear Engineering & Engineering Physics from Universitas Gadjah Mada. My peer-reviewed research in high-performance computing and my doctoral work in Mathematics and Explainable AI mean my opinions are traceable to published method, not assertion.' : 'Dengan satu dekade pengalaman engineering di scale-up global — Booking.com\'s FareHarbor, bol.com, Picnic dan Delivery Hero\'s Glovo — serta dua tahun memimpin engineer sebagai Tech Lead di ErudiFi dan Engineering Manager di Mekari, saya memberikan pandangan teknis yang berakar pada praktik terkini. Saya memegang MS Artificial Intelligence (Udacity Institute of AI & Technology, member college of Woolf, terakreditasi UE), Program Profesi Insinyur bidang Informatika dari Institut Teknologi Bandung, serta Sarjana Teknik Nuklir & Fisika Teknik dari Universitas Gadjah Mada. Riset saya di bidang high-performance computing dan penelitian doktoral saya di Matematika & Explainable AI memastikan pendapat saya dapat dilacak ke metode yang terpublikasi.')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								$author$project$Shared$pickBorder(1))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										isEn ? 'Legal Literacy: ' : 'Literasi Hukum: ')
									])),
								$elm$html$Html$text(
								isEn ? 'My current LLB(candidate) legal studies allow me to understand what a tribunal or court needs. I bridge the gap between \'code\' and \'evidence\', ensuring my reports are compliant with international standards like UK CPR 35 or Indonesian UU ITE requirements, making technical truth accessible to the bench.' : 'Studi hukum LLB(candidate) saya memungkinkan saya memahami apa yang dibutuhkan oleh tribunal atau pengadilan. Saya menjembatani celah antara \'kode\' dan \'alat bukti\', memastikan laporan saya sesuai dengan standar internasional maupun persyaratan UU ITE di Indonesia.')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								$author$project$Shared$pickBorder(2))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										isEn ? 'Bilingual Domain Focus: ' : 'Fokus Domain Bilingual: ')
									])),
								$elm$html$Html$text(
								isEn ? 'Specialized in the \'Algorithm Economy\'—including AI, Q-commerce, Logistics, and Ride-hailing. As a native Indonesian speaker based in Europe, I provide seamless bilingual support for cross-border disputes and international arbitration involving ASEAN and Western legal jurisdictions.' : 'Spesialisasi dalam \'Ekonomi Algoritma\'—termasuk AI, Q-commerce, Logistik, dan Ride-hailing. Sebagai penutur asli Bahasa Indonesia yang berdomisili di Eropa, saya memberikan dukungan bilingual yang mulus untuk sengketa lintas batas dan arbitrase internasional.')
							]))
					]))
			]));
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Pages$ExpertWitness$viewRegionFilter = F3(
	function (selectedRegion, index, region) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					_Utils_eq(
						selectedRegion,
						$elm$core$Maybe$Just(region)) ? 'filter-btn active' : 'filter-btn'),
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index + 5)),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$ExpertWitness$SetRegion(
						$elm$core$Maybe$Just(region)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$toUpper(region))
				]));
	});
var $author$project$Pages$ExpertWitness$viewRootHero = function (isEn) {
	var count = $author$project$Data$LegalPages$countByLanguage(
		isEn ? 'en' : 'id');
	var baseCount = ((count / 10) | 0) * 10;
	var h1Text = isEn ? ('Expert Witness for IT, AI, and ' + ($elm$core$String$fromInt(baseCount) + '+ Specialized Use Cases')) : ('Saksi Ahli Teknologi Informasi & ' + ($elm$core$String$fromInt(baseCount) + '+ Kasus Penggunaan'));
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('root-legal-hero elegant-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hero-main-claim')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('elegant-h1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(h1Text)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hero-subtext')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								isEn ? 'A decade of engineering across Booking.com, bol.com, Picnic and Delivery Hero\'s Glovo, combined with an MS in Artificial Intelligence, published HPC research, doctoral work in Explainable AI, and LLB(candidate) legal scholarship.' : 'Satu dekade pengalaman engineering di Booking.com, bol.com, Picnic dan Delivery Hero\'s Glovo, dipadukan dengan MS Artificial Intelligence, riset HPC terpublikasi, penelitian doktoral di bidang Explainable AI, dan landasan hukum LLB(candidate).')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('soft-sell-status')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('status-indicator')
							]),
						_List_Nil),
						$elm$html$Html$text(
						isEn ? 'Accepting expert instructions for UK, US, EU, and ASEAN jurisdictions.' : 'Tersedia untuk penugasan saksi ahli di yurisdiksi Indonesia dan Internasional.')
					]))
			]));
};
var $author$project$Pages$ExpertWitness$formatTopic = function (topic) {
	switch (topic) {
		case 'ai':
			return 'AI';
		case 'ml':
			return 'Machine Learning';
		case 'qcommerce':
			return 'Q-Commerce';
		case 'ecommerce':
			return 'E-Commerce';
		case 'ridehailing':
			return 'Ride-Hailing';
		case 'cybersecurity':
			return 'Cyber';
		case 'logistics':
			return 'Logistics';
		case 'software':
			return 'Software Engineering';
		case 'testing':
			return 'Software Testing';
		case 'systems':
			return 'System Engineering';
		case 'hpc':
			return 'HPC';
		case 'algorithms':
			return 'Algorithms';
		default:
			return _Utils_ap(
				$elm$core$String$toUpper(
					A2($elm$core$String$left, 1, topic)),
				A2($elm$core$String$dropLeft, 1, topic));
	}
};
var $author$project$Pages$ExpertWitness$viewTopicFilter = F3(
	function (selectedTopic, index, topic) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					_Utils_eq(
						selectedTopic,
						$elm$core$Maybe$Just(topic)) ? 'filter-btn active' : 'filter-btn'),
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index + 1)),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$ExpertWitness$SetTopic(
						$elm$core$Maybe$Just(topic)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Pages$ExpertWitness$formatTopic(topic))
				]));
	});
var $author$project$Pages$ExpertWitness$viewCatalogItem = F3(
	function (lang, index, page) {
		var root = (lang === 'en') ? '/expert-witness/' : '/saksi-ahli/';
		var url = root + (page.e + ('/' + (page.g + ('/' + page.d))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Shared$pickBorder(index) + ' service-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(url),
							$elm$html$Html$Attributes$title(page.k),
							$elm$html$Html$Attributes$class('deco-none')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(page.k)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('view-details')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									(lang === 'en') ? 'View Expert Profile →' : 'Lihat Profil Ahli →')
								]))
						]))
				]));
	});
var $author$project$Pages$ExpertWitness$viewTopicGroup = F2(
	function (lang, _v0) {
		var topicCode = _v0.a;
		var pages = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('category-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('category-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$ExpertWitness$formatTopic(topicCode))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('services-grid')
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Pages$ExpertWitness$viewCatalogItem(lang),
						pages))
				]));
	});
var $author$project$Pages$ExpertWitness$viewIndex = F2(
	function (lang, model) {
		var langPages = A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(p.c, lang);
			},
			$author$project$Data$LegalPages$allPages);
		var topics = $elm$core$List$sort(
			A3(
				$elm$core$List$foldl,
				F2(
					function (t, acc) {
						return A2($elm$core$List$member, t, acc) ? acc : A2($elm$core$List$cons, t, acc);
					}),
				_List_Nil,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.g;
					},
					langPages)));
		var isEn = lang === 'en';
		var regions = isEn ? $elm$core$List$sort(
			A3(
				$elm$core$List$foldl,
				F2(
					function (r, acc) {
						return A2($elm$core$List$member, r, acc) ? acc : A2($elm$core$List$cons, r, acc);
					}),
				_List_Nil,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.e;
					},
					langPages))) : _List_Nil;
		var titleText = isEn ? 'Technical Expert Witness' : 'Saksi Ahli Teknologi Informasi';
		var filteredPages = A2(
			$elm$core$List$filter,
			function (page) {
				return function () {
					var _v2 = model.bt;
					if (!_v2.$) {
						var r = _v2.a;
						return _Utils_eq(page.e, r);
					} else {
						return true;
					}
				}() && (function () {
					var _v3 = model.bu;
					if (!_v3.$) {
						var t = _v3.a;
						return _Utils_eq(page.g, t);
					} else {
						return true;
					}
				}() && function () {
					var q = $elm$core$String$toLower(model.ay);
					return A2(
						$elm$core$String$contains,
						q,
						$elm$core$String$toLower(page.k)) || A2(
						$elm$core$String$contains,
						q,
						$elm$core$String$toLower(page.i));
				}());
			},
			langPages);
		var groupedByTopic = A2(
			$elm$core$List$filter,
			function (_v1) {
				var pages = _v1.b;
				return !$elm$core$List$isEmpty(pages);
			},
			A2(
				$elm$core$List$map,
				function (t) {
					return _Utils_Tuple2(
						t,
						A2(
							$elm$core$List$filter,
							function (page) {
								return _Utils_eq(page.g, t);
							},
							filteredPages));
				},
				A2(
					$elm$core$List$filter,
					function (t) {
						var _v0 = model.bu;
						if (!_v0.$) {
							var selected = _v0.a;
							return _Utils_eq(t, selected);
						} else {
							return true;
						}
					},
					topics)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('services-catalog')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumbs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Home')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('separator')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' › ')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('current')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(titleText)
								]))
						])),
					$author$project$Pages$ExpertWitness$viewRootHero(isEn),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('catalog-controls')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('search-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$placeholder(
											isEn ? 'Search expert services...' : 'Cari layanan ahli...'),
											$elm$html$Html$Attributes$value(model.ay),
											$elm$html$Html$Events$onInput($author$project$Pages$ExpertWitness$SetSearchQuery),
											$elm$html$Html$Attributes$class('search-input')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('category-filters-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('category-filters')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													_Utils_eq(model.bu, $elm$core$Maybe$Nothing) ? 'filter-btn active' : 'filter-btn'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$ExpertWitness$SetTopic($elm$core$Maybe$Nothing)),
													$elm$html$Html$Attributes$class('red-border')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													isEn ? 'All Topics' : 'Semua Topik')
												])),
										A2(
											$elm$core$List$indexedMap,
											$author$project$Pages$ExpertWitness$viewTopicFilter(model.bu),
											topics))),
									isEn ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('category-filters secondary-filters')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													_Utils_eq(model.bt, $elm$core$Maybe$Nothing) ? 'filter-btn active' : 'filter-btn'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$ExpertWitness$SetRegion($elm$core$Maybe$Nothing)),
													$elm$html$Html$Attributes$class('blue-border')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('All Regions')
												])),
										A2(
											$elm$core$List$indexedMap,
											$author$project$Pages$ExpertWitness$viewRegionFilter(model.bt),
											regions))) : $elm$html$Html$text('')
								]))
						])),
					$author$project$Shared$viewBreak,
					$elm$core$List$isEmpty(filteredPages) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-results')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							isEn ? 'No matching expert services found.' : 'Layanan ahli tidak ditemukan.')
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('categories-stack')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Pages$ExpertWitness$viewTopicGroup(lang),
						groupedByTopic)),
					$author$project$Shared$viewBreak,
					$author$project$Pages$ExpertWitness$viewGeneralValueProp(isEn),
					$author$project$Shared$viewRecentEvent
				]));
	});
var $author$project$Main$viewPage = function (model) {
	var _v0 = model.aq;
	switch (_v0.$) {
		case 0:
			return $author$project$Pages$Home$view;
		case 1:
			return $author$project$Pages$Appearances$view;
		case 2:
			return $author$project$Pages$Credentials$view;
		case 3:
			return $author$project$Pages$Outcomes$view;
		case 6:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$CodexMsg,
				$author$project$Pages$Codex$view(model.aN));
		case 7:
			return $author$project$Pages$Signals$view;
		case 8:
			var slug = _v0.a;
			return $author$project$Pages$SignalDetail$view(
				$author$project$Data$WeeklySignals$getBySlug(slug));
		case 4:
			return $author$project$Pages$HireMe$view;
		case 5:
			return $author$project$Pages$Writings$view;
		case 9:
			return $author$project$Pages$Entrepreneurship$view;
		case 10:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$OffersMsg,
				$author$project$Pages$Offers$view(model.aU));
		case 11:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$MentorCruiseMsg,
				$author$project$Pages$MentorCruise$view(model.aS));
		case 12:
			return $author$project$Pages$FindMeIn$view;
		case 13:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$MentorShMsg,
				$author$project$Pages$MentorSh$view(model.aT));
		case 14:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$MeetAProMsg,
				$author$project$Pages$MeetAPro$view(model.aR));
		case 15:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ServicesMsg,
				$author$project$Pages$Services$view(model.az));
		case 16:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ExpertWitnessMsg,
				A2($author$project$Pages$ExpertWitness$viewIndex, 'en', model.ar));
		case 17:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ExpertWitnessMsg,
				A2($author$project$Pages$ExpertWitness$viewIndex, 'id', model.ar));
		case 18:
			var lang = _v0.a;
			var region = _v0.b;
			var topic = _v0.c;
			var forum = _v0.d;
			return $author$project$Pages$ExpertWitness$viewDetail(
				A4($author$project$Data$LegalPages$getByHierarchy, lang, region, topic, forum));
		case 19:
			var slug = _v0.a;
			return $author$project$Pages$TagDetail$view(
				$author$project$Data$SeoPages$getBySlug(slug));
		case 20:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$PortfolioBetaMsg,
				$author$project$Pages$PortfolioBeta$view(model.aY));
		case 21:
			return A2(
				$elm$html$Html$map,
				$author$project$Main$ReferralsBetaMsg,
				$author$project$Pages$ReferralsBeta$view(model.a_));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('404 - Page Not Found')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The page you\'re looking for doesn\'t exist.')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Go back home')
							]))
					]));
	}
};
var $author$project$Main$view = function (model) {
	var asSeenAt = function () {
		var _v0 = model.aq;
		if (!_v0.$) {
			return _List_fromArray(
				[$author$project$Pages$Home$viewAsSeenAt]);
		} else {
			return _List_Nil;
		}
	}();
	return {
		ac: _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container content')
						]),
					_List_fromArray(
						[
							$author$project$Shared$viewNav(
							$author$project$Main$routeToString(model.aq)),
							$author$project$Main$viewPage(model)
						]))
				]),
			_Utils_ap(
				asSeenAt,
				_List_fromArray(
					[
						$author$project$Shared$viewFooter(model.bh)
					]))),
		I: $author$project$Main$getPageTitle(model.aq)
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		cT: $author$project$Main$init,
		c1: $author$project$Main$UrlChanged,
		c2: $author$project$Main$LinkClicked,
		di: $elm$core$Basics$always($elm$core$Platform$Sub$none),
		ds: $author$project$Main$update,
		dt: $author$project$Main$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$succeed(0))(0)}});}(this));